import {matchesAppleMirrorReceiptOrigin,confirmAppleMirrorReceipt} from '@/lib/appleMirrorReceipt';
import {MirrorFileEditLauncher} from '@/components/mirror/MirrorFileEditLauncher';
import {ConnectedFileEditRecoveryPanel} from '@/components/mirror/ConnectedFileEditRecoveryPanel';
import {prepareMirrorFileEditOrigin,mirrorFileEditReceiptReference,type MirrorFileEditOrigin,type MirrorFileEditReceiptReference} from '@/lib/mirrorFileEditOrigin';
import {confirmMirrorFileEditReceipt} from '@/lib/confirmMirrorFileEditReceipt';
import {mirrorFileEditTurnTargeted} from '../../supabase/functions/_shared/mirrorFileEditIntent';
import {MirrorWindsorReportLauncher} from '@/components/mirror/MirrorWindsorReportLauncher';
import {prepareMirrorWindsorReportOrigin,type MirrorWindsorReportOrigin} from '@/lib/mirrorWindsorReportOrigin';
import {mirrorWindsorReportTurnTargeted} from '../../supabase/functions/_shared/mirrorWindsorReportIntent';
import {ConnectedTaskDeleteRecoveryPanel} from '@/components/mirror/ConnectedTaskDeleteRecoveryPanel';
import {ConnectedTaskMutationRecoveryPanel} from '@/components/mirror/ConnectedTaskMutationRecoveryPanel';
import { confirmMirrorConnectedMessageReceipt } from "@/lib/confirmMirrorConnectedMessageReceipt";
import { matchesMirrorConnectedMessageReceiptOrigin, mirrorConnectedMessageReceiptReference } from "@/lib/mirrorConnectedMessageReceipt";
import { ConnectedMessagePendingRecoveryPanel } from "@/components/mirror/ConnectedMessagePendingRecoveryPanel";
import { confirmMirrorConnectedTaskReceipt } from "@/lib/confirmMirrorConnectedTaskReceipt";
import { matchesMirrorConnectedTaskReceiptOrigin, mirrorConnectedTaskReceiptReference } from "@/lib/mirrorConnectedTaskReceipt";
import { ConnectedTaskPendingRecoveryPanel } from "@/components/mirror/ConnectedTaskPendingRecoveryPanel";
import { confirmMirrorFileReceipt } from "@/lib/confirmMirrorFileReceipt";
import { matchesMirrorFileReceiptOrigin, mirrorFileReceiptReference } from "@/lib/mirrorFileReceipt";
import { FilePendingRecoveryPanel } from "@/components/mirror/FilePendingRecoveryPanel";
import FinanceActionModal from '@/components/mirror/FinanceActionModal';
import { matchesMirrorFinanceReceiptOrigin, type FinanceActionPrefill } from '@/lib/financeExecutor';
import { confirmMirrorFinanceReceipt, parseMirrorFinanceRecovery, prepareMirrorFinanceRecovery } from '@/lib/financeMirrorReceipt';
import { createMirrorFinanceActions, financeMutationTargeted } from '../../supabase/functions/_shared/mirrorFinanceActions';
import { financeUuid } from '../../supabase/functions/_shared/financeReadIntent';
import BrainHandoffModal from "@/components/mirror/BrainHandoffModal";
import { parseBrainHandoffPrefill, type BrainHandoffPrefill } from "@/lib/brainHandoff";
import { prepareCurrentBrainProposal, prepareBrainNoteModal, sameBrainProposalValue, type BrainLiveOrigin } from "@/lib/brainProposalOrigin";
import type { BrainNoteProposalArgs, BrainHandoffArgs } from "../../supabase/functions/_shared/brainIntent";
import { MIRROR_LANGUAGE_TUTOR_HANDOFF_ENABLED } from '@/lib/featureFlags';
import LanguageClassActionModal from '@/components/language/LanguageClassActionModal';
import LanguageClassPendingRecoveryPanel from '@/components/language/LanguageClassPendingRecoveryPanel';
import LanguageTutorHandoffDialog from '@/components/language/LanguageTutorHandoffDialog';
import { languageClassOriginOperationId, matchesMirrorLanguageClassReceiptOrigin, parseLanguageClassActionPrefill, sameLanguageClassValue,
  type LanguageClassActionPrefill, type MirrorLanguageClassConfirmedReceipt } from '@/lib/languageClassActionExecutor';
import { createMirrorLanguageClassActions } from '../../supabase/functions/_shared/mirrorLanguageClassActions';
import type { LanguageClassProposalArgs, LanguageTutorHandoffArgs } from '../../supabase/functions/_shared/languageClassWriteIntent';
import LanguageActionModal from '@/components/language/LanguageActionModal';
import LanguagePendingRecoveryPanel from '@/components/language/LanguagePendingRecoveryPanel';
import { languageOriginOperationId, matchesMirrorLanguageReceiptOrigin, parseLanguageActionPrefill, sameLanguageValue,
  type LanguageActionPrefill, type MirrorLanguageConfirmedReceipt } from '@/lib/languageActionExecutor';
import { createMirrorLanguageActions, type LanguageProposalArgs } from '../../supabase/functions/_shared/mirrorLanguageActions';
import { flushSync } from "react-dom";
import MirrorDayEntry from "@/components/mirror/MirrorDayEntry";
import { useState, useRef, useEffect, useCallback, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";
import {
  ArrowUp,
  Mic,
  Loader2,
  ChevronLeft,
  ChevronDown,
  ChevronRight,
  X,
  Plus,
  MoreVertical,
  Search,
  Square,
  Volume2,
  VolumeX,
  Sparkles,
  Home,
  Menu,
} from "lucide-react";
import { toast } from "sonner";
import { useNavigate, useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { invalidateMirrorActionStream, isCurrentMirrorActionRequest, publishMirrorActionResults, type MirrorActionRequest } from "@/lib/mirrorActionResults";
import { confirmMirrorEmailReceipt } from "@/lib/confirmMirrorEmailReceipt";
import { confirmMirrorCalendarReceipt } from "@/lib/confirmMirrorCalendarReceipt";
import { confirmMirrorContactReceipt } from "@/lib/confirmMirrorContactReceipt";
import { confirmMirrorGoalReceipt } from "@/lib/confirmMirrorGoalReceipt";
import { goalContextBody, ownedGoalContext, type AttachedGoalContext } from "@/lib/goalContext";
import { matchesMirrorGoalReceiptOrigin, type GoalActionPrefill } from "@/lib/goalExecutor";
import { parseMirrorGoalRecovery, prepareMirrorGoalRecovery } from "@/lib/goalRecovery";
import { GoalActionModal } from "@/components/mirror/GoalActionModal";
import { TaskActionModal } from "@/components/mirror/TaskActionModal";
import { confirmMirrorTaskReceipt } from "@/lib/confirmMirrorTaskReceipt";
import { matchesMirrorTaskReceiptOrigin, newTaskOperationId, type TaskActionPrefill } from "@/lib/taskExecutor";
import { parseMirrorTaskRecovery, prepareMirrorTaskRecovery } from "@/lib/taskRecovery";
import { NoteActionModal, NotePendingActionLauncher } from "@/components/mirror/NoteActionModal";
import { confirmMirrorNoteReceipt } from "@/lib/confirmMirrorNoteReceipt";
import { matchesMirrorNoteReceiptOrigin, newNoteOperationId, type NoteActionPrefill } from "@/lib/noteExecutor";
import { parseMirrorNoteRecovery, prepareMirrorNoteRecovery } from "@/lib/noteRecovery";
import { takeOwnedNoteContext } from "@/lib/noteContextHandoff";
import { HabitActionModal } from "@/components/mirror/HabitActionModal";
import { confirmMirrorHabitReceipt } from "@/lib/confirmMirrorHabitReceipt";
import { matchesMirrorHabitReceiptOrigin, type HabitActionPrefill } from "@/lib/habitExecutor";
import { parseMirrorHabitRecovery, prepareMirrorHabitRecovery } from "@/lib/habitRecovery";
import { LocalReminderActionModal } from "@/components/mirror/LocalReminderActionModal";
import BodyHealthActionModal from "@/components/mirror/BodyHealthActionModal";
import NutritionMealActionModal from '@/components/mirror/NutritionMealActionModal';
import FitnessCuratedPlanModal from '@/components/mirror/FitnessCuratedPlanModal';
import FitnessCuratedPlanActionPanel from '@/components/mirror/FitnessCuratedPlanActionPanel';
import { fitnessCuratedPlanAuthSessionId, fitnessCuratedPlanOriginOperationId, matchesMirrorFitnessCuratedPlanReceiptOrigin, parseFitnessCuratedPlanPrefill, sameFitnessCuratedPlanValue,
  type FitnessCuratedPlanPrefill, type MirrorFitnessCuratedPlanConfirmedReceipt } from '@/lib/fitnessCuratedPlanExecutor';
import { createMirrorFitnessCuratedPlans, type FitnessCuratedPlanProposalArgs } from '../../supabase/functions/_shared/mirrorFitnessCuratedPlans';
import NutritionGoalsActionModal from '@/components/mirror/NutritionGoalsActionModal';
import NutritionGoalsPendingRecoveryPanel from '@/components/mirror/NutritionGoalsPendingRecoveryPanel';
import { nutritionGoalsOriginOperationId, matchesMirrorNutritionGoalsReceiptOrigin, parseNutritionGoalsActionPrefill, sameNutritionGoalsValue,
  type NutritionGoalsActionPrefill, type MirrorNutritionGoalsConfirmedReceipt } from '@/lib/nutritionGoalsExecutor';
import { createMirrorNutritionGoalsActions, type NutritionGoalsProposalArgs } from '../../supabase/functions/_shared/mirrorNutritionGoalsActions';
import NutritionHydrationActionModal from '@/components/mirror/NutritionHydrationActionModal';
import NutritionHydrationPendingRecoveryPanel from '@/components/mirror/NutritionHydrationPendingRecoveryPanel';
import { nutritionHydrationOriginOperationId, matchesMirrorNutritionHydrationReceiptOrigin, parseNutritionHydrationActionPrefill,
  type NutritionHydrationActionPrefill, type MirrorNutritionHydrationConfirmedReceipt } from '@/lib/nutritionHydrationExecutor';
import { nutritionHydrationCurrentRequest } from '../../supabase/functions/_shared/nutritionHydrationWriteIntent';
import { validNutritionHydrationDate } from '../../supabase/functions/_shared/nutritionHydrationActionDomain';
import type { NutritionHydrationProposalArgs } from '../../supabase/functions/_shared/mirrorNutritionHydrationActions';
import { nutritionMealOriginOperationId, matchesMirrorNutritionMealReceiptOrigin, sameNutritionMealValue, parseNutritionMealActionPrefill,
  type NutritionMealActionPrefill, type MirrorNutritionMealConfirmedReceipt } from '@/lib/nutritionMealExecutor';
import { canonicalNutritionMealFields, nutritionMealId } from '../../supabase/functions/_shared/nutritionMealActionDomain';
import { createMirrorNutritionMealActions, type NutritionMealProposalArgs } from '../../supabase/functions/_shared/mirrorNutritionMealActions';
import { confirmMirrorBodyHealthReceipt } from "@/lib/confirmMirrorBodyHealthReceipt";
import { matchesMirrorBodyHealthReceiptOrigin, parseMirrorBodyHealthRecovery, prepareMirrorBodyHealthRecovery, type BodyHealthActionPrefill } from "@/lib/bodyHealthExecutor";
import { bodyHealthActionCaptureHandler, bodyHealthLegacyCaptureHandler } from "@/lib/capture/handlers/bodyHealthCaptureHandler";
import { FitnessActionModal, FitnessPendingActionLauncher } from "@/components/mirror/FitnessActionModal";
import { confirmMirrorFitnessReceipt } from "@/lib/confirmMirrorFitnessReceipt";
import { fitnessOriginOperationId, matchesMirrorFitnessReceiptOrigin, type FitnessActionPrefill } from "@/lib/fitnessExecutor";
import { parseMirrorFitnessRecovery, prepareMirrorFitnessRecovery } from "@/lib/fitnessRecovery";
import { readFitnessLocalWorkoutForRequest, readFitnessLocalWorkoutForDiscardRequest } from "@/lib/fitnessLocalWorkout";
import { fitnessLocalWorkoutReadRequested } from "../../supabase/functions/_shared/fitnessLocalWorkoutIntent";
import { fitnessDraftDiscardRequested, fitnessDraftDiscardTargeted } from "../../supabase/functions/_shared/fitnessDraftDiscardIntent";
import { canonicalDiscardArgs } from "../../supabase/functions/_shared/fitnessDraftDiscardDomain";
import { fitnessLocalWorkoutId } from "../../supabase/functions/_shared/fitnessLocalWorkoutDomain";
import { FitnessDraftDiscardModal, FitnessDraftDiscardRecovery, type FitnessDraftDiscardPrefill } from "@/components/mirror/FitnessDraftDiscardModal";
import type { FitnessDraftDiscardReceipt } from "@/lib/fitnessDraftDiscard";
import { FitnessRuntimeActionModal, type FitnessRuntimeActionPrefill } from "@/components/mirror/FitnessRuntimeActionModal";
import { readFitnessRuntimeForRequest, isFitnessRuntimeRequestCurrent, fitnessRuntimeActionReceiptMatches, type FitnessRuntimeActionReceipt } from "@/lib/fitnessRuntimeAction";
import { fitnessRuntimeActionRequested, fitnessRuntimeTargeted } from "../../supabase/functions/_shared/fitnessRuntimeIntent";
import { canonicalFitnessRuntimeActionArgs, type FitnessRuntimeEnvelope } from "../../supabase/functions/_shared/fitnessRuntimeDomain";
import { FitnessDraftRestoreModal, type FitnessDraftRestorePrefill } from "@/components/mirror/FitnessDraftRestoreModal";
import { readFitnessDraftRestoreForRequest, isFitnessDraftRestoreRequestCurrent, fitnessDraftRestoreReceiptMatches, type FitnessDraftRestoreReceipt, type FitnessDraftRestoreBindings } from "@/lib/fitnessDraftRestore";
import { fitnessDraftRestoreRequested, fitnessDraftRestoreTargeted } from "../../supabase/functions/_shared/fitnessDraftRestoreIntent";
import { canonicalRestoreArgs } from "../../supabase/functions/_shared/fitnessDraftRestoreDomain";
import type { FitnessLocalWorkoutEnvelope } from "../../supabase/functions/_shared/fitnessLocalWorkoutDomain";
import { FitnessWorkoutFinishModal, type FitnessWorkoutFinishPrefill } from "@/components/mirror/FitnessWorkoutFinishModal";
import { readFitnessWorkoutFinishForRequest, isFitnessWorkoutFinishRequestCurrent } from "@/lib/mirror/fitnessWorkoutFinishReader";
import { confirmMirrorFitnessWorkoutFinishReceipt } from "@/lib/confirmMirrorFitnessWorkoutFinishReceipt";
import { fitnessWorkoutFinishReceiptMatches, type FitnessWorkoutFinishReceipt } from "@/lib/fitnessWorkoutFinishWriter";
import { fitnessWorkoutFinishRequested, fitnessWorkoutFinishTargeted } from "../../supabase/functions/_shared/fitnessWorkoutFinishIntent";
import { canonicalFitnessWorkoutFinishArgs, type FitnessWorkoutFinishEnvelope } from "../../supabase/functions/_shared/fitnessWorkoutFinishPreviewDomain";
import { FitnessSavedPlanPrepareModal, type FitnessSavedPlanPreparePrefill } from "@/components/mirror/FitnessSavedPlanPrepareModal";
import { readFitnessSavedPlanPrepareForRequest, isFitnessSavedPlanPrepareRequestCurrent, type FitnessSavedPlanPrepareBindings } from "@/lib/mirror/fitnessSavedPlanPrepareReader";
import { fitnessSavedPlanPrepareReceiptMatches, type FitnessSavedPlanPrepareReceipt } from "@/lib/fitnessSavedPlanPrepare";
import { fitnessSavedPlanPrepareRequested, fitnessSavedPlanPrepareTargeted } from "../../supabase/functions/_shared/fitnessSavedPlanPrepareIntent";
import { canonicalFitnessSavedPlanPrepareArgs, type FitnessSavedPlanPrepareEnvelope } from "../../supabase/functions/_shared/fitnessSavedPlanPrepareDomain";
import { FitnessRestSkipModal, type FitnessRestSkipPrefill } from "@/components/mirror/FitnessRestSkipModal";
import { readFitnessRestSkipForRequest, isFitnessRestSkipRequestCurrent } from "@/lib/mirror/fitnessRestSkipReader";
import { fitnessRestSkipReceiptMatches, type FitnessRestSkipReceipt } from "@/lib/fitnessRestSkip";
import { fitnessRestSkipRequested, fitnessRestSkipTargeted } from "../../supabase/functions/_shared/fitnessRestSkipIntent";
import { canonicalFitnessRestSkipArgs, type FitnessRestSkipEnvelope } from "../../supabase/functions/_shared/fitnessRestSkipDomain";
import { FitnessCurrentSetCompletionModal, type FitnessCurrentSetCompletionPrefill } from "@/components/mirror/FitnessCurrentSetCompletionModal";
import { readFitnessCurrentSetCompletionForRequest, isFitnessCurrentSetCompletionRequestCurrent, fitnessCurrentSetCompletionReceiptMatches, type FitnessCurrentSetCompletionReceipt } from "@/lib/mirror/fitnessCurrentSetCompletionReader";
import { fitnessCurrentSetCompletionRequested, fitnessCurrentSetCompletionTargeted } from "../../supabase/functions/_shared/fitnessCurrentSetCompletionIntent";
import { canonicalFitnessCurrentSetCompletionArgs, type FitnessCurrentSetCompletionEnvelope } from "../../supabase/functions/_shared/fitnessCurrentSetCompletionDomain";
import { FitnessSetupStartModal, type FitnessSetupStartPrefill } from "@/components/mirror/FitnessSetupStartModal";
import { readFitnessSetupStartForRequest, isFitnessSetupStartRequestCurrent, fitnessSetupStartReceiptMatches, type FitnessSetupStartReceipt } from "@/lib/fitnessSetupStart";
import { fitnessSetupStartRequested, fitnessSetupStartTargeted } from "../../supabase/functions/_shared/fitnessSetupStartIntent";
import { canonicalFitnessSetupStartArgs, type FitnessSetupStartEnvelope } from "../../supabase/functions/_shared/fitnessSetupStartDomain";
import { FitnessCurrentSetEditModal, type FitnessCurrentSetEditPrefill } from "@/components/mirror/FitnessCurrentSetEditModal";
import { readFitnessCurrentSetEditForRequest, isFitnessCurrentSetEditRequestCurrent, fitnessCurrentSetEditReceiptMatches, type FitnessCurrentSetEditReceipt } from "@/lib/fitnessCurrentSetEdit";
import { parseFitnessCurrentSetEditRequest, fitnessCurrentSetEditTargeted } from "../../supabase/functions/_shared/fitnessCurrentSetEditIntent";
import { canonicalFitnessCurrentSetEditArgs, type FitnessCurrentSetEditEnvelope } from "../../supabase/functions/_shared/fitnessCurrentSetEditDomain";
import { SleepActionModal } from "@/components/mirror/SleepActionModal";
import { confirmMirrorSleepReceipt } from "@/lib/confirmMirrorSleepReceipt";
import { matchesMirrorSleepReceiptOrigin, type SleepActionPrefill } from "@/lib/sleepExecutor";
import { parseMirrorSleepRecovery, prepareMirrorSleepRecovery } from "@/lib/sleepRecovery";
import { MIRROR_BODY_HEALTH_CARDS_ENABLED, MIRROR_SLEEP_CARDS_ENABLED, MIRROR_FITNESS_CARDS_ENABLED } from "@/lib/featureFlags";
import { sleepActionCaptureHandler, sleepCaptureHandler } from "@/lib/capture/handlers/sleepCaptureHandler";
import { CheckinActionModal } from "@/components/mirror/CheckinActionModal";
import { confirmMirrorCheckinReceipt } from "@/lib/confirmMirrorCheckinReceipt";
import { matchesMirrorCheckinReceiptOrigin, type CheckinActionPrefill } from "@/lib/checkinExecutor";
import { parseMirrorCheckinRecovery, prepareMirrorCheckinRecovery } from "@/lib/checkinRecovery";
import { FocusActionModal } from "@/components/mirror/FocusActionModal";
import { confirmMirrorFocusReceipt } from "@/lib/confirmMirrorFocusReceipt";
import { matchesMirrorFocusReceiptOrigin, newFocusOperationId, type FocusActionPrefill } from "@/lib/focusExecutor";
import { parseMirrorFocusRecovery, prepareMirrorFocusRecovery } from "@/lib/focusRecovery";
import { confirmMirrorReminderReceipt } from "@/lib/confirmMirrorReminderReceipt";
import { matchesMirrorReminderReceiptOrigin, type LocalReminderActionPrefill } from "@/lib/reminderExecutor";
import { parseMirrorReminderRecovery, prepareMirrorReminderRecovery } from "@/lib/reminderRecovery";
import { LocalAgendaActionModal } from "@/components/mirror/LocalAgendaActionModal";
import { confirmMirrorAgendaReceipt } from "@/lib/confirmMirrorAgendaReceipt";
import { matchesMirrorAgendaReceiptOrigin, type LocalAgendaActionPrefill } from "@/lib/agendaExecutor";
import { parseMirrorAgendaRecovery, prepareMirrorAgendaRecovery } from "@/lib/agendaRecovery";
import { confirmMirrorExternalTaskReceipt } from "@/lib/confirmMirrorExternalTaskReceipt";
import { matchesMirrorEmailReceiptOrigin } from "@/lib/mirrorEmailReceipt";
import { matchesMirrorCalendarReceiptOrigin } from "@/lib/calendarAction";
import { matchesMirrorContactReceiptOrigin } from "@/lib/contactExecutor";
import { matchesMirrorExternalTaskReceiptOrigin } from "@/lib/externalTaskExecutor";
import { loadMirrorHistoryPage, loadMirrorMessagePage, type MirrorHistoryCursor, type MirrorMessageCursor } from "@/lib/mirrorHistory";
import { deliverableFileName, downloadDeliverable, downloadImageDeliverable } from "@/lib/downloadFile";
import DeliverableChatImage from "@/components/deliverables/DeliverableChatImage";
import ReportContentButton from "@/components/report/ReportContentButton";
import { REPORT_SURFACES } from "@/lib/report/surfaces";
import { resolveAssistantMessageId } from "@/lib/report/resolveAssistantMessageId";
import { useReportedContent } from "@/contexts/ReportedContentContext";
import DeliverableImageViewer, {
  type ImageViewTarget,
} from "@/components/deliverables/DeliverableImageViewer";
import { getOrCreateMirrorSession, createIsolatedMirrorSession, resetMirrorSession, setMirrorSession } from "@/lib/mirrorSession";
import {
  beginPull,
  beginRestore,
  trackPull,
  trackRestore,
  type PullTracker,
} from "@/lib/mirrorStageGesture";
import { LIVE_REQUIRES_PREMIUM } from "@/lib/liveAccess";
import { composeNoteContextMessage } from "@/lib/mirrorNoteContext";
import ReactMarkdown from "react-markdown";
import vyvIcon from "@/assets/vyv-icon.png";
import { useLanguage } from "@/i18n/LanguageProvider";
import { localeTagFor, type Lang } from "@/i18n/locale";
import { parsePaymentErrorFromResponse } from "@/lib/quotaError";
import { usePaymentErrorHandler } from "@/hooks/usePaymentErrorHandler";
import { useQuotaErrorSurface } from "@/hooks/useQuotaErrorSurface";
import { useAudioAutoplay } from "@/hooks/useAudioAutoplay";
import { useVoiceInput } from "@/hooks/useVoiceInput";
import { useVoiceInputWhisper } from "@/hooks/useVoiceInputWhisper";
import { resetKeyboardCssVars, useKeyboardOffset } from "@/hooks/useKeyboardOffset";
import { useVoice } from "@/hooks/useVoice";
import { VoiceRecordingIndicator } from "@/components/voice/VoiceRecordingIndicator";
import { useMirrorState } from "@/hooks/useMirrorState";
import { useMirrorSurface } from "@/hooks/useMirrorSurface";
import { useNudges } from "@/hooks/useNudges";
import { useAvatar } from "@/hooks/useAvatar";
import NudgeCard from "@/components/NudgeCard";
import MirrorPushSoftAsk from "@/components/MirrorPushSoftAsk";
import MirrorActionChip from "@/components/mirror/MirrorActionChip";
import MirrorBodyScanHandoffCard from "@/components/mirror/MirrorBodyScanHandoffCard";
import { BODY_SCAN_PROVIDER_ENABLED } from "@/lib/bodyscan/provider";
import { bodyScanHandoffFromResults, isCurrentBodyScanHandoff, openBodyScanHandoff, type MirrorBodyScanHandoff } from "@/lib/mirrorBodyScanHandoff";
import { useMirrorActions } from "@/hooks/useMirrorActions";
import type { ActionProposal } from "@/types/mirror";
// Universal capture spine — routes mirror-chat proposals (e.g. agenda) to the
// right extractor + confirm modal. Replaces the inline agenda-extract
// delegation that used to live in this file.
import { useModuleCapture, type UseModuleCaptureOptions } from "@/hooks/useModuleCapture";
// Nutrition photo-capture (camera attach) + the shared capture-recap surface.
import NutritionLogModal, { type NutritionPrefill } from "@/components/nutrition/NutritionLogModal";
import { useNutritionPhotoAnalyze } from "@/hooks/useNutritionPhotoAnalyze";
// Camada de INPUT (F1): anexo de arquivo do Espelho Executor.
import { useExecutorAttachments } from "@/hooks/useExecutorAttachments";
import { useConnectedFileImport } from "@/hooks/useConnectedFileImport";
import AttachmentChips from "@/components/mirror/AttachmentChips";
// Item 2 — convite de WhatsApp INLINE no fio (não bottom-sheet: o slot modal
// do primeiro momento já é do push soft-ask).
import WaSoftAskChip from "@/components/mirror/WaSoftAskChip";
import IntegrationSuggestChip from "@/components/mirror/IntegrationSuggestChip";
import { useWaSoftAsk } from "@/hooks/useWaSoftAsk";
import { useIntegrationSuggestion } from "@/hooks/useIntegrationSuggestion";
// Falar com o Welfare Officer — SÓ para morador de organização. Quando o
// Espelho não sabe, esta é a saída DENTRO do VYV; e é o evento que faz a
// métrica oficial do piloto Kafra existir (sem escalada não há contrafactual).
import WelfareOfficerChip from "@/components/mirror/WelfareOfficerChip";
import { useOrgMembership } from "@/hooks/useOrgMembership";
import { ATTACH_ACCEPT, attachmentBodyFields } from "@/lib/executorUpload";
import {
  subscribeCaptureRecap,
  emitCaptureRecap,
  CAPTURE_RECAP_ICON,
  type CaptureRecap,
} from "@/lib/capture/captureRecapBus";
import { isInternalSentinel } from "@/lib/ttsFilters";
import { scheduleAutoDismiss, CARD_DISMISS_MS } from "@/hooks/useAutoDismiss";

// Mirror architecture modules
import {
  PRESENCE_STATES,
  MIRROR_STAGE_BG,
} from "@/components/mirror/MirrorPresenceConfig";
import MirrorAvatar from "@/features/avatar/mirror/MirrorAvatar";
import MirrorStage from "@/components/mirror/MirrorStage";
import MirrorLiveAvatar from "@/components/mirror/MirrorLiveAvatar";
import MirrorLiveControls from "@/components/mirror/MirrorLiveControls";
import { useAuthenticatedMirrorLive as useMirrorLive } from "@/hooks/useAuthenticatedMirrorLive";
import { createMirrorAuthSessionScope, mirrorAuthIdentity, type AuthenticatedMirrorChannelState as MirrorAuthenticatedChannelState, type MirrorAuthLease } from "@/lib/mirrorAuthSession";
import type { MirrorLiveToolHandoff } from "@/hooks/useMirrorLive";
import { mirrorChannelReviewDrafts, MIRROR_REVIEW_DRAFT_TTL_MS } from "@/lib/mirrorChannelReviewDraft";
import { loadMirrorWhatsAppReviewStage } from "@/lib/mirrorWhatsAppReview";
import { whatsappReviewMessageId, WHATSAPP_REVIEW_PARAM } from "../../supabase/functions/_shared/whatsappReviewHandoff";
import type { WhisperOwnerGuard } from "@/hooks/useVoiceInputWhisper";
import MirrorNavDrawer from "@/components/mirror/MirrorNavDrawer";
import MirrorSurfaceToggle from "@/components/mirror/MirrorSurfaceToggle";
import MirrorReminderBubble from "@/components/mirror/MirrorReminderBubble";
import LipSyncCalibrationHUD from "@/components/dev/LipSyncCalibrationHUD";
import VyvEnergy from "@/components/vyv/VyvEnergy";
import { isIOSNative } from "@/lib/platform";
import type { EntryIntent } from "@/lib/entryIntent";
import { nextSuggestionTrio } from "@/lib/mirrorPrompts";
import { analytics, appPlatform } from "@/lib/analytics";
import { APP_VERSION } from "@/lib/appVersion";
import { createMirrorSpeechCoordinator, mirrorSpeechNetwork, type MirrorSpeechCoordinator, type MirrorSpeechMeasurement } from "@/lib/mirrorSpeechTelemetry";
import { createMirrorProgressiveSpeechCoordinator, type MirrorProgressiveSpeechCoordinator } from "@/lib/mirrorProgressiveSpeechTelemetry";
import { Sentry } from "@/lib/sentry";
import { useRequirePremium } from "@/hooks/useRequirePremium";
import { sfx } from "@/lib/sfx";
import { useAppSplash } from "@/contexts/AppSplashContext";

// Feature flag: when true, speakResponse fetches a binary audio stream from
// mirror-tts instead of going through supabase.functions.invoke() which
// returns base64 JSON. Flip to true only AFTER deploying the streaming
// edge-function variant. Until then, keep false so production TTS works.
const TTS_STREAMING_ENABLED = true;
const TTS_SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const TTS_SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Feature flag: when true, use Whisper-based voice input (MediaRecorder +
// mirror-stt edge function). When false, use legacy Web Speech API
// (useVoiceInput). Whisper fixes iOS Safari AVAudioSession bug where Web
// Speech API fails after TTS.
const VOICE_WHISPER_ENABLED = true;

// Recap ack dismiss window lives in the shared helper (CARD_DISMISS_MS) so the
// nav toast, the agenda card and this recap all clear on the same timing.

// Tiny silent MP3 used to unlock iOS audio and to reset AVAudioSession
// back to a mic-friendly category after TTS playback.
const SILENT_MP3 = "data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLmNvbQBURU5DAAAABwAAA0xhbWUAAAAAAAAAAAAAAP/7kGQAAANUMEoFPeACNQV40KEAAA0gwX4UPYACNgV5Io5eBAgAADXCHP/7kmRAAADSBHIJaxiADNgFhw2EABN0Fch2dYAI2gWHDYSAAAANPJy//+5JkwAAA0wRyHZ2AAjYBYcNhAAAA0gRyHZ1gAjaBYcNhIAAAAf/+5JkCgAA0gRyHZ1gAjaBYcNhAAAA0gRyHZ1gAjYBYcNhIAAAPf/7kmQAAADSBHIdnWACNoFhw2EgAADSBHIdnWACNgFhw2EgAAA=";

interface ProposalChipState {
  proposal: ActionProposal;
  status: "pending" | "created" | "cancelled" | "undone" | "dismissed";
  // Camada de INPUT (NANO-2): anexos do turno que gerou este chip. O toque no
  // chip acontece DEPOIS do turno, então sem carregar os ids aqui o
  // deliverable-generate não teria como saber de qual arquivo se falava.
  attachmentIds?: string[];
  createdRecord?: { id: string; tableName: "agenda_events" | "notes" | "tasks" | "focus_sessions" };
  // F1 PR-D: entregável de ARQUIVO gerado por este chip — habilita o BAIXAR
  // no estado created (util compartilhado downloadFile.ts). Estado efêmero da
  // sessão; fora dela o caminho permanente é a Biblioteca (/library).
  deliverableFile?: {
    fileUrl: string | null;
    storagePath: string | null;
    fileName: string;
    format: string;
    kind: string;
  } | null;
}

// P2 — menu multitarefa do compositor: as capacidades REAIS do Espelho como
// COMEÇOS DE PEDIDO (mesmo mecanismo de prefill da chip 📸) — nunca um
// pipeline paralelo nem tela nova: o item pré-preenche o input e o pedido sai
// pelo sendMessage normal quando o usuário completa a frase. `disabled` =
// tease de roadmap com selo "Em breve"; "Meus Agentes" vira ATIVO trocando só
// esta flag (+ prefillKey) — estrutura pronta, sem refactor.
interface ComposerMenuItem {
  id: string;
  emoji: string;
  labelKey: string;
  // Item que ENVIA uma afirmação semente ao Espelho (inicia a conversa; o
  // Espelho pergunta o assunto) em vez de pré-preencher o input.
  sendKey?: string;
  // Item que NAVEGA (abre uma tela) em vez de enviar mensagem.
  route?: string;
  // Item que EXECUTA algo aqui mesmo — hoje, abrir um seletor de arquivo.
  // Entrou porque ícone sem rótulo só funciona quando o significado é
  // universal, e "câmera = registrar refeição" não é: a função existia no
  // compositor desde sempre e ninguém usava, porque nada dizia o que ela fazia.
  action?: "attachFile" | "mealPhoto";
  disabled?: boolean;
}

// Ajuste A/B: os itens de geração ENVIAM a semente (não pré-preenchem); "Meus
// Agentes" NAVEGA pra /agents; "Gerar vídeo" segue "em breve". "Escrever texto"
// e "Lembretes" removidos (texto = digitar no chat; lembrete vive em /agents).
const COMPOSER_MENU_ITEMS: ComposerMenuItem[] = [
  // As duas ENTRADAS DE ARQUIVO vêm primeiro: são as únicas concretas do menu
  // (as outras são começos de frase), e são as que estavam invisíveis como
  // ícone mudo na barra. Reusam as chaves i18n que já existiam nos 3 idiomas —
  // "Foto da refeição" já era a copy do aria-label da câmera; ela só nunca
  // chegava ao usuário.
  { id: "attach", emoji: "📎", labelKey: "executor.attachment.attach", action: "attachFile" },
  { id: "meal", emoji: "🍽️", labelKey: "mirror.attachPhoto", action: "mealPhoto" },
  { id: "image", emoji: "🖼️", labelKey: "mirror.composerMenu.image", sendKey: "mirror.composerMenu.imageSend" },
  { id: "pdf", emoji: "📄", labelKey: "mirror.composerMenu.pdf", sendKey: "mirror.composerMenu.pdfSend" },
  { id: "sheet", emoji: "📊", labelKey: "mirror.composerMenu.sheet", sendKey: "mirror.composerMenu.sheetSend" },
  { id: "agents", emoji: "🤖", labelKey: "mirror.composerMenu.agents", route: "/agents" },
  { id: "video", emoji: "🎬", labelKey: "mirror.composerMenu.video", disabled: true },
];

// Ajuste C (v2 — reframe de câmera REAL, não CSS scale): encolhe o avatar
// full-body da /mirror por PROFUNDIDADE (câmera afastada) e o sobe pra faixa
// superior (as chips de sugestão não sobrepõem). Reusa o MESMO mecanismo dos
// mini-mirrors — cameraDistanceOverride / lookAtYOverride do AvatarCore — agora
// repassados pelo MirrorAvatar (edit aditivo). SÓ o <MirrorAvatar> desta tela
// recebe estes props (default off → MirrorReady e todo o resto ficam idênticos).
// Substitui os valores device-specific do config frozen (desktop 5.5/1.05 ·
// mobile 5.2/1.45) por um par único, mirado no alvo mobile. AFINAR = mudar só
// este const:  distance ↑ = avatar menor (perspectiva) · lookAtY ↓ = mais pra cima.
/**
 * Carimba o id resolvido na bolha certa. A resolucao em si vive em
 * src/lib/report/resolveAssistantMessageId.ts, compartilhada com os
 * MiniMirrors — quatro copias do mesmo SELECT sairiam de sincronia na
 * primeira mudanca.
 */
async function stampAssistantMessageId(
  sessionId: string | null,
  finalText: string,
  setMessages: React.Dispatch<React.SetStateAction<Message[]>>,
  isCurrent: () => boolean = () => true,
): Promise<void> {
  const id = await resolveAssistantMessageId(sessionId, finalText);
  if (!id || !isCurrent()) return;
  setMessages((prev) => {
    // Do fim para o inicio: a bolha alvo e a ultima do assistant ainda sem id.
    const next = prev.slice();
    let patched = false;
    for (let i = next.length - 1; i >= 0; i--) {
      const m = next[i];
      if (m.role === "assistant" && !m.id && m.content === finalText) {
        next[i] = { ...m, id };
        patched = true;
        break;
      }
    }
    return patched ? next : prev;
  });
}

const MIRROR_CAM = { distance: 7.7, lookAtY: 1.0 };

type AuthenticatedMirrorChannelState = MirrorAuthenticatedChannelState & { speechMetrics?: MirrorSpeechCoordinator; progressiveSpeechMetrics?: MirrorProgressiveSpeechCoordinator };

interface Message {
  id?: string;
  role: "user" | "assistant";
  content: string;
  speechMeasurement?: number; // Ephemeral DOM marker, never persisted or emitted.
  proposals?: ProposalChipState[];
  // Current-turn navigation offer only. It does not represent a saved scan.
  bodyScanHandoff?: MirrorBodyScanHandoff | null;
  // PR-A F2: imagem gerada rende INLINE na bolha (thumbnail clicável → viewer
  // compartilhado); content vira só a legenda curta. Efêmero como o restante
  // da mensagem de entregável — o permanente é a Biblioteca.
  // deliverableId: id da linha em mirror_deliverables. A imagem gerada e uma
  // superficie de denuncia por si so (foi UMA das duas telas da evidencia do
  // Google), e sem o id o controle nao teria o que identificar.
  deliverableImage?: { storagePath: string; title: string; deliverableId?: string } | null;
  // C1 capture recap — a subtle assistant-side "I saved this" acknowledgement
  // (agenda/task/note/nutrition). Ephemeral, not persisted to mirror_messages.
  recap?: CaptureRecap;
  // Stable id for an ephemeral recap bubble so its auto-dismiss timer (and a
  // manual tap) can remove the exact message.
  recapId?: string;
}

interface HistorySession {
  id: string;
  created_at: string;
  updated_at?: string;
  title?: string;
  preview?: string;
  messageCount?: number;
  project_id?: string | null;
}

interface Project {
  id: string;
  name: string;
  color: string;
  created_at: string;
}

const PROJECT_COLORS: Record<string, string> = {
  cyan: "hsl(187 72% 50%)",
  purple: "hsl(270 60% 60%)",
  orange: "hsl(25 80% 60%)",
  green: "hsl(142 60% 50%)",
};

const COLOR_OPTIONS = ["cyan", "purple", "orange", "green"] as const;

interface MirrorChatProps {
  /**
   * Live (Option C) presentation mode: full-screen avatar presence + push-to-talk.
   * Hides the chat bubbles, history, and the text input — the SAME pipeline
   * (Whisper STT → mirror-chat → TTS) runs underneath, just voice-only.
   * Rendered by the /mirror/live route as <MirrorChat live />.
   */
  live?: boolean;
  /**
   * Optional module context forwarded to mirror-chat as `module_context`
   * (e.g. "language_tutor" from /language/live → Modo Professor). Absent =
   * global Mirror brain. Drives the per-module system block in the edge fn.
   */
  moduleContext?: string;
  /**
   * Modo Professor only — the app-selected "word set of the day". Forwarded to
   * mirror-chat as `body.tutor_words` so the tutor DELIVERS this exact set
   * (the app, not the LLM, owns selection). Ignored unless
   * moduleContext === "language_tutor".
   */
  tutorLanguage?: string;
  tutorWords?: Array<{ word: string; translation: string; example?: string }>;
  /**
   * Modo Professor only — called once per word (deduped for the session) when
   * the tutor emits the [[learned:WORD]] success marker. The wrapper raises
   * mastery + tracks the word for session/XP write-back.
   */
  onWordLearned?: (word: string) => void;
  /**
   * Modo Professor only — when true, fire ONE auto-spoken opener on mount
   * (non-gesture) so the tutor greets first and introduces the day-words.
   * Guarded against double-fire. Never enabled on the plain Espelho Live.
   */
  autoKickoff?: boolean;
  /**
   * Modo Professor only — flips true when the wrapper's day-set build has
   * SETTLED (success, empty, failure OR timeout). autoKickoff waits on this
   * instead of a non-empty word set, so a failed/empty set can never freeze
   * the opener — the tutor just runs a generic conversational session.
   */
  tutorWordsReady?: boolean;
}

const MirrorChat = ({
  live = false,
  moduleContext,
  tutorWords,
  tutorLanguage,
  onWordLearned,
  autoKickoff = false,
  tutorWordsReady = false,
}: MirrorChatProps = {}) => {
  const navigate = useNavigate();
  const { isPremium, isLoading: premiumLoading, redirect: premiumRedirect } = useRequirePremium();
  const handlePaymentError = usePaymentErrorHandler();
  const surfaceQuotaError = useQuotaErrorSurface();

  // ── LIVE por OpenAI Realtime (LOTE 3, 05/09) ──────────────────────────────
  // Só a tela /mirror/live PURA. O modo professor (/language/live,
  // moduleContext="language_tutor") segue no pipeline Whisper → mirror-chat →
  // TTS; o /mirror push-to-talk (live === false) não muda. O hook é chamado
  // sempre (ordem de hooks) e só age com enabled=true. O 402 do token (Free
  // fora da grade ou Premium sem minutos) cai no MESMO roteador de paywall.
  const realtimeLive = live && !moduleContext;
  const { t, tf, lang } = useLanguage();
  const prepareLiveToolSessionRef = useRef<() => Promise<string | null>>(async () => null);
  const liveHandoffHandlerRef = useRef<(handoff: MirrorLiveToolHandoff) => void>(() => {});
  const [liveToolHandoff, setLiveToolHandoff] = useState<{ handoff: MirrorLiveToolHandoff; lease: MirrorAuthLease } | null>(null);
  const prepareLiveToolSession = useCallback(() => prepareLiveToolSessionRef.current(), []);
  const onLiveToolHandoff = useCallback((handoff: MirrorLiveToolHandoff) => liveHandoffHandlerRef.current(handoff), []);
  const rt = useMirrorLive({
    enabled: realtimeLive,
    prepareToolSession: realtimeLive ? prepareLiveToolSession : undefined,
    onToolHandoff: onLiveToolHandoff,
    onQuotaExceeded: handlePaymentError,
    // LOTE 4 — o idioma da UI vai no token, como vai no mirror-chat
    // (body.language = lang): o LIVE respondia pelo idioma do perfil.
    language: lang,
  });

  // Live entry analytics — fire once per mount in live mode.
  useEffect(() => {
    if (live) analytics.mirrorLiveOpened();
  }, [live]);
  const [autoplayAudio] = useAudioAutoplay();

  // Smart nudge — only the teach_mirror_incomplete type is shown on this page
  // (see render below). Other types are gated to Home so chat stays focused.
  const { activeNudge, dismissNudge, actOnNudge } = useNudges();
  const { hasAvatar, loading: avatarLoading } = useAvatar();
  // Superfície do palco (avatar × energia) — decisão Rafa 21/08. NULL no
  // banco resolve para o comportamento de sempre (tem avatar → avatar; não
  // tem → energia). A flag derivada exige as DUAS coisas — escolha E avatar
  // real — para nunca montar o MirrorAvatar de quem não tem GLB próprio.
  const { surface: mirrorSurface, setSurface: setMirrorSurface, loading: surfaceLoading } = useMirrorSurface(hasAvatar);
  const mirrorShowsAvatar = hasAvatar && mirrorSurface === "avatar";
  // Anti-flash (bug 25/08): pintar avatar/energia antes de os DOIS loadings
  // resolverem mostra a superfície errada e troca na frente do usuário —
  // mesma classe do P0 #3. Ambos os hooks têm cache de sessão, então isto só
  // segura o primeiro mount pós-reload.
  const mirrorSurfaceResolving = avatarLoading || surfaceLoading;
  const mirrorActions = useMirrorActions();

  // Universal capture spine — mounted ONCE here, at the proposal seam. The
  // agenda-extract -> CreateEventModal flow that used to be inline in this file
  // now lives in useModuleCapture + the agenda handler (registry-driven: adding
  // nutrition/sleep/etc. = register a handler, no change here). The hook owns
  // the modal lifecycle + the two-axis re-emit idempotency (action_id +
  // normalized raw_text, 90s TTL) that used to live in this component.

  // Voice-first: the Espelho is now the post-login destination, so dismiss the
  // branded login splash (armed by Auth.tsx) on mount — the old destination
  // (MirrorHome) hid it; without this it would hang until the 4s safety timeout.
  // hide() is idempotent + a no-op when the splash isn't showing.
  const splash = useAppSplash();
  useEffect(() => {
    splash.hide();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Voice input
  const voiceLegacy = useVoiceInput(lang);
  // Modo Professor: the live tutor session is bilingual (the learner mixes
  // native + target language), so Whisper must auto-detect per utterance
  // instead of being forced to the app locale — the fixed hint made it
  // transcribe/translate EN speech into PT. moduleContext is unset on
  // /mirror and /mirror/live, so the Espelho keeps the locale hint as-is.
  const voiceWhisper = useVoiceInputWhisper(lang, {
    detectLanguage: moduleContext === "language_tutor",
  });
  const voice = VOICE_WHISPER_ENABLED
    ? { ...voiceWhisper, stopListening: voiceWhisper.stopListening as unknown as () => string }
    : voiceLegacy;
  const isTranscribing = VOICE_WHISPER_ENABLED ? voiceWhisper.isTranscribing : false;
  const recordingSeconds = VOICE_WHISPER_ENABLED ? voiceWhisper.recordingSeconds : 0;
  const amplitude = VOICE_WHISPER_ENABLED ? voiceWhisper.amplitude : 0;

  const [isVoiceStarting, setIsVoiceStarting] = useState(false);
  const [voiceDraftReady, setVoiceDraftReady] = useState(false);
  const voiceBusy = isVoiceStarting || voice.isListening || isTranscribing;
  const voiceCaptureRef = useRef<{ draft: string; authEpoch: number; sessionEpoch: number; stopping: boolean; starting: boolean; reviewing: boolean; lease?: MirrorAuthLease; guard?: WhisperOwnerGuard } | null>(null);
  const cancelVoiceRef = useRef<(restoreDraft?: boolean) => void>(() => {});
  const speechEpochRef = useRef(0);

  // Current conversation
  const [messages, setMessages] = useState<Message[]>([]);
  const [input, setInput] = useState("");
  const reviewComposerDraftRef = useRef(input);
  const reviewComposerVersionRef = useRef(0);
  if (reviewComposerDraftRef.current !== input) reviewComposerVersionRef.current++;
  reviewComposerDraftRef.current = input;
  const [isLoading, setIsLoading] = useState(false);
  // Transport callbacks accept an authority integration; this production state always requires it.
  const actionResultStreamRef = useRef<AuthenticatedMirrorChannelState>({ ownerId: null, authEpoch: 0, sessionEpoch: 0, sessionTransition: false, request: 0, mounted: false, controller: null, authScope: createMirrorAuthSessionScope(), speechMetrics: createMirrorSpeechCoordinator({ onResult: report => analytics.mirrorSpeechLatency(report) }) });
  const progressiveSpeechMetricsRef = useRef(createMirrorProgressiveSpeechCoordinator({ onResult: report => analytics.mirrorProgressiveSpeechLatency(report) }));
  actionResultStreamRef.current.progressiveSpeechMetrics = progressiveSpeechMetricsRef.current;
  const [captureAuthEpoch, setCaptureAuthEpoch] = useState(0);
  const fitnessCuratedPlanAuthSessionRef = useRef<string | null>(null);
  const [captureOwnerId, setCaptureOwnerId] = useState<string | null>(null);
  liveHandoffHandlerRef.current = (handoff) => {
    const stream = actionResultStreamRef.current, lease = stream.authScope.capture();
    if (!stream.mounted || !lease || !stream.authScope.isCurrent(lease)
      || handoff.ownerId !== lease.ownerId || handoff.authSessionId !== lease.authSessionId
      || !handoff.transcript.trim() || handoff.transcript.length > 4000) return;
    setLiveToolHandoff({ handoff, lease });
  };
  useEffect(() => {
    const scope = actionResultStreamRef.current.authScope;
    if (captureAuthEpoch === 0 && !scope.current()) return;
    mirrorChannelReviewDrafts.observe(scope.current());
    if (liveToolHandoff && !scope.isCurrent(liveToolHandoff.lease)) setLiveToolHandoff(null);
  }, [captureAuthEpoch, liveToolHandoff]);
  useEffect(() => {
    if (rt.status === "requesting_mic" || rt.status === "connecting" || rt.status === "idle")
      setLiveToolHandoff(null);
  }, [rt.status]);
  const [windsorReportOrigin,setWindsorReportOrigin]=useState<MirrorWindsorReportOrigin|null>(null);
  const [fileEditOrigin,setFileEditOrigin]=useState<MirrorFileEditOrigin|null>(null);
  const stopStreamTtsRef = useRef<() => void>(() => {});
  const streamGoIdleRef = useRef<() => void>(() => {});
  useEffect(() => {
    const streamState = actionResultStreamRef.current;
    const historyPaging = historyPagingRef.current;
    const transcriptPaging = transcriptPagingRef.current;
    const projectLoads = projectsLoadRef.current;
    streamState.mounted = true;
    const applyAuthSession = (session: unknown) => {
      if (!streamState.mounted) return;
      const observation = streamState.authScope?.observeSession(session);
      const observedSession = session as { user?: { id?: string }; access_token?: string } | null;
      const nextOwner = observation ? observation.identity?.ownerId ?? null : observedSession?.user?.id ?? null;
      const nextCuratedAuthSession = observation ? observation.identity?.authSessionId ?? null : fitnessCuratedPlanAuthSessionId(observedSession?.access_token);
      if (fitnessCuratedPlanAuthSessionRef.current !== nextCuratedAuthSession) {
        fitnessCuratedPlanAuthSessionRef.current = nextCuratedAuthSession;
        fitnessCuratedPlanActor.current = null; fitnessCuratedPlanLiveOrigins.current.clear(); setFitnessCuratedPlanPrefill(null);
      }
      setCaptureOwnerId(nextOwner);
      if (nextOwner !== streamState.ownerId || observation?.changed) {
        streamState.speechMetrics?.discard();
        streamState.progressiveSpeechMetrics?.discard();
        const changedAccount = streamState.ownerId !== null;
        streamState.ownerId = nextOwner;
        streamState.authEpoch++;
        if (streamState.authScope) setCaptureAuthEpoch(streamState.authEpoch);
        streamState.sessionTransition = false;
        historyPagingRef.current.request++;
        historyPagingRef.current.loading = false;
        historyPagingRef.current.cursor = null;
        transcriptPagingRef.current.request++;
        projectsLoadRef.current.request++;
        transcriptPagingRef.current.loading = false;
        transcriptPagingRef.current.cursor = null;
        earlierScrollAnchorRef.current = null;
        setLoadingHistory(false);
        setLoadingProjects(false);
        setLoadingEarlierMessages(false);
        setLoadingSessionId(null);
        setHasMoreHistory(false);
        setHasEarlierMessages(false);
        setHistoryLoadError(null);
        setEarlierLoadError(false);
        if (changedAccount) {
          cancelVoiceRef.current(false);
          speechEpochRef.current++;
          invalidateMirrorActionStream(streamState);
          streamState.sessionEpoch++;
          activeSessionIdRef.current = null;
          sessionPromiseRef.current = null;
          setSessionId(null);
          setMessages([]);
          setHistorySessions([]);
          setProjects([]);
          setViewingSessionId(null);
          setViewingMessages([]);
          setInput("");
          if (streamState.authScope) {
            welcomeCheckedRef.current = false; suggestChecked.current = false; wokeRef.current = false;
            setSpokenWelcomePending(false); setSuggestionsArmed(false);
            setWindsorReportOrigin(null); setFileEditOrigin(null);
          }
          attachedGoalRef.current = null; setAttachedGoal(null);
          attachedNoteRef.current = null; setAttachedNote(null);
          setRecoveredGoalPrefill(null);
          setRecoveredTaskPrefill(null);
          setRecoveredNotePrefill(null);
          setRecoveredHabitPrefill(null);
    setRecoveredAgendaPrefill(null);
    setRecoveredReminderPrefill(null);
    setRecoveredFocusPrefill(null);
    setRecoveredCheckinPrefill(null);
    setRecoveredSleepPrefill(null);
    setRecoveredFitnessPrefill(null);
    setFitnessDraftDiscardPrefill(null);
    setFitnessRuntimePrefill(null);
    setFitnessDraftRestorePrefill(null);
    setFitnessCurrentSetEditPrefill(null);
    setFitnessSetupStartPrefill(null);
    setFitnessCurrentSetCompletionPrefill(null);
    setFitnessSavedPlanPreparePrefill(null);
    setFitnessWorkoutFinishPrefill(null);
    setFitnessRestSkipPrefill(null);
    setRecoveredBodyHealthPrefill(null);
    setNutritionMealPrefill(null); nutritionMealActor.current = null; nutritionMealLiveOrigins.current.clear();
    setNutritionHydrationPrefill(null); nutritionHydrationActor.current = null; nutritionHydrationLiveOrigins.current.clear();
    setLanguagePrefill(null); languageActor.current = null; languageLiveOrigins.current.clear();
    setLanguageClassPrefill(null); languageClassActor.current = null; languageClassLiveOrigins.current.clear();
    setLanguageTutorPrefill(null); languageTutorActor.current = null; languageTutorLiveOrigins.current.clear();
    brainNoteLiveOrigins.current.clear(); setBrainHandoffPrefill(null); brainHandoffActor.current = null; brainHandoffLiveOrigins.current.clear();
    setNutritionGoalsPrefill(null); nutritionGoalsActor.current = null; nutritionGoalsLiveOrigins.current.clear();
    setFitnessCuratedPlanPrefill(null); fitnessCuratedPlanActor.current = null; fitnessCuratedPlanLiveOrigins.current.clear();
          setIsLoading(false);
          stopStreamTtsRef.current();
          streamGoIdleRef.current();
        }
      }
    };
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => applyAuthSession(session));
    // Initial reads may settle after a newer synchronous auth event; never adopt that stale actor.
    if (streamState.authScope) {
      const revision = streamState.authScope.revision();
      void supabase.auth.getSession().then(result => {
        if (streamState.mounted && streamState.authScope.revision() === revision) {
          applyAuthSession(result.error ? null : result.data.session);
        }
      }).catch(error => {
        if (streamState.mounted && streamState.authScope.revision() === revision) {
          console.warn("[MirrorChat] Initial auth session unavailable", error); applyAuthSession(null);
        }
      });
    }
    return () => {
      streamState.speechMetrics?.discard();
        streamState.progressiveSpeechMetrics?.discard();
      streamState.mounted = false;
      streamState.authScope?.invalidate();
      cancelVoiceRef.current(false);
      historyPaging.request++;
      transcriptPaging.request++;
      projectLoads.request++;
      invalidateMirrorActionStream(streamState);
      subscription.unsubscribe();
    };
  }, []);

  // ── Nota anexada pelo "Enviar ao Espelho" (Notas → /mirror) ──────────────
  // Notes.tsx navegava para cá com `state: { noteContext: {...} }` desde
  // sempre, e esta tela NUNCA importou useLocation: o conteúdo da nota morria
  // na fronteira da navegação. O botão carimbava `is_sent_to_mirror = true`,
  // trocava o label para "enviada", e nada tinha sido enviado — a chave i18n
  // "mirror.noteContext.label" existia nos seis idiomas sem um único leitor.
  //
  // Consertar isto é o que dá sentido ao flag: `is_sent_to_mirror` só pode
  // valer como sinal de prioridade no contexto (ver _shared/notesContext.ts,
  // boostSentToMirror) depois que apertar o botão de fato manda a nota.
  const location = useLocation();


  useEffect(() => {
    if (live || moduleContext || !location.state || typeof location.state !== "object" || Array.isArray(location.state)) return;
    const state = location.state as Record<string, unknown>;
    const id = state.liveReviewDraftId;
    if (typeof id !== "string" || !/^[0-9a-f-]{36}$/iu.test(id)) return;
    const actor = actionResultStreamRef.current.authScope.current();
    if (!actor) return;
    const draft = mirrorChannelReviewDrafts.take(id, actor);
    const remaining = { ...state };
    delete remaining.liveReviewDraftId;
    navigate(location.pathname, { replace: true, state: remaining });
    // Only prefill. The existing send button starts a fresh authenticated turn.
    if (draft !== null) setInput(draft);
  }, [live, moduleContext, location.state, location.pathname, captureAuthEpoch, navigate]);
  const [attachedNote, setAttachedNote] = useState<string | null>(null);
  // Espelho síncrono do estado para sendMessage ler o valor corrente mesmo
  // quando chamado de um callback capturado (caminho de voz), sem depender de
  // updater de setState — CLAUDE.md §11.
  const attachedNoteRef = useRef<string | null>(null);
  attachedNoteRef.current = attachedNote;
  const [attachedGoal, setAttachedGoal] = useState<AttachedGoalContext | null>(null);
  const attachedGoalRef = useRef(attachedGoal); attachedGoalRef.current = attachedGoal;
  const [recoveredGoalPrefill, setRecoveredGoalPrefill] = useState<GoalActionPrefill | null>(null);
  const [recoveredTaskPrefill, setRecoveredTaskPrefill] = useState<TaskActionPrefill | null>(null);
  const [recoveredNotePrefill, setRecoveredNotePrefill] = useState<NoteActionPrefill | null>(null);
  const brainNoteLiveOrigins = useRef(new Map<string, BrainLiveOrigin<BrainNoteProposalArgs>>());
  const [brainHandoffPrefill, setBrainHandoffPrefill] = useState<BrainHandoffPrefill | null>(null);
  const brainHandoffActor = useRef<{ action_id: string; isCurrent: () => boolean } | null>(null);
  const brainHandoffLiveOrigins = useRef(new Map<string, BrainLiveOrigin<BrainHandoffArgs>>());
  const [recoveredHabitPrefill, setRecoveredHabitPrefill] = useState<HabitActionPrefill | null>(null);
  const [recoveredReminderPrefill, setRecoveredReminderPrefill] = useState<LocalReminderActionPrefill | null>(null);
  const [recoveredBodyHealthPrefill, setRecoveredBodyHealthPrefill] = useState<BodyHealthActionPrefill | null>(null);
  const [nutritionMealPrefill, setNutritionMealPrefill] = useState<NutritionMealActionPrefill | null>(null);
  const nutritionMealActor = useRef<{ operation_id: string; isCurrent: () => boolean } | null>(null);
  const nutritionMealLiveOrigins = useRef(new Map<string, { args: NutritionMealProposalArgs; isCurrent: () => boolean }>());
  const nutritionMealAcknowledgements = useRef(new Map<string, { promise: Promise<boolean>; resolve: (value: boolean) => void; isCurrent: () => boolean }>());
  const publishNutritionMealReceipt = async (input: MirrorNutritionMealConfirmedReceipt, actorCurrent: () => boolean): Promise<boolean> => {
    // The immutable proof comes from an exact-operation receipt lookup, never the model or draft.
    const receipt = structuredClone(input), actor = nutritionMealActor.current;
    const ownerId = actionResultStreamRef.current.ownerId, originalSession = activeSessionIdRef.current;
    const isCurrent = () => actorCurrent() && !!actor && nutritionMealActor.current === actor && actor.isCurrent()
      && actionResultStreamRef.current.ownerId === ownerId && activeSessionIdRef.current === originalSession;
    if (!ownerId || !originalSession || !isCurrent() || actor?.operation_id !== receipt.operation_id
      || !matchesMirrorNutritionMealReceiptOrigin(receipt, { userId: ownerId, sessionId: originalSession, actionId: receipt.action_id })) return false;
    const id = 'local-nutrition-meal:' + receipt.operation_id;
    if (messages.some(message => message.id === id)) return isCurrent();
    const existing = nutritionMealAcknowledgements.current.get(id); if (existing) return existing.promise;
    let resolve!: (value: boolean) => void;
    const promise = new Promise<boolean>(settle => { resolve = settle; });
    nutritionMealAcknowledgements.current.set(id, { promise, resolve, isCurrent });
    const content = t(receipt.result.unchanged ? 'nutritionMealAction.unchanged' : 'nutritionMealAction.receipt.' + receipt.action);
    // React commit is an acknowledgement of this local factual card, not a durable history write.
    setMessages(previous => !isCurrent() || previous.some(message => message.id === id) ? previous : [...previous, { id, role: 'assistant', content }]);
    return promise;
  };
  useEffect(() => {
    const committed = new Set(messages.map(message => message.id));
    for (const [id, acknowledgement] of nutritionMealAcknowledgements.current) if (!acknowledgement.isCurrent() || committed.has(id)) {
      acknowledgement.resolve(acknowledgement.isCurrent() && committed.has(id)); nutritionMealAcknowledgements.current.delete(id);
    }
  });
  useEffect(() => { const pending = nutritionMealAcknowledgements.current; return () => { for (const entry of pending.values()) entry.resolve(false); pending.clear(); }; }, []);
  const [nutritionHydrationPrefill, setNutritionHydrationPrefill] = useState<NutritionHydrationActionPrefill | null>(null);
  const nutritionHydrationActor = useRef<{ operation_id: string; isCurrent: () => boolean } | null>(null);
  const nutritionHydrationLiveOrigins = useRef(new Map<string, { args: NutritionHydrationProposalArgs; isCurrent: () => boolean }>());
  const nutritionHydrationAcknowledgements = useRef(new Map<string, { promise: Promise<boolean>; resolve: (value: boolean) => void; isCurrent: () => boolean }>());
  const publishNutritionHydrationReceipt = async (input: MirrorNutritionHydrationConfirmedReceipt, actorCurrent: () => boolean): Promise<boolean> => {
    // The immutable proof comes from an exact-operation receipt lookup, never the model or draft.
    const receipt = structuredClone(input), actor = nutritionHydrationActor.current;
    const ownerId = actionResultStreamRef.current.ownerId, originalSession = activeSessionIdRef.current;
    const isCurrent = () => actorCurrent() && !!actor && nutritionHydrationActor.current === actor && actor.isCurrent()
      && actionResultStreamRef.current.ownerId === ownerId && activeSessionIdRef.current === originalSession;
    if (!ownerId || !originalSession || !isCurrent() || actor?.operation_id !== receipt.operation_id
      || !matchesMirrorNutritionHydrationReceiptOrigin(receipt, { userId: ownerId, sessionId: originalSession, actionId: receipt.action_id })) return false;
    const id = 'local-nutrition-hydration:' + receipt.operation_id;
    if (messages.some(message => message.id === id)) return isCurrent();
    const existing = nutritionHydrationAcknowledgements.current.get(id); if (existing) return existing.promise;
    let resolve!: (value: boolean) => void;
    const promise = new Promise<boolean>(settle => { resolve = settle; });
    nutritionHydrationAcknowledgements.current.set(id, { promise, resolve, isCurrent });
    const content = t(receipt.result.unchanged ? 'nutritionHydrationAction.unchanged' : 'nutritionHydrationAction.receipt.' + receipt.action);
    // React commit is an acknowledgement of this local factual card, not a durable history write.
    setMessages(previous => !isCurrent() || previous.some(message => message.id === id) ? previous : [...previous, { id, role: 'assistant', content }]);
    return promise;
  };
  useEffect(() => {
    const committed = new Set(messages.map(message => message.id));
    for (const [id, acknowledgement] of nutritionHydrationAcknowledgements.current) if (!acknowledgement.isCurrent() || committed.has(id)) {
      acknowledgement.resolve(acknowledgement.isCurrent() && committed.has(id)); nutritionHydrationAcknowledgements.current.delete(id);
    }
  });
  useEffect(() => { const pending = nutritionHydrationAcknowledgements.current; return () => { for (const entry of pending.values()) entry.resolve(false); pending.clear(); }; }, []);
  const [languagePrefill, setLanguagePrefill] = useState<LanguageActionPrefill | null>(null);
  const languageActor = useRef<{ operation_id: string; isCurrent: () => boolean } | null>(null);
  const languageLiveOrigins = useRef(new Map<string, { args: LanguageProposalArgs; isCurrent: () => boolean }>());
  const languageAcknowledgements = useRef(new Map<string, { promise: Promise<boolean>; resolve: (value: boolean) => void; isCurrent: () => boolean }>());
  const publishLanguageReceipt = async (input: MirrorLanguageConfirmedReceipt, actorCurrent: () => boolean): Promise<boolean> => {
    // The immutable proof comes from an exact-operation receipt lookup, never the model or draft.
    const receipt = structuredClone(input), actor = languageActor.current;
    const ownerId = actionResultStreamRef.current.ownerId, originalSession = activeSessionIdRef.current;
    const isCurrent = () => actorCurrent() && !!actor && languageActor.current === actor && actor.isCurrent()
      && actionResultStreamRef.current.ownerId === ownerId && activeSessionIdRef.current === originalSession;
    if (!ownerId || !originalSession || !isCurrent() || actor?.operation_id !== receipt.operation_id
      || !matchesMirrorLanguageReceiptOrigin(receipt, { userId: ownerId, sessionId: originalSession, actionId: receipt.action_id })) return false;
    const id = 'local-language:' + receipt.operation_id;
    if (messages.some(message => message.id === id)) return isCurrent();
    const existing = languageAcknowledgements.current.get(id); if (existing) return existing.promise;
    let resolve!: (value: boolean) => void;
    const promise = new Promise<boolean>(settle => { resolve = settle; });
    languageAcknowledgements.current.set(id, { promise, resolve, isCurrent });
    const content = t(receipt.result.unchanged ? 'languageAction.unchanged' : receipt.action === 'delete' ? 'languageAction.receipt.delete' : receipt.request.resource === 'profile' ? 'languageAction.receipt.profile' : 'languageAction.receipt.vocabulary');
    // React commit is an acknowledgement of this local factual card, not a durable history write.
    setMessages(previous => !isCurrent() || previous.some(message => message.id === id) ? previous : [...previous, { id, role: 'assistant', content }]);
    return promise;
  };
  useEffect(() => {
    const committed = new Set(messages.map(message => message.id));
    for (const [id, acknowledgement] of languageAcknowledgements.current) if (!acknowledgement.isCurrent() || committed.has(id)) {
      acknowledgement.resolve(acknowledgement.isCurrent() && committed.has(id)); languageAcknowledgements.current.delete(id);
    }
  });
  useEffect(() => { const pending = languageAcknowledgements.current; return () => { for (const entry of pending.values()) entry.resolve(false); pending.clear(); }; }, []);
  const [languageClassPrefill, setLanguageClassPrefill] = useState<LanguageClassActionPrefill | null>(null);
  const languageClassActor = useRef<{ operation_id: string; isCurrent: () => boolean } | null>(null);
  const languageClassLiveOrigins = useRef(new Map<string, { args: LanguageClassProposalArgs; isCurrent: () => boolean }>());
  const languageClassAcknowledgements = useRef(new Map<string, { promise: Promise<boolean>; resolve: (value: boolean) => void; isCurrent: () => boolean }>());
  const publishLanguageClassReceipt = async (input: MirrorLanguageClassConfirmedReceipt, actorCurrent: () => boolean): Promise<boolean> => {
    // The immutable proof comes from an exact-operation receipt lookup, never the model or draft.
    const receipt = structuredClone(input), actor = languageClassActor.current;
    const ownerId = actionResultStreamRef.current.ownerId, originalSession = activeSessionIdRef.current;
    const isCurrent = () => actorCurrent() && !!actor && languageClassActor.current === actor && actor.isCurrent()
      && actionResultStreamRef.current.ownerId === ownerId && activeSessionIdRef.current === originalSession;
    if (!ownerId || !originalSession || !isCurrent() || actor?.operation_id !== receipt.operation_id
      || !matchesMirrorLanguageClassReceiptOrigin(receipt, { userId: ownerId, sessionId: originalSession, actionId: receipt.action_id })) return false;
    const id = 'local-language-class:' + receipt.operation_id;
    if (messages.some(message => message.id === id)) return isCurrent();
    const existing = languageClassAcknowledgements.current.get(id); if (existing) return existing.promise;
    let resolve!: (value: boolean) => void;
    const promise = new Promise<boolean>(settle => { resolve = settle; });
    languageClassAcknowledgements.current.set(id, { promise, resolve, isCurrent });
    const content = t(receipt.result.unchanged ? 'languageClassAction.unchanged' : 'languageClassAction.receipt.' + receipt.action);
    // React commit is an acknowledgement of this local factual card, not a durable history write.
    setMessages(previous => !isCurrent() || previous.some(message => message.id === id) ? previous : [...previous, { id, role: 'assistant', content }]);
    return promise;
  };
  useEffect(() => {
    const committed = new Set(messages.map(message => message.id));
    for (const [id, acknowledgement] of languageClassAcknowledgements.current) if (!acknowledgement.isCurrent() || committed.has(id)) {
      acknowledgement.resolve(acknowledgement.isCurrent() && committed.has(id)); languageClassAcknowledgements.current.delete(id);
    }
  });
  useEffect(() => { const pending = languageClassAcknowledgements.current; return () => { for (const entry of pending.values()) entry.resolve(false); pending.clear(); }; }, []);
  const [languageTutorPrefill, setLanguageTutorPrefill] = useState<{ language: string; expected_user_id: string; expected_session_id: string; action_id: string } | null>(null);
  const languageTutorActor = useRef<{ action_id: string; isCurrent: () => boolean } | null>(null);
  const languageTutorLiveOrigins = useRef(new Map<string, { args: LanguageTutorHandoffArgs; isCurrent: () => boolean }>());
  const [nutritionGoalsPrefill, setNutritionGoalsPrefill] = useState<NutritionGoalsActionPrefill | null>(null);
  const nutritionGoalsActor = useRef<{ operation_id: string; isCurrent: () => boolean } | null>(null);
  const nutritionGoalsLiveOrigins = useRef(new Map<string, { args: NutritionGoalsProposalArgs; isCurrent: () => boolean }>());
  const nutritionGoalsAcknowledgements = useRef(new Map<string, { promise: Promise<boolean>; resolve: (value: boolean) => void; isCurrent: () => boolean }>());
  const publishNutritionGoalsReceipt = async (input: MirrorNutritionGoalsConfirmedReceipt, actorCurrent: () => boolean): Promise<boolean> => {
    // The immutable proof comes from an exact-operation receipt lookup, never the model or draft.
    const receipt = structuredClone(input), actor = nutritionGoalsActor.current;
    const ownerId = actionResultStreamRef.current.ownerId, originalSession = activeSessionIdRef.current;
    const isCurrent = () => actorCurrent() && !!actor && nutritionGoalsActor.current === actor && actor.isCurrent()
      && actionResultStreamRef.current.ownerId === ownerId && activeSessionIdRef.current === originalSession;
    if (!ownerId || !originalSession || !isCurrent() || actor?.operation_id !== receipt.operation_id
      || !matchesMirrorNutritionGoalsReceiptOrigin(receipt, { userId: ownerId, sessionId: originalSession, actionId: receipt.action_id })) return false;
    const id = 'local-nutrition-goals:' + receipt.operation_id;
    if (messages.some(message => message.id === id)) return isCurrent();
    const existing = nutritionGoalsAcknowledgements.current.get(id); if (existing) return existing.promise;
    let resolve!: (value: boolean) => void;
    const promise = new Promise<boolean>(settle => { resolve = settle; });
    nutritionGoalsAcknowledgements.current.set(id, { promise, resolve, isCurrent });
    const content = t(receipt.result.unchanged ? 'nutritionGoalsAction.unchanged' : 'nutritionGoalsAction.receipt.' + receipt.action);
    // React commit is an acknowledgement of this local factual card, not a durable history write.
    setMessages(previous => !isCurrent() || previous.some(message => message.id === id) ? previous : [...previous, { id, role: 'assistant', content }]);
    return promise;
  };
  useEffect(() => {
    const committed = new Set(messages.map(message => message.id));
    for (const [id, acknowledgement] of nutritionGoalsAcknowledgements.current) if (!acknowledgement.isCurrent() || committed.has(id)) {
      acknowledgement.resolve(acknowledgement.isCurrent() && committed.has(id)); nutritionGoalsAcknowledgements.current.delete(id);
    }
  });
  useEffect(() => { const pending = nutritionGoalsAcknowledgements.current; return () => { for (const entry of pending.values()) entry.resolve(false); pending.clear(); }; }, []);
  const [fitnessCuratedPlanPrefill, setFitnessCuratedPlanPrefill] = useState<FitnessCuratedPlanPrefill | null>(null);
  const fitnessCuratedPlanActor = useRef<{ operation_id: string; action_id: string; isCurrent: () => boolean } | null>(null);
  const fitnessCuratedPlanLiveOrigins = useRef(new Map<string, { args: FitnessCuratedPlanProposalArgs; isCurrent: () => boolean }>());
  const fitnessCuratedPlanAcknowledgements = useRef(new Map<string, { promise: Promise<boolean>; resolve: (value: boolean) => void; isCurrent: () => boolean }>());
  const publishFitnessCuratedPlanReceipt = async (input: MirrorFitnessCuratedPlanConfirmedReceipt, actorCurrent: () => boolean): Promise<boolean> => {
    // The immutable proof comes from an exact-operation receipt lookup, never the model or draft.
    const receipt = structuredClone(input), actor = fitnessCuratedPlanActor.current;
    const ownerId = actionResultStreamRef.current.ownerId, originalSession = activeSessionIdRef.current, authSession = fitnessCuratedPlanAuthSessionRef.current;
    const isCurrent = () => !!authSession && fitnessCuratedPlanAuthSessionRef.current === authSession && actorCurrent() && !!actor && fitnessCuratedPlanActor.current === actor && actor.isCurrent()
      && actionResultStreamRef.current.ownerId === ownerId && activeSessionIdRef.current === originalSession;
    if (!ownerId || !originalSession || !isCurrent() || actor?.operation_id !== receipt.operation_id
      || !matchesMirrorFitnessCuratedPlanReceiptOrigin(receipt, { userId: ownerId, sessionId: originalSession, actionId: receipt.action_id })) return false;
    const id = 'local-fitness-curated-plan:' + receipt.operation_id;
    if (messages.some(message => message.id === id)) return isCurrent();
    const existing = fitnessCuratedPlanAcknowledgements.current.get(id); if (existing) return existing.promise;
    let resolve!: (value: boolean) => void;
    const promise = new Promise<boolean>(settle => { resolve = settle; });
    fitnessCuratedPlanAcknowledgements.current.set(id, { promise, resolve, isCurrent });
    const content = t('fitnessCuratedPlanAction.receipt.create_activate');
    // React commit is an acknowledgement of this local factual card, not a durable history write.
    setMessages(previous => !isCurrent() || previous.some(message => message.id === id) ? previous : [...previous, { id, role: 'assistant', content }]);
    return promise;
  };
  useEffect(() => {
    const committed = new Set(messages.map(message => message.id));
    for (const [id, acknowledgement] of fitnessCuratedPlanAcknowledgements.current) if (!acknowledgement.isCurrent() || committed.has(id)) {
      acknowledgement.resolve(acknowledgement.isCurrent() && committed.has(id)); fitnessCuratedPlanAcknowledgements.current.delete(id);
    }
  });
  useEffect(() => { const pending = fitnessCuratedPlanAcknowledgements.current; return () => { for (const entry of pending.values()) entry.resolve(false); pending.clear(); }; }, []);
  const [recoveredFitnessPrefill, setRecoveredFitnessPrefill] = useState<FitnessActionPrefill | null>(null);
  const [fitnessDraftDiscardPrefill, setFitnessDraftDiscardPrefill] = useState<FitnessDraftDiscardPrefill | null>(null);
  const [fitnessRuntimePrefill, setFitnessRuntimePrefill] = useState<FitnessRuntimeActionPrefill | null>(null);
  const [fitnessDraftRestorePrefill, setFitnessDraftRestorePrefill] = useState<FitnessDraftRestorePrefill | null>(null);
  const [fitnessWorkoutFinishPrefill, setFitnessWorkoutFinishPrefill] = useState<FitnessWorkoutFinishPrefill | null>(null);
  const savedWorkoutFinishAcknowledgements = useRef(new Map<string, { promise: Promise<boolean>; resolve: (accepted: boolean) => void; isCurrent: () => boolean }>());
  const publishSavedWorkoutFinishReceipt = async (receipt: FitnessWorkoutFinishReceipt, isCurrent: () => boolean): Promise<boolean> => {
    const ownerId = actionResultStreamRef.current.ownerId, sessionId = activeSessionIdRef.current;
    if (!isCurrent() || !ownerId || !sessionId || !fitnessWorkoutFinishReceiptMatches(receipt, ownerId, sessionId)) return Promise.resolve(false);
    const confirmed = await confirmMirrorFitnessWorkoutFinishReceipt({ client: supabase, receipt, content: t('fitnessWorkoutFinish.saved'), isCurrent });
    if (!confirmed || !isCurrent() || !fitnessWorkoutFinishReceiptMatches(receipt, ownerId, sessionId)) return false;
    const id = confirmed.id;
    if (messages.some(message => message.id === id)) return Promise.resolve(isCurrent());
    const pending = savedWorkoutFinishAcknowledgements.current.get(id);
    if (pending) return pending.promise;
    let resolve!: (accepted: boolean) => void;
    const promise = new Promise<boolean>(settle => { resolve = settle; });
    savedWorkoutFinishAcknowledgements.current.set(id, { promise, resolve, isCurrent });
    const content = confirmed.content;
    // Server proof authorizes this factual bubble; only its React commit is ACK.
    setMessages(previous => !isCurrent() || previous.some(message => message.id === id) ? previous : [...previous, { id, role: 'assistant', content } as Message]);
    return promise;
  };
  useEffect(() => {
    const committedIds = new Set(messages.map(message => message.id));
    for (const [id, acknowledgement] of savedWorkoutFinishAcknowledgements.current) {
      if (!acknowledgement.isCurrent() || committedIds.has(id)) {
        acknowledgement.resolve(acknowledgement.isCurrent() && committedIds.has(id));
        savedWorkoutFinishAcknowledgements.current.delete(id);
      }
    }
  }, [messages]);
  useEffect(() => { const pending = savedWorkoutFinishAcknowledgements.current; return () => { for (const acknowledgement of pending.values()) acknowledgement.resolve(false); pending.clear(); }; }, []);
  const [fitnessSavedPlanPreparePrefill, setFitnessSavedPlanPreparePrefill] = useState<FitnessSavedPlanPreparePrefill | null>(null);
  const localSavedPlanPrepareAcknowledgements = useRef(new Map<string, { promise: Promise<boolean>; resolve: (accepted: boolean) => void; isCurrent: () => boolean }>());
  const publishLocalSavedPlanPrepareReceipt = (receipt: FitnessSavedPlanPrepareReceipt, isCurrent: () => boolean): Promise<boolean> => {
    const ownerId = actionResultStreamRef.current.ownerId, sessionId = activeSessionIdRef.current;
    if (!isCurrent() || !ownerId || !sessionId || !fitnessSavedPlanPrepareReceiptMatches(receipt, ownerId, sessionId)) return Promise.resolve(false);
    const id = 'local-fitness-saved-plan-prepare:' + receipt.operationId;
    if (messages.some(message => message.id === id)) return Promise.resolve(isCurrent());
    const pending = localSavedPlanPrepareAcknowledgements.current.get(id);
    if (pending) return pending.promise;
    let resolve!: (accepted: boolean) => void;
    const promise = new Promise<boolean>(settle => { resolve = settle; });
    localSavedPlanPrepareAcknowledgements.current.set(id, { promise, resolve, isCurrent });
    const content = tf('fitnessSavedPlanPrepare.localPrepared', { plan: receipt.planName, day: receipt.dayName ?? tf('fitnessSavedPlanPrepare.dayPosition', { day: receipt.dayIndex }) });
    setMessages(previous => !isCurrent() || previous.some(message => message.id === id) ? previous : [...previous, { id, role: 'assistant', content } as Message]);
    return promise;
  };
  useEffect(() => {
    const committedIds = new Set(messages.map(message => message.id));
    for (const [id, acknowledgement] of localSavedPlanPrepareAcknowledgements.current) {
      if (!acknowledgement.isCurrent() || committedIds.has(id)) {
        acknowledgement.resolve(acknowledgement.isCurrent() && committedIds.has(id));
        localSavedPlanPrepareAcknowledgements.current.delete(id);
      }
    }
  }, [messages]);
  useEffect(() => { const pending = localSavedPlanPrepareAcknowledgements.current; return () => { for (const acknowledgement of pending.values()) acknowledgement.resolve(false); pending.clear(); }; }, []);
  const [fitnessRestSkipPrefill, setFitnessRestSkipPrefill] = useState<FitnessRestSkipPrefill | null>(null);
  const localRestSkipAcknowledgements = useRef(new Map<string, { promise: Promise<boolean>; resolve: (accepted: boolean) => void; isCurrent: () => boolean }>());
  const publishLocalRestSkipReceipt = (receipt: FitnessRestSkipReceipt, isCurrent: () => boolean): Promise<boolean> => {
    const ownerId = actionResultStreamRef.current.ownerId, sessionId = activeSessionIdRef.current;
    if (!isCurrent() || !ownerId || !sessionId || !fitnessRestSkipReceiptMatches(receipt, ownerId, sessionId)) return Promise.resolve(false);
    const id = 'local-fitness-rest-skip:' + receipt.operationId;
    if (messages.some(message => message.id === id)) return Promise.resolve(true);
    const pending = localRestSkipAcknowledgements.current.get(id);
    if (pending) return pending.promise;
    let resolve!: (accepted: boolean) => void;
    const promise = new Promise<boolean>(done => { resolve = done; });
    localRestSkipAcknowledgements.current.set(id, { promise, resolve, isCurrent });
    const content = t('fitnessRestSkip.localSkipped');
    // A skipped rest is acknowledged only after a factual local React bubble commits.
    setMessages(previous => !isCurrent() || previous.some(message => message.id === id) ? previous : [...previous, { id, role: 'assistant', content }]);
    return promise;
  };
  useEffect(() => {
    for (const [id, acknowledgement] of localRestSkipAcknowledgements.current) {
      if (!acknowledgement.isCurrent() || messages.some(message => message.id === id)) {
        acknowledgement.resolve(acknowledgement.isCurrent() && messages.some(message => message.id === id));
        localRestSkipAcknowledgements.current.delete(id);
      }
    }
  }, [messages]);
  useEffect(() => { const pending = localRestSkipAcknowledgements.current; return () => { for (const acknowledgement of pending.values()) acknowledgement.resolve(false); pending.clear(); }; }, []);
  const [fitnessCurrentSetCompletionPrefill, setFitnessCurrentSetCompletionPrefill] = useState<FitnessCurrentSetCompletionPrefill | null>(null);
  const localSetCompletionAcknowledgements = useRef(new Map<string, { promise: Promise<boolean>; resolve: (accepted: boolean) => void; isCurrent: () => boolean }>());
  const publishLocalSetCompletionReceipt = (receipt: FitnessCurrentSetCompletionReceipt, isCurrent: () => boolean): Promise<boolean> => {
    const ownerId = actionResultStreamRef.current.ownerId, sessionId = activeSessionIdRef.current;
    if (!isCurrent() || !ownerId || !sessionId || !fitnessCurrentSetCompletionReceiptMatches(receipt, ownerId, sessionId)) return Promise.resolve(false);
    const id = 'local-fitness-set-completion:' + receipt.operationId;
    if (messages.some(message => message.id === id)) return Promise.resolve(true);
    const pending = localSetCompletionAcknowledgements.current.get(id);
    if (pending) return pending.promise;
    let resolve!: (accepted: boolean) => void;
    const promise = new Promise<boolean>(done => { resolve = done; });
    localSetCompletionAcknowledgements.current.set(id, { promise, resolve, isCurrent });
    const content = receipt.timed ? tf('fitnessCurrentSetCompletion.localCompletedTimed', { seconds: receipt.reps }) : t('fitnessCurrentSetCompletion.localCompleted');
    // A declared completion is acknowledged only after a factual local React bubble commits.
    setMessages(previous => !isCurrent() || previous.some(message => message.id === id) ? previous : [...previous, { id, role: 'assistant', content }]);
    return promise;
  };
  useEffect(() => {
    for (const [id, acknowledgement] of localSetCompletionAcknowledgements.current) {
      if (!acknowledgement.isCurrent() || messages.some(message => message.id === id)) {
        acknowledgement.resolve(acknowledgement.isCurrent() && messages.some(message => message.id === id));
        localSetCompletionAcknowledgements.current.delete(id);
      }
    }
  }, [messages]);
  useEffect(() => { const pending = localSetCompletionAcknowledgements.current; return () => { for (const acknowledgement of pending.values()) acknowledgement.resolve(false); pending.clear(); }; }, []);
  const [fitnessSetupStartPrefill, setFitnessSetupStartPrefill] = useState<FitnessSetupStartPrefill | null>(null);
  const localSetupStartAcknowledgements = useRef(new Map<string, { promise: Promise<boolean>; resolve: (accepted: boolean) => void; isCurrent: () => boolean }>());
  const publishLocalSetupStartReceipt = (receipt: FitnessSetupStartReceipt, isCurrent: () => boolean): Promise<boolean> => {
    const ownerId = actionResultStreamRef.current.ownerId, sessionId = activeSessionIdRef.current;
    if (!isCurrent() || !ownerId || !sessionId || !fitnessSetupStartReceiptMatches(receipt, ownerId, sessionId)) return Promise.resolve(false);
    const id = 'local-fitness-setup-start:' + receipt.operationId;
    if (messages.some(message => message.id === id)) return Promise.resolve(true);
    const pending = localSetupStartAcknowledgements.current.get(id);
    if (pending) return pending.promise;
    let resolve!: (accepted: boolean) => void;
    const promise = new Promise<boolean>(done => { resolve = done; });
    localSetupStartAcknowledgements.current.set(id, { promise, resolve, isCurrent });
    const content = receipt.timed ? tf('fitnessSetupStart.localStartedTimed', { seconds: receipt.reps }) : t('fitnessSetupStart.localStarted');
    // Starting is acknowledged only after a factual local React bubble commits.
    setMessages(previous => !isCurrent() || previous.some(message => message.id === id) ? previous : [...previous, { id, role: 'assistant', content }]);
    return promise;
  };
  useEffect(() => {
    for (const [id, acknowledgement] of localSetupStartAcknowledgements.current) {
      if (!acknowledgement.isCurrent() || messages.some(message => message.id === id)) {
        acknowledgement.resolve(acknowledgement.isCurrent() && messages.some(message => message.id === id));
        localSetupStartAcknowledgements.current.delete(id);
      }
    }
  }, [messages]);
  useEffect(() => { const pending = localSetupStartAcknowledgements.current; return () => { for (const acknowledgement of pending.values()) acknowledgement.resolve(false); pending.clear(); }; }, []);
  const [fitnessCurrentSetEditPrefill, setFitnessCurrentSetEditPrefill] = useState<FitnessCurrentSetEditPrefill | null>(null);
  const localSetEditAcknowledgements = useRef(new Map<string, { promise: Promise<boolean>; resolve: (accepted: boolean) => void; isCurrent: () => boolean }>());
  const publishLocalSetEditReceipt = (receipt: FitnessCurrentSetEditReceipt, isCurrent: () => boolean): Promise<boolean> => {
    const ownerId = actionResultStreamRef.current.ownerId, sessionId = activeSessionIdRef.current;
    if (!isCurrent() || !ownerId || !sessionId || !fitnessCurrentSetEditReceiptMatches(receipt, ownerId, sessionId)) return Promise.resolve(false);
    const id = 'local-fitness-current-set-edit:' + receipt.operationId;
    if (messages.some(message => message.id === id)) return Promise.resolve(true);
    const pending = localSetEditAcknowledgements.current.get(id);
    if (pending) return pending.promise;
    let resolve!: (accepted: boolean) => void;
    const promise = new Promise<boolean>(done => { resolve = done; });
    localSetEditAcknowledgements.current.set(id, { promise, resolve, isCurrent });
    const content = t('fitnessCurrentSetEdit.localEdited');
    // Factual editor readback becomes only a committed local React bubble.
    setMessages(previous => !isCurrent() || previous.some(message => message.id === id) ? previous : [...previous, { id, role: 'assistant', content }]);
    return promise;
  };
  useEffect(() => {
    for (const [id, acknowledgement] of localSetEditAcknowledgements.current) {
      if (!acknowledgement.isCurrent() || messages.some(message => message.id === id)) {
        acknowledgement.resolve(acknowledgement.isCurrent() && messages.some(message => message.id === id));
        localSetEditAcknowledgements.current.delete(id);
      }
    }
  }, [messages]);
  useEffect(() => { const pending = localSetEditAcknowledgements.current; return () => { for (const acknowledgement of pending.values()) acknowledgement.resolve(false); pending.clear(); }; }, []);
  const localRestoreAcknowledgements = useRef(new Map<string, { promise: Promise<boolean>; resolve: (accepted: boolean) => void; isCurrent: () => boolean }>());
  const publishLocalRestoreReceipt = (receipt: FitnessDraftRestoreReceipt, isCurrent: () => boolean): Promise<boolean> => {
    const ownerId = actionResultStreamRef.current.ownerId, sessionId = activeSessionIdRef.current;
    if (!isCurrent() || !ownerId || !sessionId || !fitnessDraftRestoreReceiptMatches(receipt, ownerId, sessionId)) return Promise.resolve(false);
    const id = 'local-fitness-draft-restore:' + receipt.operationId;
    if (messages.some(message => message.id === id)) return Promise.resolve(true);
    const pending = localRestoreAcknowledgements.current.get(id);
    if (pending) return pending.promise;
    let resolve!: (accepted: boolean) => void;
    const promise = new Promise<boolean>(done => { resolve = done; });
    localRestoreAcknowledgements.current.set(id, { promise, resolve, isCurrent });
    const content = t('mirror.fitnessDraftRestore.finalLocal');
    // Issued readback is acknowledged only after this local React bubble commits.
    setMessages(previous => !isCurrent() || previous.some(message => message.id === id) ? previous : [...previous, { id, role: 'assistant', content }]);
    return promise;
  };
  useEffect(() => {
    for (const [id, acknowledgement] of localRestoreAcknowledgements.current) {
      if (!acknowledgement.isCurrent() || messages.some(message => message.id === id)) {
        acknowledgement.resolve(acknowledgement.isCurrent() && messages.some(message => message.id === id));
        localRestoreAcknowledgements.current.delete(id);
      }
    }
  }, [messages]);
  useEffect(() => { const pending = localRestoreAcknowledgements.current; return () => { for (const acknowledgement of pending.values()) acknowledgement.resolve(false); pending.clear(); }; }, []);
  const localRuntimeAcknowledgements = useRef(new Map<string, { promise: Promise<boolean>; resolve: (accepted: boolean) => void; isCurrent: () => boolean }>());
  const publishLocalRuntimeReceipt = (receipt: FitnessRuntimeActionReceipt, isCurrent: () => boolean): Promise<boolean> => {
    const ownerId = actionResultStreamRef.current.ownerId, sessionId = activeSessionIdRef.current;
    if (!isCurrent() || !ownerId || !sessionId || !fitnessRuntimeActionReceiptMatches(receipt, ownerId, sessionId)) return Promise.resolve(false);
    const id = 'local-fitness-runtime:' + receipt.operationId;
    if (messages.some(message => message.id === id)) return Promise.resolve(true);
    const pending = localRuntimeAcknowledgements.current.get(id);
    if (pending) return pending.promise;
    let resolve!: (accepted: boolean) => void;
    const promise = new Promise<boolean>(done => { resolve = done; });
    localRuntimeAcknowledgements.current.set(id, { promise, resolve, isCurrent });
    const content = t('fitnessRuntimeAction.' + (receipt.action === 'pause' ? 'localPaused' : 'localResumed'));
    // Issued controller readback becomes a local React bubble only. This path
    // never invokes a DB receipt, mirror_messages insert, provider or navigation.
    setMessages(previous => !isCurrent() || previous.some(message => message.id === id) ? previous : [...previous, { id, role: 'assistant', content }]);
    return promise;
  };
  useEffect(() => {
    for (const [id, acknowledgement] of localRuntimeAcknowledgements.current) {
      if (!acknowledgement.isCurrent() || messages.some(message => message.id === id)) {
        acknowledgement.resolve(acknowledgement.isCurrent() && messages.some(message => message.id === id));
        localRuntimeAcknowledgements.current.delete(id);
      }
    }
  }, [messages]);
  useEffect(() => { const pending = localRuntimeAcknowledgements.current; return () => { for (const acknowledgement of pending.values()) acknowledgement.resolve(false); pending.clear(); }; }, []);
  const localDraftAcknowledgements = useRef(new Map<string, { promise: Promise<boolean>; resolve: (accepted: boolean) => void; isCurrent: () => boolean }>());
  const publishLocalDraftReceipt = (receipt: FitnessDraftDiscardReceipt, isCurrent: () => boolean): Promise<boolean> => {
    if (!isCurrent() || receipt.owner !== actionResultStreamRef.current.ownerId || receipt.sessionId !== activeSessionIdRef.current) return Promise.resolve(false);
    const id = 'local-fitness-draft-discard:' + receipt.operationId;
    if (messages.some(message => message.id === id)) return Promise.resolve(true);
    const pending = localDraftAcknowledgements.current.get(id);
    if (pending) return pending.promise;
    let resolve!: (accepted: boolean) => void;
    const promise = new Promise<boolean>(done => { resolve = done; });
    localDraftAcknowledgements.current.set(id, { promise, resolve, isCurrent });
    const content = t('fitnessDraftDiscard.localAck');
    // Local-only device receipt: never inserted into mirror_messages or sent
    // through a server receipt, model, provider or automatic module navigation.
    setMessages(previous => !isCurrent() || previous.some(message => message.id === id) ? previous : [...previous, { id, role: 'assistant', content }]);
    return promise;
  };
  useEffect(() => {
    for (const [id, acknowledgement] of localDraftAcknowledgements.current) {
      if (!acknowledgement.isCurrent() || messages.some(message => message.id === id)) {
        acknowledgement.resolve(acknowledgement.isCurrent() && messages.some(message => message.id === id));
        localDraftAcknowledgements.current.delete(id);
      }
    }
  }, [messages]);
  useEffect(() => { const pending = localDraftAcknowledgements.current; return () => { for (const acknowledgement of pending.values()) acknowledgement.resolve(false); pending.clear(); }; }, []);
  const [recoveredSleepPrefill, setRecoveredSleepPrefill] = useState<SleepActionPrefill | null>(null);
  const [recoveredCheckinPrefill, setRecoveredCheckinPrefill] = useState<CheckinActionPrefill | null>(null);
  const [recoveredFocusPrefill, setRecoveredFocusPrefill] = useState<FocusActionPrefill | null>(null);
  const [recoveredAgendaPrefill, setRecoveredAgendaPrefill] = useState<LocalAgendaActionPrefill | null>(null);

  // Modo Professor (language_tutor) Live caption: CURRENT turn only — the
  // tutor's target line + its [[tr]] translation, replacing each turn (never an
  // accumulated transcript, which would recreate the chat panel). Only computed
  // for the language tutor; the plain Espelho Live stays caption-free.
  const tutorCaption = useMemo(() => {
    if (!live || moduleContext !== "language_tutor") return null;
    const lastAssistant = [...messages].reverse().find(
      (m) => m.role === "assistant" && m.content && m.content.trim().length > 0,
    );
    if (!lastAssistant) return null;
    // Drop the [[learned:WORD]] success marker before splitting — it's an
    // app-only signal, never shown or spoken.
    const raw = lastAssistant.content.replace(/\[\[learned:[^\]]*\]\]/gi, "");
    const i = raw.indexOf("[[tr]]");
    const spoken = (i >= 0 ? raw.slice(0, i) : raw).trim();
    const translation = i >= 0 ? raw.slice(i + 6).trim() : "";
    if (!spoken) return null;
    return { spoken, translation };
  }, [live, moduleContext, messages]);

  // Modo Professor: words already credited this live session, so the same
  // [[learned:WORD]] marker repeated across turns raises mastery only once.
  const learnedThisSessionRef = useRef<Set<string>>(new Set());
  // Clarification ladder (capture-never-freeze): how many consecutive turns came
  // back degenerate (no text + no proposal). The COUNT is deterministic here in
  // code — Sonnet can't be trusted to count (CLAUDE.md 4.3). The prompt teaches
  // the Espelho to ASK rather than go silent; this caps the asking at 3 then
  // gives up gracefully. Reset to 0 on any non-empty turn.
  const clarifyAttemptsRef = useRef(0);
  const [showConversation, setShowConversation] = useState(false);
  const [entered, setEntered] = useState(false);
  // Volatile dismiss for the "This isn't you" avatar prompt — by design no
  // localStorage / sessionStorage / DB persistence, so the card returns on
  // every fresh login (or page reload) until the user actually creates an
  // avatar (server-side `hasAvatar` flips true, gating the render).
  const [avatarPromptDismissed, setAvatarPromptDismissed] = useState(false);
  const [sessionId, setSessionId] = useState<string | null>(null);
  // Updated at each session transition, before React commits. A late SSE
  // response must compare against the conversation actually active now.
  const activeSessionIdRef = useRef<string | null>(null);
  const [recoveredFinance, setRecoveredFinance] = useState<{prefill:FinanceActionPrefill;isCurrent:()=>boolean} | null>(null);
  const acknowledgeCapture: NonNullable<UseModuleCaptureOptions["onCaptured"]> = (tool, receipt) => {
      if (!["propose_connected_message_action","propose_connected_task_action","propose_file_action","propose_finance_action","propose_finance_log","propose_email_action","propose_calendar_action","propose_contact_action","propose_people_task_action","propose_goal","propose_goal_action","create_task","propose_local_task_action","create_note","propose_note_action","propose_brain_note_action","create_habit","propose_habit_action","propose_habit_log","propose_agenda_event","propose_local_agenda_action","propose_reminder_action","propose_reminder_preferences_action","propose_focus_log","propose_focus_action","propose_focus_timer_action","propose_checkin_action","propose_sleep_log","propose_sleep_action","propose_fitness_action","propose_body_log","propose_body_health_action"].includes(tool) || !receipt) return Promise.resolve(false);
      const state = actionResultStreamRef.current;
      const origin = { authEpoch: state.authEpoch, sessionEpoch: state.sessionEpoch, request: state.request };
      const isCurrent = () => state.mounted && !state.sessionTransition &&
        state.ownerId === receipt.userId && activeSessionIdRef.current === receipt.sessionId &&
        state.authEpoch === origin.authEpoch && state.sessionEpoch === origin.sessionEpoch && state.request === origin.request;
      if (!isCurrent()) return Promise.resolve(false);
      const receiptOrigin = {userId:receipt.userId,sessionId:receipt.sessionId??"",actionId:receipt.action_id};
      const acknowledgement = tool === "propose_connected_message_action" && matchesMirrorConnectedMessageReceiptOrigin(receipt,receiptOrigin)
        ? confirmMirrorConnectedMessageReceipt({client:supabase,receipt,language:lang,isCurrent})
        : tool === "propose_connected_task_action" && matchesMirrorConnectedTaskReceiptOrigin(receipt,receiptOrigin)
        ? confirmMirrorConnectedTaskReceipt({client:supabase,receipt,language:lang,isCurrent})
        : tool === "propose_file_action" && matchesMirrorFileReceiptOrigin(receipt,receiptOrigin)
        ? confirmMirrorFileReceipt({client:supabase,receipt,language:lang,isCurrent})
        : (tool === "propose_finance_action" || tool === "propose_finance_log") && matchesMirrorFinanceReceiptOrigin(receipt,receiptOrigin)
        ? confirmMirrorFinanceReceipt({client:supabase,receipt,language:lang,isCurrent})
        : tool === "propose_email_action" && matchesMirrorEmailReceiptOrigin(receipt,receiptOrigin)
        ? confirmMirrorEmailReceipt({client:supabase,receipt,language:lang,isCurrent})
        : tool === 'propose_calendar_action' && matchesAppleMirrorReceiptOrigin(receipt,receiptOrigin)
          ? confirmAppleMirrorReceipt({client:supabase,receipt,language:lang,isCurrent})
        : tool === "propose_calendar_action" && matchesMirrorCalendarReceiptOrigin(receipt,receiptOrigin)
          ? confirmMirrorCalendarReceipt({client:supabase,receipt,language:lang,isCurrent})
          : tool === "propose_contact_action" && matchesMirrorContactReceiptOrigin(receipt,receiptOrigin)
            ? confirmMirrorContactReceipt({client:supabase,receipt,language:lang,isCurrent})
            : tool === "propose_people_task_action" && matchesMirrorExternalTaskReceiptOrigin(receipt,receiptOrigin)
              ? confirmMirrorExternalTaskReceipt({client:supabase,receipt,language:lang,isCurrent})
              : (tool === "create_task" || tool === "propose_local_task_action") && matchesMirrorTaskReceiptOrigin(receipt,receiptOrigin)
                ? confirmMirrorTaskReceipt({client:supabase,receipt,language:lang,isCurrent})
              : (tool === "create_note" || tool === "propose_note_action" || tool === "propose_brain_note_action") && matchesMirrorNoteReceiptOrigin(receipt,receiptOrigin)
                && (tool === "propose_brain_note_action" ? !!receipt.brain_kind : receipt.brain_kind === undefined)
                ? confirmMirrorNoteReceipt({client:supabase,receipt,language:lang,isCurrent})
              : (tool === "create_habit" || tool === "propose_habit_action" || tool === "propose_habit_log") && matchesMirrorHabitReceiptOrigin(receipt,receiptOrigin)
                ? confirmMirrorHabitReceipt({client:supabase,receipt,language:lang,isCurrent})
              : (tool === "propose_body_log" || tool === "propose_body_health_action") && matchesMirrorBodyHealthReceiptOrigin(receipt,receiptOrigin)
                ? confirmMirrorBodyHealthReceipt({client:supabase,receipt,language:lang,isCurrent})
              : tool === "propose_fitness_action" && matchesMirrorFitnessReceiptOrigin(receipt,receiptOrigin)
                ? confirmMirrorFitnessReceipt({client:supabase,receipt,language:lang,isCurrent})
              : (tool === "propose_sleep_log" || tool === "propose_sleep_action") && matchesMirrorSleepReceiptOrigin(receipt,receiptOrigin)
                ? confirmMirrorSleepReceipt({client:supabase,receipt,language:lang,isCurrent})
              : tool === "propose_checkin_action" && matchesMirrorCheckinReceiptOrigin(receipt,receiptOrigin)
                ? confirmMirrorCheckinReceipt({client:supabase,receipt,language:lang,isCurrent})
              : (tool === "propose_focus_log" || tool === "propose_focus_action" || tool === "propose_focus_timer_action") && matchesMirrorFocusReceiptOrigin(receipt,receiptOrigin)
                ? confirmMirrorFocusReceipt({client:supabase,receipt,language:lang,isCurrent})
              : (tool === "propose_reminder_action" || tool === "propose_reminder_preferences_action") && matchesMirrorReminderReceiptOrigin(receipt,receiptOrigin)
                ? confirmMirrorReminderReceipt({client:supabase,receipt,language:lang,isCurrent})
              : (tool === "propose_agenda_event" || tool === "propose_local_agenda_action") && matchesMirrorAgendaReceiptOrigin(receipt,receiptOrigin)
                ? confirmMirrorAgendaReceipt({client:supabase,receipt,language:lang,isCurrent})
              : (tool === "propose_goal" || tool === "propose_goal_action") && matchesMirrorGoalReceiptOrigin(receipt,receiptOrigin)
                ? confirmMirrorGoalReceipt({client:supabase,receipt,language:lang,isCurrent}) : Promise.resolve(null);
      return acknowledgement.then(message => {
        if (!message || !isCurrent()) return false;
        setMessages(previous => !isCurrent() || previous.some(item => item.id === message.id)
          ? previous : [...previous, { id: message.id, role: "assistant", content: message.content }]);
        return true;
      }).catch(() => {
        // The provider write remains confirmed even if recording its
        // acknowledgement is temporarily unavailable. Never repeat it here.
        console.warn("[MirrorChat] Connector receipt acknowledgement unavailable");
        return false;
      });
    };
  const acknowledgeFileEdit=async(receipt:MirrorFileEditReceiptReference,callerCurrent:()=>boolean)=>{
    const state=actionResultStreamRef.current,origin={authEpoch:state.authEpoch,sessionEpoch:state.sessionEpoch,request:state.request};
    const isCurrent=()=>callerCurrent()&&state.mounted&&!state.sessionTransition&&state.ownerId===receipt.userId
      &&activeSessionIdRef.current===receipt.sessionId&&state.authEpoch===origin.authEpoch
      &&state.sessionEpoch===origin.sessionEpoch&&state.request===origin.request;
    if(!isCurrent())return false;
    const message=await confirmMirrorFileEditReceipt({client:supabase,receipt,language:lang,isCurrent});
    if(!message||!isCurrent())return false;
    setMessages(previous=>!isCurrent()||previous.some(item=>item.id===message.id)?previous:[...previous,{id:message.id,role:"assistant",content:message.content}]);
    return true;
  };
  const capture = useModuleCapture({ ownerId: captureOwnerId, sessionId, getRequestId:()=>actionResultStreamRef.current.request, onCaptured: acknowledgeCapture });
  // A first send creates its session while awaiting the server. Use the
  // router for the current render only after the request's origin guard;
  // the router captured before session creation is deliberately obsolete.
  const captureRef = useRef(capture);
  captureRef.current = capture;

  // Escalada para o Welfare Officer. `isResident` sai do claim do JWT — o app
  // não tinha NENHUMA noção de organização antes disto, e continua não tendo
  // além deste booleano. Usuário B2C comum nunca vê nada disto.
  const orgMembership = useOrgMembership();
  const [welfareOpen, setWelfareOpen] = useState(false);
  const [welfareSent, setWelfareSent] = useState(false);

  // Mirror hub nav drawer — the hamburger overlay that descends over the
  // (dimmed) avatar on /mirror. Never shown in Live (presence/voice-only).
  const [navOpen, setNavOpen] = useState(false);
  const [navModulesOpen, setNavModulesOpen] = useState(false);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (live || params.get("menu") !== "modules") return;
    setNavModulesOpen(true);
    setNavOpen(true);
    params.delete("menu");
    const search = params.toString();
    navigate(location.pathname + (search ? "?" + search : ""), { replace: true, state: location.state });
  }, [live, location.pathname, location.search, location.state, navigate]);
  // History
  const [showHistory, setShowHistory] = useState(false);
  const [historySessions, setHistorySessions] = useState<HistorySession[]>([]);
  const [viewingSessionId, setViewingSessionId] = useState<string | null>(null);
  const [viewingMessages, setViewingMessages] = useState<Message[]>([]);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [hasMoreHistory, setHasMoreHistory] = useState(false);
  const [historyLoadError, setHistoryLoadError] = useState<"page" | "preview" | null>(null);
  const historyPagingRef = useRef({ request: 0, loading: false, retryAppend: false, ownerId: null as string | null, cursor: null as MirrorHistoryCursor | null });
  const [loadingEarlierMessages, setLoadingEarlierMessages] = useState(false);
  const [loadingSessionId, setLoadingSessionId] = useState<string | null>(null);
  const [hasEarlierMessages, setHasEarlierMessages] = useState(false);
  const [earlierLoadError, setEarlierLoadError] = useState(false);
  const transcriptPagingRef = useRef({ request: 0, loading: false, ownerId: null as string | null, sessionId: null as string | null, previousSessionId: null as string | null, cursor: null as MirrorMessageCursor | null });
  const earlierScrollAnchorRef = useRef<{ sessionId: string; height: number; top: number } | null>(null);
  const [confirmDeleteId, setConfirmDeleteId] = useState<string | null>(null);
  const [menuOpenId, setMenuOpenId] = useState<string | null>(null);
  const [renamingId, setRenamingId] = useState<string | null>(null);
  const [renameValue, setRenameValue] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [movingSessionId, setMovingSessionId] = useState<string | null>(null);
  const [longPressIdx, setLongPressIdx] = useState<number | null>(null);
  const longPressTimerRef = useRef<number | null>(null);

  // Projects
  const [projects, setProjects] = useState<Project[]>([]);
  const [loadingProjects, setLoadingProjects] = useState(false);
  const projectsLoadRef = useRef({ request: 0 });
  const [expandedProjectId, setExpandedProjectId] = useState<string | null>(null);
  const [creatingProject, setCreatingProject] = useState(false);
  const [newProjectName, setNewProjectName] = useState("");
  const [projectMenuOpenId, setProjectMenuOpenId] = useState<string | null>(null);
  const [renamingProjectId, setRenamingProjectId] = useState<string | null>(null);
  const [renameProjectValue, setRenameProjectValue] = useState("");
  const [changingColorProjectId, setChangingColorProjectId] = useState<string | null>(null);

  // Nutrition photo attach (Mirror): camera → nutrition-photo-analyze →
  // NutritionLogModal (source 'photo'), the same modal the voice flow uses.
  const photoInputRef = useRef<HTMLInputElement>(null);
  const [photoPrefill, setPhotoPrefill] = useState<NutritionPrefill | null>(null);
  const { analyzePhoto, isAnalyzing: isAnalyzingPhoto } = useNutritionPhotoAnalyze();

  // Camada de INPUT (F1) — anexo de ARQUIVO (imagem/PDF/planilha) para o
  // Espelho Executor. Convive com a câmera da Nutrição acima e não a substitui:
  // aquele botão roteia para nutrition-photo-analyze (refeição), este alimenta
  // o turno de conversa. Dois destinos diferentes, dois botões.
  const attachInputRef = useRef<HTMLInputElement>(null);
  const attachments = useExecutorAttachments();
  const { composerEmpty: reviewComposerEmpty, composerRevision: reviewAttachmentsRevision, stageReferences: stageWhatsAppReview } = attachments;
  useConnectedFileImport(attachments.attach);
  const reviewComposerBusyRef = useRef(false);
  reviewComposerBusyRef.current = isLoading || isAnalyzingPhoto || !!attachedNoteRef.current || !!attachedGoalRef.current ||
    !!voiceCaptureRef.current || actionResultStreamRef.current.sessionTransition;
  useEffect(() => {
    if (live || moduleContext || !location.search) return;
    const id = whatsappReviewMessageId(location.search);
    const scope = actionResultStreamRef.current.authScope, lease = scope.capture();
    if (!id || !lease) return;
    const draftVersion = reviewComposerVersionRef.current, chipsVersion = reviewAttachmentsRevision();
    const mirrorSessionEpoch = actionResultStreamRef.current.sessionEpoch;
    let mounted = true;
    void loadMirrorWhatsAppReviewStage({
      messageId: id, scope, lease,
      isMounted: () => mounted && actionResultStreamRef.current.mounted,
      readStage: async (messageId, accessToken) => {
        const result = await supabase.functions.invoke("mirror-chat", {
          body: { promptType: "whatsapp_review", messageId },
          headers: { Authorization: "Bearer " + accessToken },
        });
        return result.error ? null : result.data?.stage;
      },
    }).then(stage => {
      if (!mounted || !scope.isCurrent(lease)) return;
      if (stage === null) toast.error(t("mirror.channel.reviewUnavailable"));
      else if (reviewComposerDraftRef.current.trim() || reviewComposerBusyRef.current || !reviewComposerEmpty() ||
        reviewComposerVersionRef.current !== draftVersion || reviewAttachmentsRevision() !== chipsVersion ||
        actionResultStreamRef.current.sessionEpoch !== mirrorSessionEpoch)
        toast.info(t("mirror.channel.reviewBusy"));
      else if (!stageWhatsAppReview(stage, scope, lease)) toast.error(t("mirror.channel.reviewUnavailable"));
      else { reviewComposerDraftRef.current = stage.text; setInput(stage.text); }
      const search = new URLSearchParams(location.search);
      search.delete(WHATSAPP_REVIEW_PARAM);
      navigate({ pathname: location.pathname, search: search.toString(), hash: location.hash }, { replace: true, state: location.state });
    });
    return () => { mounted = false; };
  }, [live, moduleContext, location.search, location.pathname, location.hash, location.state, captureAuthEpoch, navigate, t,
    reviewComposerEmpty, reviewAttachmentsRevision, stageWhatsAppReview]);


  // Primeira troca completa da sessão. Calculado AQUI, e não junto do render,
  // porque `useWaSoftAsk` é hook e não pode ficar atrás dos early returns que
  // existem mais abaixo (premiumRedirect). Mesma condição que alimenta o push
  // soft-ask — de propósito: os dois disputam exatamente este instante, e o
  // árbitro só é honesto se ler o mesmo sinal.
  const firstExchangeComplete =
    !isLoading &&
    messages.some((m) => m.role === "user") &&
    messages.some((m) => m.role === "assistant" && m.content.trim().length > 0);

  // ÁRBITRO — a passagem de bastão que faltava.
  //
  // O push soft-ask e o chip de WhatsApp querem o mesmo instante, e no D0 os
  // dois SEMPRE colidem. A versão anterior resolvia isso dando o dia inteiro ao
  // push: o chip lia `push_opt_in` uma vez, na montagem, onde todo usuário novo
  // é NULL, e nada nesta sessão relia. Ceder a vez virava ceder para sempre —
  // 27 eventos / 21 usuários de treatment bloqueados, zero liberados.
  //
  // Agora o push avisa quando termina e o chip entra em seguida, NA MESMA
  // SESSÃO. É o que os dados pedem: 82,5% dos vínculos acontecem na primeira
  // hora, então "espera a próxima sessão" era, na prática, "não acontece".
  const [pushSettled, setPushSettled] = useState(false);
  const waSoftAsk = useWaSoftAsk(firstExchangeComplete, pushSettled);

  // Proposta de integração — porta (a) de "o Espelho ensina o app".
  //
  // Fica atrás do MESMO gate do soft-ask (`firstExchangeComplete`): só depois
  // de a pessoa ter trocado ao menos uma mensagem. Propor antes disso seria
  // um banner com cara de Espelho.
  //
  // Só um dos dois chips aparece por vez — ver a condição de render, que dá
  // precedência ao WhatsApp (ele é do D0 e tem janela; a integração pode
  // esperar a próxima conversa).
  const integrationSuggest = useIntegrationSuggestion(firstExchangeComplete);

  // TTS — Fase 5 lip sync. Audio playback + alignment are owned by useVoice
  // (ElevenLabs path A with timestamps). The persistent <audio ref={audioElementRef}/>
  // element below is passed to useVoice as `externalAudioElement` so playback
  // happens on the iOS-unlocked element instead of a `new Audio()` instance
  // that would be blocked by Safari autoplay policy outside the user gesture.
  // Aliased as `tts` because `voice` is already taken by useVoiceInput above.
  const audioElementRef = useRef<HTMLAudioElement>(null);
  const tts = useVoice({ externalAudioElement: audioElementRef.current });
  const { stop: stopTts, speak: speakTts } = tts;
  stopStreamTtsRef.current = stopTts;
  const isSpeaking = tts.isPlaying;
  const [isMuted, setIsMuted] = useState(false);
  const speechTextNodesRef = useRef(new Map<number, HTMLDivElement>());
  actionResultStreamRef.current.speechMetrics?.configure({
    platform: appPlatform(), app_version: APP_VERSION,
    tier: premiumLoading ? "unknown" : isPremium ? "premium" : "free",
    language: lang, network: mirrorSpeechNetwork(), synthetic: false,
  });
  actionResultStreamRef.current.progressiveSpeechMetrics?.configure({
    platform: appPlatform(), app_version: APP_VERSION,
    tier: premiumLoading ? "unknown" : isPremium ? "premium" : "free",
    language: lang, network: mirrorSpeechNetwork(), synthetic: false,
  });
  // React committed the actual assistant text node. SSE arrival/setState is not a DOM timestamp.
  useEffect(() => {
    if (live || !showConversation || showHistory) return;
    for (const message of messages) {
      if (message.role !== "assistant" || !message.speechMeasurement || !message.content.trim()) continue;
      const node = speechTextNodesRef.current.get(message.speechMeasurement);
      if (node?.isConnected && node.textContent?.trim())
        actionResultStreamRef.current.speechMetrics?.committedText(message.speechMeasurement);
    }
  }, [messages, live, showConversation, showHistory]);
  // First-session spoken welcome ("1 tap to wake"). Armed by the welcome effect
  // ONLY on a first-ever visit (PHASE B), reusing the existing welcome-row
  // signal (mirror_messages) — no new flag/column. Consumed once on first tap.
  const [spokenWelcomePending, setSpokenWelcomePending] = useState(false);
  const wokeRef = useRef(false);
  // Permanent Mirror suggestion chips. Armed on EVERY /mirror entry (idle
  // state), gated by the per-user "show_mirror_suggestions" toggle; cleared on
  // the first send (text, voice, or chip) so they never linger into an ongoing
  // conversation. `suggestions` holds the 3 rotated i18n keys for this entry
  // (see @/lib/mirrorPrompts). Replaces the old first-session-only chips —
  // decoupled from entry_intent (the 30 concrete prompts self-answer via tools,
  // so they send as plain messages, no opening-turn play).
  const [suggestionsArmed, setSuggestionsArmed] = useState(false);
  const [suggestions, setSuggestions] = useState<string[]>([]);
  // PR-A F2: alvo do viewer de imagem compartilhado (aberto pela thumbnail
  // inline da bolha).
  const [imageView, setImageView] = useState<ImageViewTarget | null>(null);
  // Denuncia de conteudo de IA: a bolha denunciada some da thread e CONTINUA
  // sumida depois de fechar e reabrir, porque a fonte do filtro e a tabela
  // content_reports, nao estado local.
  const { isReported } = useReportedContent();
  // P2: bottom-sheet do menu multitarefa do compositor.
  const [composerMenuOpen, setComposerMenuOpen] = useState(false);
  // ========== META_PERSON_LIP_SYNC — restore after May 4 ==========
  // Reason for disabling: AudioContext.createMediaElementSource breaks audio on iOS Safari
  // because AudioContext starts suspended and requires resume() inside a user gesture.
  // Reintroduce when MetaPerson avatar with proper face rigging is activated.
  // const analyserRef = useRef<AnalyserNode | null>(null);
  // const audioContextRef = useRef<AudioContext | null>(null);
  // const mediaSourceRef = useRef<MediaElementAudioSourceNode | null>(null);
  // ========== END META_PERSON_LIP_SYNC ==========

  const inputBarRef = useRef<HTMLDivElement>(null);
  const [inputBarHeight, setInputBarHeight] = useState(88);

  const threadRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    const field = inputRef.current;
    if (!field) return;
    field.style.height = "auto";
    field.style.height = Math.min(120, Math.max(40, field.scrollHeight)) + "px";
  }, [input, showConversation]);

  // Gesto de recolher/devolver a conversa (Rafa 30/08) — a decisão é pura
  // (@/lib/mirrorStageGesture, com teste próprio); aqui só o fio dos toques.
  const pullTrackerRef = useRef<PullTracker>(null);
  const restoreTrackerRef = useRef<{ startY: number } | null>(null);

  // Presence state — single source of truth in useMirrorState
  // ── Group B Mixamo state machine — DISABLED 27/04 ──
  // Reverted after UX validation: animations (Telling A Secret / Talking /
  // thoughtful head shake) didn't read as natural despite the state machine
  // working technically (validated via diagnostic logs in hash 501d121).
  // Code below kept commented (state, audio listeners, setMirrorState calls,
  // useMirrorState arg, MirrorAvatar props) so a future Mixamo set with
  // better assets can re-enable by uncommenting. State machine infra in
  // useMirrorState + AvatarCore stays dormant via backward-compat default.
  // const [mirrorState, setMirrorState] = useState<MirrorAnimationState>("idle"); // DISABLED Group B revert

  const {
    presenceState,
    animationUrl,
    startThinking,
    goIdle,
  } = useMirrorState({
    isVoiceListening: voice.isListening || isTranscribing,
    isTTSSpeaking: isSpeaking,
    // mirrorState, // DISABLED Group B revert
  });
  streamGoIdleRef.current = goIdle;
  const visuals = PRESENCE_STATES[presenceState];
  // No Realtime a presença vem dos eventos do canal de dados (fala do
  // usuário / fala do modelo), não do par Whisper/TTS.
  const livePresence = realtimeLive ? rt.presence : presenceState;

  // Energia na METADE (veredito Rafa 07/08, PR #447): com o orb menor, o vão
  // entre ele e a barra viraria buraco morto no idle. Chips + input + mic
  // sobem este tanto SÓ na composição da energia (superfície energia — sem
  // avatar OU avatar de lado pelo toggle), sem conversa aberta e sem teclado
  // — nos demais estados o cluster volta ao fundo. Avatar (MetaPerson) não é
  // afetado.
  //
  // publishCssVars (fix 66aa9c10): ESTE hook é agora a fonte única de
  // --keyboard-offset/--vv-offset-top no repo — a cópia inline que vivia
  // abaixo (duas fontes do mesmo cálculo) foi removida; o clamp de sanidade
  // e a detecção de fechamento moram no hook, com teste próprio.
  const { isKeyboardOpen } = useKeyboardOffset({ publishCssVars: true });
  const idleInputLift =
    !live && !mirrorShowsAvatar && !showConversation && !isKeyboardOpen ? 64 : 0;
  // O microfone grande pertence SÓ ao modo live (push-to-talk). Em /mirror a
  // tela de ENTRADA já é o layout final (Rafa, 30/08): mic dentro da barra,
  // chips de sugestão e toggle avatar/energia desde o primeiro frame — nada
  // de "tela antiga" que vira a nova no primeiro clique. A capacidade de voz
  // não mudou, só a posição: o botão da barra (#523) é o caminho único de
  // gravação fora do live, então o caso "gravação iniciada no hero" deixou
  // de existir e a condição encolheu junto.
  // No LIVE Realtime o push-to-talk sai de cena: a conversa é contínua e o
  // botão único (começar/encerrar) mora em MirrorLiveControls.
  const heroVoiceVisible = live && !realtimeLive;

  // ── Group B audio listeners — DISABLED 27/04 (Group B revert) ──
  // useEffect(() => {
  //   const audio = audioElementRef.current;
  //   if (!audio) return;
  //   const onPlay = () => setMirrorState("speaking");
  //   const onEndedOrPause = () => setMirrorState("idle");
  //   audio.addEventListener("play", onPlay);
  //   audio.addEventListener("pause", onEndedOrPause);
  //   audio.addEventListener("ended", onEndedOrPause);
  //   return () => {
  //     audio.removeEventListener("play", onPlay);
  //     audio.removeEventListener("pause", onEndedOrPause);
  //     audio.removeEventListener("ended", onEndedOrPause);
  //   };
  // }, []);

  // ── Lifecycle ──

  useEffect(() => {
    const tm = setTimeout(() => setEntered(true), 100);
    return () => clearTimeout(tm);
  }, []);

  // Prevent page crash from unhandled promise rejections (TTS, Supabase, etc.)
  useEffect(() => {
    const handler = (e: PromiseRejectionEvent) => e.preventDefault();
    window.addEventListener("unhandledrejection", handler);
    return () => window.removeEventListener("unhandledrejection", handler);
  }, []);

  // C1 retention loop — when ANY capture confirms (agenda/task/note/nutrition,
  // voice or photo), the confirm modal / chip path emits a recap on the bus.
  // Append it as a subtle assistant-side bubble so the user SEES the Mirror did
  // something real. Ephemeral (not persisted): the record lives in its module
  // table; this is just the in-conversation acknowledgement.
  // Auto-dismiss cancellers for ephemeral recap bubbles (run on unmount). Each
  // bubble schedules its OWN removal via the shared primitive — this is a
  // multi-item list, so it can't use the single-active useAutoDismiss hook, but
  // it shares the same window (CARD_DISMISS_MS) and timer semantics.
  const recapTimersRef = useRef<Array<() => void>>([]);
  useEffect(() => {
    return subscribeCaptureRecap((recap) => {
      const recapId = `recap-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
      setShowConversation(true);
      setMessages((prev) => [...prev, { role: "assistant", content: "", recap, recapId }]);
      // The ack must never linger or trap the voice loop — auto-remove it shortly.
      const cancel = scheduleAutoDismiss(CARD_DISMISS_MS, () => {
        setMessages((prev) => prev.filter((m) => m.recapId !== recapId));
      });
      recapTimersRef.current.push(cancel);
    });
  }, []);
  useEffect(
    () => () => recapTimersRef.current.forEach((cancel) => cancel()),
    [],
  );

  // isKeyboardOpen na dependência (fix 66aa9c10): quando o teclado abre, o
  // thread encolhe pelo clamp de altura e o scrollTop antigo deixaria a
  // última mensagem cortada — re-ancorar aqui é o que mantém "visível e
  // ancorada na última mensagem enquanto se digita".
  useEffect(() => {
    const frame = window.requestAnimationFrame(() => {
      if (threadRef.current) {
        const anchor = earlierScrollAnchorRef.current;
        if (anchor && anchor.sessionId === activeSessionIdRef.current) {
          threadRef.current.scrollTop = anchor.top + threadRef.current.scrollHeight - anchor.height;
          earlierScrollAnchorRef.current = null;
        } else {
          threadRef.current.scrollTop = threadRef.current.scrollHeight;
        }
      }
    });
    return () => window.cancelAnimationFrame(frame);
  }, [messages, isLoading, showConversation, isKeyboardOpen, inputBarHeight]);

  // A publicação de --keyboard-offset/--vv-offset-top saiu daqui (fix
  // 66aa9c10): morava uma cópia inline do useKeyboardOffset — duas fontes do
  // mesmo cálculo — e agora vive SÓ no hook (chamado acima com
  // publishCssVars). O que fica nesta página é o que é DELA:
  //
  // Clamp de scroll (24/07, app iOS): o root desta página é fixed inset:0
  // overflow:hidden — o document NUNCA tem overflow, então qualquer
  // window.scrollY > 0 é pan ilegítimo do WKWebView (keyboard avoidance
  // nativo acontece no scroll view e NÃO aparece em vv.offsetTop — o
  // listener do visualViewport não o enxerga). Zera na hora. O thread de
  // mensagens rola em container próprio (threadRef, overflow-y-auto), nunca
  // no window, então não existe scroll legítimo pra brigar; na web scrollY
  // já é sempre 0 e o clamp é no-op.
  useEffect(() => {
    const clampScroll = () => {
      if (window.scrollY !== 0) window.scrollTo(0, 0);
    };
    clampScroll();
    window.addEventListener("scroll", clampScroll);
    return () => {
      window.removeEventListener("scroll", clampScroll);
    };
  }, []);

  // Prefill input from sessionStorage (set by VitalFlow / Progress / QuickCapture)
  useEffect(() => {
    const prefill = sessionStorage.getItem("vyv-prefill");
    if (prefill) {
      setInput(prefill);
      sessionStorage.removeItem("vyv-prefill");
    }
  }, []);

  useEffect(() => {
    const incoming = (location.state as { goalContext?: unknown } | null)?.goalContext;
    if (!incoming || !captureOwnerId) return;
    const goal = ownedGoalContext(incoming, captureOwnerId);
    if (goal) { setAttachedGoal(goal); setShowConversation(true); }
    navigate(location.pathname, { replace: true, state: null });
  }, [location.state, location.pathname, navigate, captureOwnerId]);

  // Anexa a nota que veio de Notas → "Enviar ao Espelho".
  // Limpa o history state em seguida: sem isso um F5 (ou um voltar) re-anexaria
  // a mesma nota indefinidamente, porque o state sobrevive à navegação.
  useEffect(() => {
    const incoming = (location.state as { noteContext?: unknown } | null)?.noteContext;
    if (!incoming || !captureOwnerId || actionResultStreamRef.current.ownerId !== captureOwnerId) return;
    const note = takeOwnedNoteContext(incoming, captureOwnerId);
    if (note) { attachedNoteRef.current = note.content; setAttachedNote(note.content); setShowConversation(true); }
    navigate(location.pathname, { replace: true, state: null });
  }, [location.key, location.state, location.pathname, navigate, captureOwnerId]);

  // Prevent overscroll bounce from jumping the layout
  useEffect(() => {
    document.body.style.overscrollBehavior = "none";
    return () => {
      document.body.style.overscrollBehavior = "";
    };
  }, []);

  // Measure input bar height so conversation panel stays above it
  useEffect(() => {
    const el = inputBarRef.current;
    if (!el) return;
    const ro = new ResizeObserver(() => setInputBarHeight(el.offsetHeight));
    ro.observe(el);
    setInputBarHeight(el.offsetHeight);
    return () => ro.disconnect();
  }, []);

  // ── History helpers ──

  const groupSessionsByDate = (sessions: HistorySession[]) => {
    const now = new Date();
    const todayMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
    const yesterdayMidnight = todayMidnight - 86400000;
    const weekMidnight = todayMidnight - 7 * 86400000;
    const groups: Record<string, HistorySession[]> = { today: [], yesterday: [], lastWeek: [], older: [] };
    for (const s of sessions) {
      // Group by latest activity (updated_at) — falls back to created_at for
      // pre-migration rows where updated_at wasn't populated yet.
      const d = new Date(s.updated_at || s.created_at);
      const dayMs = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
      if (dayMs === todayMidnight) groups.today.push(s);
      else if (dayMs === yesterdayMidnight) groups.yesterday.push(s);
      else if (dayMs >= weekMidnight) groups.lastWeek.push(s);
      else groups.older.push(s);
    }
    return groups;
  };

  const relativeTime = (dateStr: string) => {
    const diffMs = Date.now() - new Date(dateStr).getTime();
    const mins = Math.floor(diffMs / 60000);
    const hours = Math.floor(diffMs / 3600000);
    const days = Math.floor(diffMs / 86400000);
    if (mins < 60) return `${mins}m`;
    if (hours < 24) return `${hours}h`;
    if (days < 7) return `${days}d`;
    return new Date(dateStr).toLocaleDateString(localeTagFor(lang), { month: "short", day: "numeric" });
  };


  useEffect(() => {
    // Only the active capture may update the draft; cancel/auth/session changes
    // must never let a late recognition event restore discarded speech.
    const capture = voiceCaptureRef.current;
    if (VOICE_WHISPER_ENABLED || !capture || capture.stopping) return;
    const state = actionResultStreamRef.current;
    if (state.mounted && state.authEpoch === capture.authEpoch && state.sessionEpoch === capture.sessionEpoch &&
      voiceLegacy.isListening && voiceLegacy.transcript) {
      setInput(capture.draft ? capture.draft + "\n" + voiceLegacy.transcript : voiceLegacy.transcript);
    }
  }, [voiceLegacy.transcript, voiceLegacy.isListening]);

  // Permission failures and browser-initiated SpeechRecognition end events do
  // not call handleVoicePress again. Retire their capture when the hooks settle
  // so the preserved draft remains editable/sendable, instead of staying locked.
  const recoverEndedVoiceCapture = useCallback(() => {
    const capture = voiceCaptureRef.current;
    if (voiceBusy || !capture || capture.starting || capture.stopping || capture.reviewing) return;
    const state = actionResultStreamRef.current;
    if (!state.mounted || state.authEpoch !== capture.authEpoch || state.sessionEpoch !== capture.sessionEpoch) {
      cancelVoiceRef.current(false);
      return;
    }
    const text = VOICE_WHISPER_ENABLED ? "" : voiceLegacy.transcript;
    if (text.trim()) {
      setInput(capture.draft ? capture.draft + "\n" + text : text);
      capture.reviewing = true;
      setVoiceDraftReady(true);
    } else {
      voiceCaptureRef.current = null;
      setVoiceDraftReady(false);
      setInput(capture.draft);
    }
  }, [voiceBusy, voiceLegacy.transcript]);
  useEffect(recoverEndedVoiceCapture, [recoverEndedVoiceCapture]);

  // First-time welcome message — runs once when the user opens /mirror with
  // no prior history in mirror_messages. Inserts a single assistant row
  // (session_id NULL, lazily attached to a real session only when the
  // user sends their first turn). Replaces the deleted WelcomeCard surface
  // with a chat-native greeting that fits the Mirror's voice.
  //
  // Two-phase logic:
  //   PHASE A — load: SELECT existing welcome row (session_id IS NULL,
  //     role=assistant). If it exists (returning visit), load it into
  //     messages state. Without this, returning users with the welcome
  //     row already inserted would see an empty Mirror because nothing
  //     else loads messages at mount.
  //   PHASE B — insert: when no welcome row exists AND total message
  //     count for the user is 0 (no historical conversations either),
  //     insert a fresh welcome row.
  //
  // Both phases flip `setShowConversation(true)` so the conversation
  // panel at MirrorChat.tsx:1960 actually renders the bubble. The panel
  // is gated by `showConversation && (messages.length > 0 || isLoading)`;
  // populating `messages` alone is not enough — the gate must be opened.
  //
  // Idempotent in two layers:
  //   1. welcomeCheckedRef guards against React 18 strict-mode double-mount
  //      and HMR re-runs in dev.
  //   2. The DB-side guard (existing welcome lookup + count check) ensures
  //      we never insert a second welcome row on any future mount.
  //
  // Race acceptance: simultaneous tabs may insert 2 welcomes (single user
  // on mobile, very rare). No UNIQUE constraint added.
  const welcomeCheckedRef = useRef(false);
  useEffect(() => {
    if (welcomeCheckedRef.current) return;
    const state = actionResultStreamRef.current, scope = state.authScope, lease = scope?.capture() ?? null;
    if (scope && !lease) return;
    const authEpoch = state.authEpoch;
    welcomeCheckedRef.current = true;

    let cancelled = false;
    const isCurrentWelcome = () => !cancelled && state.mounted && state.authEpoch === authEpoch && (!scope || scope.isCurrent(lease));
    (async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user || !isCurrentWelcome() || scope && lease?.ownerId !== user.id) return;

        // ── PHASE A — load existing welcome row (session_id IS NULL) ──
        // LOTE 4.2 (05/09): as falas do LIVE nascem com session_id NULL e
        // channel='live' (mirror-live-tick). Sem o filtro, o PRIMEIRO
        // transcript do Espelho falado viraria a "bolha de boas-vindas" de
        // todo usuário estabelecido (4.826 usuários têm a linha de boas-vindas
        // hoje; quem não tem, ganharia uma fala solta no lugar). Pinado em
        // src/test/mirrorLive.test.ts.
        const { data: existingWelcome, error: welcomeSelErr } = await supabase
          .from("mirror_messages")
          .select("id, content")
          .eq("user_id", user.id)
          .is("session_id", null)
          .neq("channel", "live")
          .eq("role", "assistant")
          .order("created_at", { ascending: true })
          .limit(1)
          .maybeSingle();
        if (welcomeSelErr) {
          console.error("[mirror.welcome] welcome lookup failed:", welcomeSelErr);
          return;
        }
        if (!isCurrentWelcome()) return;

        if (existingWelcome) {
          setMessages((prev) => {
            if (!isCurrentWelcome() || prev.length > 0) return prev;
            return [{
              id: existingWelcome.id,
              role: "assistant",
              content: existingWelcome.content,
            }];
          });
          setShowConversation(true);
          return;
        }

        // ── PHASE B — first-ever visit: guard against retroactive insert
        //              into established users (count > 0 means real history
        //              exists in some session, just no NULL-session welcome). ──
        const { count, error: countErr } = await supabase
          .from("mirror_messages")
          .select("id", { count: "exact", head: true })
          .eq("user_id", user.id);
        if (countErr) {
          console.error("[mirror.welcome] count failed:", countErr);
          return;
        }
        if (!isCurrentWelcome() || (count ?? 0) > 0) return;

        // First-session hook: the visible bubble combines the user's NAME with
        // the value-question (mirror.welcome.withName/noName), so the opening —
        // the highest-emotion moment of session 1 — is personal AND says what VYV
        // does. The AUDIO (wakeSpokenWelcome) stays the generic value-question
        // (mirror.spokenWelcome): text and audio share the value-question, the
        // name is the visual extra, so there is no double greeting. Reusing these
        // keys also removes them from the orphan set.
        const { data: profile } = await supabase
          .from("user_profiles")
          .select("first_name")
          .eq("user_id", user.id)
          .maybeSingle();
        if (!isCurrentWelcome()) return;
        const firstName = (profile?.first_name ?? "").trim();
        const content = firstName
          ? tf("mirror.welcome.withName", { name: firstName })
          : t("mirror.welcome.noName");

        const { data: inserted, error: insertErr } = await supabase
          .from("mirror_messages")
          .insert({ user_id: user.id, role: "assistant", content })
          .select("id")
          .single();
        if (insertErr) {
          console.error("[mirror.welcome] insert failed:", insertErr);
          return;
        }
        if (!isCurrentWelcome()) return;

        // First-ever visit → SHOW the welcome bubble (previously suppressed to
        // avoid a text+audio double greeting; the value-question appears in both
        // text and audio, name is the visual extra, so there is no redundancy).
        // The spoken welcome still fires on first tap for AUDIO. Arm the one-tap
        // reply chips + instrument the funnel entry. NEXT open is PHASE A and
        // renders the same persisted (personalized) row — no audio re-fires.
        setMessages((prev) => (!isCurrentWelcome() || prev.length > 0 ? prev : [{
          id: inserted.id,
          role: "assistant",
          content,
        }]));
        setShowConversation(true);
        setSpokenWelcomePending(true);
        analytics.welcomeShown();
      } catch (err) {
        console.error("[mirror.welcome] unexpected:", err);
      }
    })();

    return () => {
      cancelled = true;
    };
    // t intentionally omitted from deps — a language switch mid-session
    // should NOT re-fire the welcome lookup or insert. The text is captured
    // once on first visit in whatever language is active at that moment.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [captureAuthEpoch]);

  // Permanent suggestion chips — armed on EVERY /mirror entry (not just the
  // first session), gated by the per-user show_mirror_suggestions toggle
  // (user_profiles; default ON). The toggle read is defensive: pre-migration
  // the column is absent → PostgREST errors, so we fall back to the localStorage
  // cache written by Settings, then to ON. The rotated trio comes from
  // nextSuggestionTrio() (persisted cursor, never repeats the previous entry).
  const suggestChecked = useRef(false);
  useEffect(() => {
    if (suggestChecked.current) return;
    const state = actionResultStreamRef.current, scope = state.authScope, lease = scope?.capture() ?? null;
    if (scope && !lease) return;
    const authEpoch = state.authEpoch;
    suggestChecked.current = true;
    let cancelled = false;
    const isCurrentSuggestions = () => !cancelled && state.mounted && state.authEpoch === authEpoch && (!scope || scope.isCurrent(lease));
    (async () => {
      // default ON; localStorage cache is the offline/pre-migration fallback.
      let on = localStorage.getItem("vyv_mirror_suggestions_on") !== "false";
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!isCurrentSuggestions() || scope && lease?.ownerId !== user?.id) return;
        if (user) {
          const { data, error } = await supabase
            .from("user_profiles")
            .select("show_mirror_suggestions")
            .eq("user_id", user.id)
            .maybeSingle();
          if (!isCurrentSuggestions()) return;
          if (!error && data && typeof (data as any).show_mirror_suggestions === "boolean") {
            on = (data as any).show_mirror_suggestions;
          }
        }
      } catch {
        /* column may not exist pre-migration → keep localStorage/default ON */
      }
      if (!isCurrentSuggestions() || !on) return;
      setSuggestions(nextSuggestionTrio());
      setSuggestionsArmed(true);
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [captureAuthEpoch]);

  // ── TTS helpers (Fase 5: ElevenLabs via useVoice with alignment) ──

  // Strip markdown chars + collapse newlines + cap to ElevenLabs MAX_TEXT_LENGTH
  // (2500 chars per edge fn). Mirrors the cleaning the legacy mirror-tts
  // OpenAI edge fn did server-side, so the migration preserves UX (no
  // asterisks/hashes read aloud in audio).
  const cleanForTTS = (text: string): string =>
    text
      // language_tutor (Modo Professor): strip the [[learned:WORD]] success
      // marker anywhere it appears — it's an app-only signal, never voiced.
      // No-op for every other caller (marker only emitted by the tutor block).
      .replace(/\[\[learned:[^\]]*\]\]/gi, "")
      // language_tutor (Modo Professor): reply is "<target line>\n[[tr]] <native
      // translation>". The [[tr]] line is caption-only — strip it (and anything
      // after) so TTS speaks ONLY the target line and the ElevenLabs alignment
      // (lip-sync) matches what's voiced. No-op for every other caller.
      .replace(/\[\[tr\]\][\s\S]*$/, "")
      .replace(/[*_#`~]/g, "")
      .replace(/\n+/g, ". ")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 2500);

  const handleStopSpeaking = useCallback(() => {
    actionResultStreamRef.current.progressiveSpeechMetrics?.finishCurrent("stop", "stop");
    actionResultStreamRef.current.speechMetrics?.finishCurrent("stop", "stop");
    speechEpochRef.current++;
    stopTts();
  }, [stopTts]);

  const handleStopResponse = useCallback(() => {
    // Abort this displayed response only. The shared action identity must stay
    // intact so an already approved action can still deliver its receipt.
    actionResultStreamRef.current.progressiveSpeechMetrics?.finishCurrent("stop", "stop");
    actionResultStreamRef.current.speechMetrics?.finishCurrent("stop", "stop");
    actionResultStreamRef.current.controller?.abort();
    actionResultStreamRef.current.controller = null;
    setIsLoading(false);
    speechEpochRef.current++;
    stopTts();
    goIdle();
  }, [stopTts, goIdle]);

  const speakResponse = useCallback(async (text: string, isCurrent: () => boolean = () => true, measurement?: MirrorSpeechMeasurement, manualListen = false) => {
    if (!actionResultStreamRef.current.mounted || !isCurrent() || isMuted || !text?.trim() || measurement && !measurement.canSpeak()) return;
    const scope = actionResultStreamRef.current.authScope, lease = scope?.capture() ?? null;
    if (scope && (!lease || actionResultStreamRef.current.authEpoch !== captureAuthEpoch)) return;
    const authEpoch = actionResultStreamRef.current.authEpoch;
    const ownsSpeech = () => actionResultStreamRef.current.mounted && isCurrent()
      && actionResultStreamRef.current.authEpoch === authEpoch && (!scope || scope.isCurrent(lease));
    const sessionEpoch = actionResultStreamRef.current.sessionEpoch;
    if (manualListen) actionResultStreamRef.current.speechMetrics?.finishCurrent("stop", "superseded");
    const speechMetrics = measurement ?? (manualListen ? actionResultStreamRef.current.speechMetrics?.begin({
      isCurrent: () => ownsSpeech() && actionResultStreamRef.current.sessionEpoch === sessionEpoch,
      visibleTextExpected: false, mode: "manual_listen", trigger: "manual", voiceEnabled: true,
    }) : undefined);
    const canSpeakNow = () => ownsSpeech() && (!speechMetrics || speechMetrics.canSpeak());
    const speechObserver = speechMetrics?.observer;
    actionResultStreamRef.current.progressiveSpeechMetrics?.finishCurrent("stop", "superseded");
    const speechEpoch = ++speechEpochRef.current;
    // This transport cohort is installed only for prepared speech. Closing
    // v1 measurement below never revokes its independent canSpeak permission.
    const progressiveMetrics = speechMetrics ? actionResultStreamRef.current.progressiveSpeechMetrics?.begin(
      () => ownsSpeech() && speechEpochRef.current === speechEpoch,
    ) : undefined;
    const progressiveObserver = progressiveMetrics ? (event: Parameters<typeof progressiveMetrics.observer>[0]) => {
      if (event.stage === "accepted") speechMetrics?.discard();
      progressiveMetrics.observer(event);
    } : undefined;
    stopTts();

    // iOS AVAudioSession unlock — the persistent <audio ref={audioElementRef}/>
    // element below is no longer the TTS player (useVoice owns playback via
    // its own Audio instance), but we keep this SILENT_MP3 trick so the iOS
    // mic-reset hack later in this file still has an unlocked element to
    // touch. Must happen synchronously inside the user gesture.
    const audioEl = audioElementRef.current;
    if (audioEl) {
      audioEl.src = SILENT_MP3;
      try { await audioEl.play(); audioEl.pause(); } catch { /* iOS blocked — continue */ }
    }
    if (!canSpeakNow() || speechEpochRef.current !== speechEpoch) return;

    try {
      let accessToken = lease?.accessToken;
      if (scope && lease) {
        const session = await supabase.auth.getSession();
        if (!canSpeakNow() || session.error || !scope.matchesSession(session.data.session, lease)) return;
        accessToken = session.data.session!.access_token;
      }
      await speakTts(cleanForTTS(text), { language: lang, ...(speechObserver ? { observer: speechObserver, progressive: true } : {}), ...(progressiveObserver ? { progressiveObserver, incrementalAccepted: () => {
        // Intra-clip audio has a separate request-clock diagnostic. Closing these
        // incompatible cohorts does not revoke prepared/receipt permission.
        speechMetrics?.discard(); progressiveMetrics?.discard();
      } } : {}), ...(scope && lease ? { ownerGuard: {
        accessToken: accessToken!, assertCurrent: () => {
          if (!canSpeakNow() || speechEpochRef.current !== speechEpoch) throw new Error("Mirror session changed");
        },
      } } : {}) });
    } catch (err) {
      if (ownsSpeech() && speechEpochRef.current === speechEpoch) speechMetrics?.finish("error", "tts_request");
      console.warn("[TTS] Error:", err);
    }
  }, [isMuted, lang, speakTts, stopTts, captureAuthEpoch]);

  // First-session "1 tap to wake": unlock audio + speak the gender-correct
  // greeting (voice resolved server-side in elevenlabs-tts after #238), then
  // return to ready/idle. Official decision: NO auto-listen — the user taps the
  // mic themselves when ready to speak. Runs once (wokeRef).
  const wakeSpokenWelcome = useCallback(() => {
    if (wokeRef.current) return;
    wokeRef.current = true;
    setSpokenWelcomePending(false);
    // speakResponse owns the iOS unlock + tts.speak; presence flips to
    // "speaking" via isSpeaking, then back to idle/ready when the greeting ends.
    speakResponse(t("mirror.spokenWelcome"));
  }, [speakResponse, t]);

  // ── Session helpers ──

  // SINGLE-FLIGHT (12/06): the only duplicate guard used to be the sessionId
  // STATE — two concurrent sends (tutor auto-kickoff + the user's first
  // speech while the INSERT was still in flight) both passed the null check
  // and each created a row. The shared pool survived via mirrorSession's own
  // module-level inFlight, but the ISOLATED tutor path has no cache by
  // design → two lesson sessions 1.8s apart in prod (0b653e45/dcc02f49, the
  // kickoff orphaned in the first). The ref below holds the in-flight
  // promise so every concurrent caller converges on ONE session, on BOTH
  // paths.
  const sessionPromiseRef = useRef<Promise<string> | null>(null);

  const createSessionIfNeeded = useCallback(async (_firstMsgText?: string): Promise<string> => {
    if (activeSessionIdRef.current) return activeSessionIdRef.current;
    if (sessionPromiseRef.current) return sessionPromiseRef.current;
    const sessionEpoch = actionResultStreamRef.current.sessionEpoch;
    const authEpoch = actionResultStreamRef.current.authEpoch;
    const scope = actionResultStreamRef.current.authScope, lease = scope?.capture() ?? null;
    const isCurrent = () => actionResultStreamRef.current.mounted && actionResultStreamRef.current.sessionEpoch === sessionEpoch
      && actionResultStreamRef.current.authEpoch === authEpoch && (!scope || scope.isCurrent(lease));
    if (!isCurrent()) throw new Error("Mirror session changed");

    const p = (async (): Promise<string> => {
      const {
        data: { user },
        error: userError,
      } = await supabase.auth.getUser();

      if (!isCurrent() || userError || !user || scope && lease?.ownerId !== user.id) throw new Error("User not authenticated");

      // Modo Professor: ISOLATED kind='language_tutor' session — never the
      // shared pool. Pre-fix the tutor's kickoff landed in (or created) the
      // Espelho session and the 6h fallback resumed the lesson row after a
      // reload (prod a8ff8f3a: lesson + Espelho turns interleaved, mirror-chat
      // feeds the FULL session history into the prompt). Gated by the same
      // moduleContext prop as every other tutor path.
      const sid = moduleContext === "language_tutor"
        ? await createIsolatedMirrorSession(user.id)
        : // Shared session cache — see src/lib/mirrorSession.ts. Returns the
          // same session_id Brain mini is using (and reuses recent sessions
          // across page unmount/remount so memory persists turn-to-turn).
          await getOrCreateMirrorSession(user.id);
      if (!actionResultStreamRef.current.mounted ||
        actionResultStreamRef.current.sessionEpoch !== sessionEpoch ||
        actionResultStreamRef.current.authEpoch !== authEpoch) throw new Error("Mirror session changed");
      activeSessionIdRef.current = sid;
      // Publish the new capture origin before a cached SSE can complete in
      // the same React batch. Only new-session creation needs a sync commit.
      flushSync(() => setSessionId(sid));
      return sid;
    })();

    sessionPromiseRef.current = p;
    try {
      return await p;
    } catch (err) {
      // Failed create must not poison future sends — clear so the next send
      // retries instead of awaiting a rejected promise forever.
      if (sessionPromiseRef.current === p) sessionPromiseRef.current = null;
      throw err;
    }
  }, [moduleContext]);

  prepareLiveToolSessionRef.current = async () => {
    const stream = actionResultStreamRef.current, lease = stream.authScope.capture();
    if (!stream.mounted || !lease || !stream.authScope.isCurrent(lease)) return null;
    const session = await createSessionIfNeeded();
    return stream.mounted && stream.authScope.isCurrent(lease) ? session : null;
  };
  const reviewLiveToolInChat = () => {
    const captured = liveToolHandoff, scope = actionResultStreamRef.current.authScope;
    if (!captured || !scope.isCurrent(captured.lease)) return;
    mirrorChannelReviewDrafts.observe(captured.lease);
    const id = mirrorChannelReviewDrafts.stage(captured.handoff, captured.lease);
    if (!id) return;
    // Keep revocation synchronous through the route transition. This observer
    // never awaits the auth client or performs authenticated network work.
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      mirrorChannelReviewDrafts.observe(mirrorAuthIdentity(session));
    });
    const timer = setTimeout(() => mirrorChannelReviewDrafts.discard(id), MIRROR_REVIEW_DRAFT_TTL_MS);
    mirrorChannelReviewDrafts.attachCleanup(id, () => {
      clearTimeout(timer);
      subscription.unsubscribe();
    });
    void rt.end().catch(error => console.warn("[mirror] LIVE review cleanup failed", error));
    navigate("/mirror", { state: { liveReviewDraftId: id } });
  };

  // Voltar ao avatar/energia SEM perder a conversa (Rafa 30/08). NÃO é o
  // resetCurrentConversation abaixo: as mensagens ficam — a conversa só
  // RECOLHE, e volta ao tocar no campo (onFocus/onClick já reabrem) ou ao
  // puxar o palco para cima. Blur + reset das vars seguem o idioma do
  // fechamento por gesto do fix 66aa9c10.
  const returnToStage = useCallback(() => {
    inputRef.current?.blur();
    resetKeyboardCssVars();
    setShowConversation(false);
    goIdle();
  }, [goIdle]);

  const resetCurrentConversation = useCallback(() => {
    setRecoveredHabitPrefill(null);
    setRecoveredAgendaPrefill(null);
    setRecoveredReminderPrefill(null);
    setRecoveredFocusPrefill(null);
    setRecoveredCheckinPrefill(null);
    setRecoveredSleepPrefill(null);
    setRecoveredFitnessPrefill(null);
    setFitnessDraftDiscardPrefill(null);
    setFitnessRuntimePrefill(null);
    setFitnessDraftRestorePrefill(null);
    setFitnessCurrentSetEditPrefill(null);
    setFitnessSetupStartPrefill(null);
    setFitnessCurrentSetCompletionPrefill(null);
    setFitnessSavedPlanPreparePrefill(null);
    setFitnessWorkoutFinishPrefill(null);
    setFitnessRestSkipPrefill(null);
    setRecoveredBodyHealthPrefill(null);
    setNutritionMealPrefill(null); nutritionMealActor.current = null; nutritionMealLiveOrigins.current.clear();
    setNutritionHydrationPrefill(null); nutritionHydrationActor.current = null; nutritionHydrationLiveOrigins.current.clear();
    setLanguagePrefill(null); languageActor.current = null; languageLiveOrigins.current.clear();
    setLanguageClassPrefill(null); languageClassActor.current = null; languageClassLiveOrigins.current.clear();
    setLanguageTutorPrefill(null); languageTutorActor.current = null; languageTutorLiveOrigins.current.clear();
    brainNoteLiveOrigins.current.clear(); setBrainHandoffPrefill(null); brainHandoffActor.current = null; brainHandoffLiveOrigins.current.clear();
    setNutritionGoalsPrefill(null); nutritionGoalsActor.current = null; nutritionGoalsLiveOrigins.current.clear();
    setFitnessCuratedPlanPrefill(null); fitnessCuratedPlanActor.current = null; fitnessCuratedPlanLiveOrigins.current.clear();
    cancelVoiceRef.current(false);
    speechEpochRef.current++;
    actionResultStreamRef.current.speechMetrics?.discard();
    actionResultStreamRef.current.progressiveSpeechMetrics?.discard();
    invalidateMirrorActionStream(actionResultStreamRef.current);
    actionResultStreamRef.current.sessionEpoch++;
    actionResultStreamRef.current.sessionTransition = false;
    historyPagingRef.current.request++;
    historyPagingRef.current.loading = false;
    transcriptPagingRef.current.request++;
    projectsLoadRef.current.request++;
    transcriptPagingRef.current.loading = false;
    transcriptPagingRef.current.cursor = null;
    earlierScrollAnchorRef.current = null;
    setLoadingHistory(false);
    setLoadingProjects(false);
    setLoadingEarlierMessages(false);
    setLoadingSessionId(null);
    setHasEarlierMessages(false);
    setEarlierLoadError(false);
    activeSessionIdRef.current = null;
    setIsLoading(false);
    stopStreamTtsRef.current();
    setMessages([]);
    setInput("");
    setSessionId(null);
    sessionPromiseRef.current = null;
    resetMirrorSession();
    setShowConversation(false);
    setViewingSessionId(null);
    setViewingMessages([]);
    goIdle();
  }, [goIdle]);

  const startNewReflection = useCallback(() => {
    resetCurrentConversation();
    setShowHistory(false);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  }, [resetCurrentConversation]);

  // ── History ──

  const loadHistorySessions = useCallback(async (append = false) => {
    const scope = actionResultStreamRef.current.authScope, lease = scope?.capture() ?? null;
    if (scope && !lease) return;
    const paging = historyPagingRef.current;
    if (append && (paging.loading || !paging.cursor)) return;
    const request = ++paging.request;
    paging.retryAppend = append;
    const authEpoch = actionResultStreamRef.current.authEpoch;
    const cursor = append ? paging.cursor : null;
    const isCurrentHistory = (ownerId?: string) => actionResultStreamRef.current.mounted &&
      actionResultStreamRef.current.authEpoch === authEpoch && paging.request === request &&
      (!scope || scope.isCurrent(lease)) &&
      (!ownerId || actionResultStreamRef.current.ownerId === ownerId);
    paging.loading = true;
    setLoadingHistory(true);
    setHistoryLoadError(null);
    try {
      const { data: { user }, error } = await supabase.auth.getUser();
      if (!isCurrentHistory()) return;
      if (error || !user || !isCurrentHistory(user.id)) throw new Error("History owner unavailable");
      if (append && paging.ownerId !== user.id) return;
      const page = await loadMirrorHistoryPage(supabase, { userId: user.id, cursor, pageSize: 20 });
      if (!isCurrentHistory(user.id)) return;
      paging.ownerId = user.id;
      paging.cursor = page.nextCursor;
      setHasMoreHistory(page.hasMore);
      setHistoryLoadError(page.previewUnavailable ? "preview" : null);
      setHistorySessions(previous => {
        if (!isCurrentHistory(user.id)) return previous;
        if (!append) return page.sessions;
        const existing = new Set(previous.map(session => session.id));
        return [...previous, ...page.sessions.filter(session => {
          if (existing.has(session.id)) return false;
          existing.add(session.id);
          return true;
        })];
      });
    } catch (error) {
      if (!isCurrentHistory()) return;
      console.error("loadHistorySessions error:", error);
      setHistoryLoadError("page");
    } finally {
      if (isCurrentHistory()) {
        paging.loading = false;
        setLoadingHistory(false);
      }
    }
  }, []);

  // Read only the latest page before activating a historical conversation.
  // The helper validates the session owner before loading any transcript.
  const loadSessionMessages = async (sid: string): Promise<boolean> => {
    const scope = actionResultStreamRef.current.authScope, lease = scope?.capture() ?? null;
    if (scope && !lease) return false;
    setRecoveredHabitPrefill(null);
    setRecoveredAgendaPrefill(null);
    setRecoveredReminderPrefill(null);
    setRecoveredFocusPrefill(null);
    setRecoveredCheckinPrefill(null);
    setRecoveredSleepPrefill(null);
    setRecoveredFitnessPrefill(null);
    setFitnessDraftDiscardPrefill(null);
    setFitnessRuntimePrefill(null);
    setFitnessDraftRestorePrefill(null);
    setFitnessCurrentSetEditPrefill(null);
    setFitnessSetupStartPrefill(null);
    setFitnessCurrentSetCompletionPrefill(null);
    setFitnessSavedPlanPreparePrefill(null);
    setFitnessWorkoutFinishPrefill(null);
    setFitnessRestSkipPrefill(null);
    setRecoveredBodyHealthPrefill(null);
    setNutritionMealPrefill(null); nutritionMealActor.current = null; nutritionMealLiveOrigins.current.clear();
    setNutritionHydrationPrefill(null); nutritionHydrationActor.current = null; nutritionHydrationLiveOrigins.current.clear();
    setLanguagePrefill(null); languageActor.current = null; languageLiveOrigins.current.clear();
    setLanguageClassPrefill(null); languageClassActor.current = null; languageClassLiveOrigins.current.clear();
    setLanguageTutorPrefill(null); languageTutorActor.current = null; languageTutorLiveOrigins.current.clear();
    brainNoteLiveOrigins.current.clear(); setBrainHandoffPrefill(null); brainHandoffActor.current = null; brainHandoffLiveOrigins.current.clear();
    setNutritionGoalsPrefill(null); nutritionGoalsActor.current = null; nutritionGoalsLiveOrigins.current.clear();
    setFitnessCuratedPlanPrefill(null); fitnessCuratedPlanActor.current = null; fitnessCuratedPlanLiveOrigins.current.clear();
    setRecoveredGoalPrefill(null);
    setRecoveredTaskPrefill(null);
    cancelVoiceRef.current(false);
    speechEpochRef.current++;
    actionResultStreamRef.current.speechMetrics?.discard();
    actionResultStreamRef.current.progressiveSpeechMetrics?.discard();
    invalidateMirrorActionStream(actionResultStreamRef.current);
    const loadEpoch = ++actionResultStreamRef.current.sessionEpoch;
    const authEpoch = actionResultStreamRef.current.authEpoch;
    const paging = transcriptPagingRef.current;
    const previousSessionId = actionResultStreamRef.current.sessionTransition
      ? paging.previousSessionId : activeSessionIdRef.current;
    paging.previousSessionId = previousSessionId;
    const request = ++paging.request;
    const isCurrentLoad = (ownerId?: string) => actionResultStreamRef.current.mounted &&
      actionResultStreamRef.current.sessionEpoch === loadEpoch &&
      actionResultStreamRef.current.authEpoch === authEpoch && paging.request === request &&
      (!scope || scope.isCurrent(lease)) &&
      (!ownerId || actionResultStreamRef.current.ownerId === ownerId);
    actionResultStreamRef.current.sessionTransition = true;
    activeSessionIdRef.current = null;
    sessionPromiseRef.current = null;
    paging.loading = true;
    setLoadingSessionId(sid);
    earlierScrollAnchorRef.current = null;
    setLoadingEarlierMessages(false);
    setEarlierLoadError(false);
    setIsLoading(false);
    stopStreamTtsRef.current();
    goIdle();

    try {
      const { data: { user }, error } = await supabase.auth.getUser();
      if (!isCurrentLoad()) return false;
      if (error || !user || !isCurrentLoad(user.id)) throw new Error("History owner unavailable");
      const page = await loadMirrorMessagePage(supabase, { userId: user.id, sessionId: sid, pageSize: 50 });
      if (!isCurrentLoad(user.id)) return false;

      paging.ownerId = user.id;
      paging.sessionId = sid;
      paging.cursor = page.nextCursor;
      setHasEarlierMessages(page.hasMore);
      setMessages(page.messages);
      activeSessionIdRef.current = sid;
      setSessionId(sid);
      setMirrorSession(sid, user.id);
      setInput("");
      setViewingSessionId(null);
      setViewingMessages([]);
      setShowHistory(false);
      setShowConversation(true);

      setTimeout(() => {
        if (isCurrentLoad(user.id) && activeSessionIdRef.current === sid) inputRef.current?.focus();
      }, 100);
      return true;
    } catch (error) {
      if (!isCurrentLoad()) return false;
      // Keep the existing conversation usable when a different history row
      // cannot be opened. No transcript or cursor from the failed read wins.
      activeSessionIdRef.current = previousSessionId;
      console.error("loadSessionMessages error:", error);
      toast.error(t("history.loadFailed"));
      return false;
    } finally {
      if (isCurrentLoad()) {
        paging.loading = false;
        setLoadingSessionId(null);
        actionResultStreamRef.current.sessionTransition = false;
      }
    }
  };

  useEffect(() => {
    const incoming=(location.state as {financeActionRecovery?:unknown}|null)?.financeActionRecovery;
    if(!incoming||!captureOwnerId)return;
    const locator=parseMirrorFinanceRecovery(incoming,captureOwnerId);
    let current=true;
    const state=actionResultStreamRef.current,authEpoch=state.authEpoch;
    let expectedSessionEpoch=state.sessionEpoch,expectedRequest=state.request;
    const isCurrent=()=>current&&state.mounted&&state.ownerId===captureOwnerId&&state.authEpoch===authEpoch&&state.sessionEpoch===expectedSessionEpoch&&state.request===expectedRequest;
    void(async()=>{
      try{
        const prefill=locator&&await prepareMirrorFinanceRecovery(locator,{ownerId:captureOwnerId,isCurrent,loadSession:async sid=>{
          if(!isCurrent())return false;
          const loading=loadSessionMessages(sid),epoch=state.sessionEpoch;
          expectedSessionEpoch=epoch;expectedRequest=state.request;
          const loaded=await loading;
          return loaded===true&&isCurrent()&&!state.sessionTransition&&activeSessionIdRef.current===sid;
        }});
        if(!isCurrent())return;
        if(prefill)setRecoveredFinance({prefill,isCurrent:()=>state.mounted&&state.ownerId===captureOwnerId&&state.authEpoch===authEpoch&&state.sessionEpoch===expectedSessionEpoch&&state.request===expectedRequest&&!state.sessionTransition&&activeSessionIdRef.current===prefill.expected_session_id});
        else toast.error(t('financeAction.outcomeUnknown'));
      }catch{if(isCurrent())toast.error(t('financeAction.outcomeUnknown'));}
      finally{if(isCurrent())navigate(location.pathname+location.search,{replace:true,state:null});}
    })();
    return()=>{current=false;};
  // The route key and monotonic auth/request/session epochs fence late recovery.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[location.key,location.state,captureOwnerId]);

  useEffect(() => {
    const incoming = (location.state as { goalActionRecovery?: unknown } | null)?.goalActionRecovery;
    if (!incoming || !captureOwnerId) return;
    const locator = parseMirrorGoalRecovery(incoming, captureOwnerId);
    let current = true;
    const state = actionResultStreamRef.current, authEpoch = state.authEpoch;
    let expectedSessionEpoch = state.sessionEpoch;
    const isCurrent = () => current && state.mounted && state.ownerId === captureOwnerId && state.authEpoch === authEpoch && state.sessionEpoch === expectedSessionEpoch;
    void (async () => {
      try {
        const prefill = locator && await prepareMirrorGoalRecovery(locator, { ownerId: captureOwnerId, isCurrent, loadSession: async sid => {
          if (!isCurrent()) return false;
          const loading = loadSessionMessages(sid), epoch = state.sessionEpoch;
          expectedSessionEpoch = epoch;
          const loaded = await loading;
          return loaded === true && isCurrent() && state.sessionEpoch === epoch && !state.sessionTransition && activeSessionIdRef.current === sid;
        } });
        if (!isCurrent()) return;
        if (prefill) setRecoveredGoalPrefill(prefill);
        else toast.error(t("history.loadFailed"));
      } catch { if (isCurrent()) toast.error(t("history.loadFailed")); }
      finally { if (isCurrent()) navigate(location.pathname + location.search, { replace: true, state: null }); }
    })();
    return () => { current = false; };
  // The route key invalidates A→B→A; session loading has its own monotonic epoch.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, location.state, captureOwnerId]);

  useEffect(() => {
    const incoming = (location.state as { taskActionRecovery?: unknown } | null)?.taskActionRecovery;
    if (!incoming || !captureOwnerId) return;
    const locator = parseMirrorTaskRecovery(incoming, captureOwnerId);
    let current = true;
    const state = actionResultStreamRef.current, authEpoch = state.authEpoch;
    let expectedSessionEpoch = state.sessionEpoch;
    const isCurrent = () => current && state.mounted && state.ownerId === captureOwnerId && state.authEpoch === authEpoch && state.sessionEpoch === expectedSessionEpoch;
    void (async () => {
      try {
        const prefill = locator && await prepareMirrorTaskRecovery(locator, { ownerId: captureOwnerId, isCurrent, loadSession: async sid => {
          if (!isCurrent()) return false;
          const loading = loadSessionMessages(sid), epoch = state.sessionEpoch;
          expectedSessionEpoch = epoch;
          const loaded = await loading;
          return loaded === true && isCurrent() && state.sessionEpoch === epoch && !state.sessionTransition && activeSessionIdRef.current === sid;
        } });
        if (!isCurrent()) return;
        if (prefill) setRecoveredTaskPrefill(prefill);
        else toast.error(t("history.loadFailed"));
      } catch { if (isCurrent()) toast.error(t("history.loadFailed")); }
      finally { if (isCurrent()) navigate(location.pathname + location.search, { replace: true, state: null }); }
    })();
    return () => { current = false; };
  // The route key invalidates A→B→A; session loading has its own monotonic epoch.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, location.state, captureOwnerId]);
  useEffect(() => {
    const incoming = (location.state as { noteActionRecovery?: unknown } | null)?.noteActionRecovery;
    if (!incoming || !captureOwnerId) return;
    const locator = parseMirrorNoteRecovery(incoming, captureOwnerId);
    let current = true;
    const state = actionResultStreamRef.current, authEpoch = state.authEpoch;
    let expectedSessionEpoch = state.sessionEpoch;
    const isCurrent = () => current && state.mounted && state.ownerId === captureOwnerId && state.authEpoch === authEpoch && state.sessionEpoch === expectedSessionEpoch;
    void (async () => {
      try {
        const prefill = locator && await prepareMirrorNoteRecovery(locator, { ownerId: captureOwnerId, isCurrent, loadSession: async sid => {
          if (!isCurrent()) return false;
          const loading = loadSessionMessages(sid), epoch = state.sessionEpoch;
          expectedSessionEpoch = epoch;
          const loaded = await loading;
          return loaded === true && isCurrent() && state.sessionEpoch === epoch && !state.sessionTransition && activeSessionIdRef.current === sid;
        } });
        if (!isCurrent()) return;
        if (prefill) setRecoveredNotePrefill(prefill);
        else toast.error(t("history.loadFailed"));
      } catch { if (isCurrent()) toast.error(t("history.loadFailed")); }
      finally { if (isCurrent()) navigate(location.pathname + location.search, { replace: true, state: null }); }
    })();
    return () => { current = false; };
  // The route key invalidates A→B→A; session loading has its own monotonic epoch.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, location.state, captureOwnerId]);
  useEffect(() => {
    const incoming = (location.state as { brainNoteActionRecovery?: unknown } | null)?.brainNoteActionRecovery;
    if (!incoming || !captureOwnerId) return;
    const parsed = parseMirrorNoteRecovery(incoming, captureOwnerId);
    const locator = parsed?.brain_kind ? parsed : null;
    let current = true;
    const state = actionResultStreamRef.current, authEpoch = state.authEpoch;
    let expectedSessionEpoch = state.sessionEpoch;
    const isCurrent = () => current && state.mounted && state.ownerId === captureOwnerId && state.authEpoch === authEpoch && state.sessionEpoch === expectedSessionEpoch;
    void (async () => {
      try {
        const prefill = locator && await prepareMirrorNoteRecovery(locator, { ownerId: captureOwnerId, isCurrent, loadSession: async sid => {
          if (!isCurrent()) return false;
          const loading = loadSessionMessages(sid), epoch = state.sessionEpoch;
          expectedSessionEpoch = epoch;
          const loaded = await loading;
          return loaded === true && isCurrent() && state.sessionEpoch === epoch && !state.sessionTransition && activeSessionIdRef.current === sid;
        } });
        if (!isCurrent()) return;
        if (prefill) setRecoveredNotePrefill(prefill);
        else toast.error(t("history.loadFailed"));
      } catch { if (isCurrent()) toast.error(t("history.loadFailed")); }
      finally { if (isCurrent()) navigate(location.pathname + location.search, { replace: true, state: null }); }
    })();
    return () => { current = false; };
  // The route key invalidates A→B→A; session loading has its own monotonic epoch.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, location.state, captureOwnerId]);
  useEffect(() => {
    const incoming = (location.state as { habitActionRecovery?: unknown } | null)?.habitActionRecovery;
    if (!incoming || !captureOwnerId) return;
    const locator = parseMirrorHabitRecovery(incoming, captureOwnerId);
    let current = true;
    const state = actionResultStreamRef.current, authEpoch = state.authEpoch;
    let expectedSessionEpoch = state.sessionEpoch;
    const isCurrent = () => current && state.mounted && state.ownerId === captureOwnerId && state.authEpoch === authEpoch && state.sessionEpoch === expectedSessionEpoch;
    void (async () => {
      try {
        const prefill = locator && await prepareMirrorHabitRecovery(locator, { ownerId: captureOwnerId, isCurrent, loadSession: async sid => {
          if (!isCurrent()) return false;
          const loading = loadSessionMessages(sid), epoch = state.sessionEpoch;
          expectedSessionEpoch = epoch;
          const loaded = await loading;
          return loaded === true && isCurrent() && state.sessionEpoch === epoch && !state.sessionTransition && activeSessionIdRef.current === sid;
        } });
        if (!isCurrent()) return;
        if (prefill) setRecoveredHabitPrefill(prefill);
        else toast.error(t("history.loadFailed"));
      } catch { if (isCurrent()) toast.error(t("history.loadFailed")); }
      finally { if (isCurrent()) navigate(location.pathname + location.search, { replace: true, state: null }); }
    })();
    return () => { current = false; };
  // The route key invalidates A→B→A; session loading has its own monotonic epoch.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, location.state, captureOwnerId]);
  useEffect(() => {
    const incoming = (location.state as { agendaActionRecovery?: unknown } | null)?.agendaActionRecovery;
    if (!incoming || !captureOwnerId) return;
    const locator = parseMirrorAgendaRecovery(incoming, captureOwnerId);
    let current = true;
    const state = actionResultStreamRef.current, authEpoch = state.authEpoch;
    let expectedSessionEpoch = state.sessionEpoch;
    const isCurrent = () => current && state.mounted && state.ownerId === captureOwnerId && state.authEpoch === authEpoch && state.sessionEpoch === expectedSessionEpoch;
    void (async () => {
      try {
        const prefill = locator && await prepareMirrorAgendaRecovery(locator, { ownerId: captureOwnerId, isCurrent, loadSession: async sid => {
          if (!isCurrent()) return false;
          const loading = loadSessionMessages(sid), epoch = state.sessionEpoch;
          expectedSessionEpoch = epoch;
          const loaded = await loading;
          return loaded === true && isCurrent() && state.sessionEpoch === epoch && !state.sessionTransition && activeSessionIdRef.current === sid;
        } });
        if (!isCurrent()) return;
        if (prefill) setRecoveredAgendaPrefill(prefill);
        else toast.error(t("history.loadFailed"));
      } catch { if (isCurrent()) toast.error(t("history.loadFailed")); }
      finally { if (isCurrent()) navigate(location.pathname + location.search, { replace: true, state: null }); }
    })();
    return () => { current = false; };
  // The route key invalidates A→B→A; session loading has its own monotonic epoch.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, location.state, captureOwnerId]);
  useEffect(() => {
    const incoming = (location.state as { reminderActionRecovery?: unknown } | null)?.reminderActionRecovery;
    if (!incoming || !captureOwnerId) return;
    const locator = parseMirrorReminderRecovery(incoming, captureOwnerId);
    let current = true;
    const state = actionResultStreamRef.current, authEpoch = state.authEpoch;
    let expectedSessionEpoch = state.sessionEpoch;
    const isCurrent = () => current && state.mounted && state.ownerId === captureOwnerId && state.authEpoch === authEpoch && state.sessionEpoch === expectedSessionEpoch;
    void (async () => {
      try {
        const prefill = locator && await prepareMirrorReminderRecovery(locator, { ownerId: captureOwnerId, isCurrent, loadSession: async sid => {
          if (!isCurrent()) return false;
          const loading = loadSessionMessages(sid), epoch = state.sessionEpoch;
          expectedSessionEpoch = epoch;
          const loaded = await loading;
          return loaded === true && isCurrent() && state.sessionEpoch === epoch && !state.sessionTransition && activeSessionIdRef.current === sid;
        } });
        if (!isCurrent()) return;
        if (prefill) setRecoveredReminderPrefill(prefill);
        else toast.error(t("history.loadFailed"));
      } catch { if (isCurrent()) toast.error(t("history.loadFailed")); }
      finally { if (isCurrent()) navigate(location.pathname + location.search, { replace: true, state: null }); }
    })();
    return () => { current = false; };
  // The route key invalidates A→B→A; session loading has its own monotonic epoch.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, location.state, captureOwnerId]);
  useEffect(() => {
    const incoming = (location.state as { focusActionRecovery?: unknown } | null)?.focusActionRecovery;
    if (!incoming || !captureOwnerId) return;
    const locator = parseMirrorFocusRecovery(incoming, captureOwnerId);
    let current = true;
    const state = actionResultStreamRef.current, authEpoch = state.authEpoch;
    let expectedSessionEpoch = state.sessionEpoch;
    const isCurrent = () => current && state.mounted && state.ownerId === captureOwnerId && state.authEpoch === authEpoch && state.sessionEpoch === expectedSessionEpoch;
    void (async () => {
      try {
        const prefill = locator && await prepareMirrorFocusRecovery(locator, { ownerId: captureOwnerId, isCurrent, loadSession: async sid => {
          if (!isCurrent()) return false;
          const loading = loadSessionMessages(sid), epoch = state.sessionEpoch;
          expectedSessionEpoch = epoch;
          const loaded = await loading;
          return loaded === true && isCurrent() && state.sessionEpoch === epoch && !state.sessionTransition && activeSessionIdRef.current === sid;
        } });
        if (!isCurrent()) return;
        if (prefill) setRecoveredFocusPrefill(prefill);
        else toast.error(t("history.loadFailed"));
      } catch { if (isCurrent()) toast.error(t("history.loadFailed")); }
      finally { if (isCurrent()) navigate(location.pathname + location.search, { replace: true, state: null }); }
    })();
    return () => { current = false; };
  // The route key invalidates A→B→A; session loading has its own monotonic epoch.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, location.state, captureOwnerId]);

  useEffect(() => {
    const incoming = (location.state as { checkinActionRecovery?: unknown } | null)?.checkinActionRecovery;
    if (!incoming || !captureOwnerId) return;
    const locator = parseMirrorCheckinRecovery(incoming, captureOwnerId);
    let current = true;
    const state = actionResultStreamRef.current, authEpoch = state.authEpoch;
    let expectedSessionEpoch = state.sessionEpoch;
    const isCurrent = () => current && state.mounted && state.ownerId === captureOwnerId && state.authEpoch === authEpoch && state.sessionEpoch === expectedSessionEpoch;
    void (async () => {
      try {
        const prefill = locator && await prepareMirrorCheckinRecovery(locator, { ownerId: captureOwnerId, isCurrent, loadSession: async sid => {
          if (!isCurrent()) return false;
          const loading = loadSessionMessages(sid), epoch = state.sessionEpoch;
          expectedSessionEpoch = epoch;
          const loaded = await loading;
          return loaded === true && isCurrent() && state.sessionEpoch === epoch && !state.sessionTransition && activeSessionIdRef.current === sid;
        } });
        if (!isCurrent()) return;
        if (prefill) setRecoveredCheckinPrefill(prefill);
        else toast.error(t("history.loadFailed"));
      } catch { if (isCurrent()) toast.error(t("history.loadFailed")); }
      finally { if (isCurrent()) navigate(location.pathname + location.search, { replace: true, state: null }); }
    })();
    return () => { current = false; };
  // The route key invalidates A→B→A; session loading has its own monotonic epoch.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, location.state, captureOwnerId]);

  useEffect(() => {
    const incoming = (location.state as { sleepActionRecovery?: unknown } | null)?.sleepActionRecovery;
    if (!incoming || !captureOwnerId) return;
    const locator = parseMirrorSleepRecovery(incoming, captureOwnerId);
    let current = true;
    const state = actionResultStreamRef.current, authEpoch = state.authEpoch;
    let expectedSessionEpoch = state.sessionEpoch;
    const isCurrent = () => current && state.mounted && state.ownerId === captureOwnerId && state.authEpoch === authEpoch && state.sessionEpoch === expectedSessionEpoch;
    void (async () => {
      try {
        const prefill = locator && await prepareMirrorSleepRecovery(locator, { ownerId: captureOwnerId, isCurrent, loadSession: async sid => {
          if (!isCurrent()) return false;
          const loading = loadSessionMessages(sid), epoch = state.sessionEpoch;
          expectedSessionEpoch = epoch;
          const loaded = await loading;
          return loaded === true && isCurrent() && state.sessionEpoch === epoch && !state.sessionTransition && activeSessionIdRef.current === sid;
        } });
        if (!isCurrent()) return;
        if (prefill) setRecoveredSleepPrefill(prefill);
        else toast.error(t("history.loadFailed"));
      } catch { if (isCurrent()) toast.error(t("history.loadFailed")); }
      finally { if (isCurrent()) navigate(location.pathname + location.search, { replace: true, state: null }); }
    })();
    return () => { current = false; };
  // The route key invalidates A→B→A; session loading has its own monotonic epoch.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, location.state, captureOwnerId]);
  useEffect(() => {
    const incoming = (location.state as { fitnessActionRecovery?: unknown } | null)?.fitnessActionRecovery;
    if (!incoming || !captureOwnerId) return;
    const locator = parseMirrorFitnessRecovery(incoming, captureOwnerId);
    let current = true;
    const state = actionResultStreamRef.current, authEpoch = state.authEpoch;
    let expectedSessionEpoch = state.sessionEpoch;
    const isCurrent = () => current && state.mounted && state.ownerId === captureOwnerId && state.authEpoch === authEpoch && state.sessionEpoch === expectedSessionEpoch;
    void (async () => {
      try {
        const prefill = locator && await prepareMirrorFitnessRecovery(locator, { ownerId: captureOwnerId, isCurrent, loadSession: async sid => {
          if (!isCurrent()) return false;
          const loading = loadSessionMessages(sid), epoch = state.sessionEpoch;
          expectedSessionEpoch = epoch;
          const loaded = await loading;
          return loaded === true && isCurrent() && state.sessionEpoch === epoch && !state.sessionTransition && activeSessionIdRef.current === sid;
        } });
        if (!isCurrent()) return;
        if (prefill) setRecoveredFitnessPrefill(prefill);
        else toast.error(t("history.loadFailed"));
      } catch { if (isCurrent()) toast.error(t("history.loadFailed")); }
      finally { if (isCurrent()) navigate(location.pathname + location.search, { replace: true, state: null }); }
    })();
    return () => { current = false; };
  // The route key invalidates A→B→A; session loading has its own monotonic epoch.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, location.state, captureOwnerId]);

  useEffect(() => {
    const incoming = (location.state as { bodyHealthActionRecovery?: unknown } | null)?.bodyHealthActionRecovery;
    if (!incoming || !captureOwnerId) return;
    const locator = parseMirrorBodyHealthRecovery(incoming, captureOwnerId);
    let current = true;
    const state = actionResultStreamRef.current, authEpoch = state.authEpoch;
    let expectedSessionEpoch = state.sessionEpoch;
    const isCurrent = () => current && state.mounted && state.ownerId === captureOwnerId && state.authEpoch === authEpoch && state.sessionEpoch === expectedSessionEpoch;
    void (async () => {
      try {
        const prefill = locator && await prepareMirrorBodyHealthRecovery(locator, { ownerId: captureOwnerId, isCurrent, loadSession: async sid => {
          if (!isCurrent()) return false;
          const loading = loadSessionMessages(sid), epoch = state.sessionEpoch;
          expectedSessionEpoch = epoch;
          const loaded = await loading;
          return loaded === true && isCurrent() && state.sessionEpoch === epoch && !state.sessionTransition && activeSessionIdRef.current === sid;
        } });
        if (!isCurrent()) return;
        if (prefill) setRecoveredBodyHealthPrefill(prefill);
        else toast.error(t("history.loadFailed"));
      } catch { if (isCurrent()) toast.error(t("history.loadFailed")); }
      finally { if (isCurrent()) navigate(location.pathname + location.search, { replace: true, state: null }); }
    })();
    return () => { current = false; };
  // The route key invalidates A→B→A; session loading has its own monotonic epoch.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, location.state, captureOwnerId]);

  const loadEarlierMessages = async () => {
    const paging = transcriptPagingRef.current;
    const sid = activeSessionIdRef.current;
    const ownerId = actionResultStreamRef.current.ownerId;
    if (!sid || !ownerId || paging.loading || !paging.cursor ||
      paging.sessionId !== sid || paging.ownerId !== ownerId || actionResultStreamRef.current.sessionTransition) return;
    const request = paging.request;
    const authEpoch = actionResultStreamRef.current.authEpoch;
    const sessionEpoch = actionResultStreamRef.current.sessionEpoch;
    const isCurrentPage = () => actionResultStreamRef.current.mounted && paging.request === request &&
      actionResultStreamRef.current.authEpoch === authEpoch && actionResultStreamRef.current.sessionEpoch === sessionEpoch &&
      actionResultStreamRef.current.ownerId === ownerId && activeSessionIdRef.current === sid;
    paging.loading = true;
    setLoadingEarlierMessages(true);
    setEarlierLoadError(false);
    try {
      const page = await loadMirrorMessagePage(supabase, { userId: ownerId, sessionId: sid, cursor: paging.cursor, pageSize: 50 });
      if (!isCurrentPage()) return;
      paging.cursor = page.nextCursor;
      const thread = threadRef.current;
      if (thread) earlierScrollAnchorRef.current = { sessionId: sid, height: thread.scrollHeight, top: thread.scrollTop };
      setHasEarlierMessages(page.hasMore);
      setMessages(previous => {
        if (!isCurrentPage()) return previous;
        const existing = new Set(previous.flatMap(message => message.id ? [message.id] : []));
        return [...page.messages.filter(message => {
          if (existing.has(message.id)) return false;
          existing.add(message.id);
          return true;
        }), ...previous];
      });
    } catch (error) {
      if (!isCurrentPage()) return;
      console.error("loadEarlierMessages error:", error);
      setEarlierLoadError(true);
    } finally {
      if (isCurrentPage()) {
        paging.loading = false;
        setLoadingEarlierMessages(false);
      }
    }
  };

  // ── Projects ──

  const loadProjects = useCallback(async () => {
    const scope = actionResultStreamRef.current.authScope, lease = scope?.capture() ?? null;
    if (scope && !lease) return;
    const authEpoch = actionResultStreamRef.current.authEpoch;
    const request = ++projectsLoadRef.current.request;
    const isCurrentProjects = (ownerId?: string) => actionResultStreamRef.current.mounted &&
      actionResultStreamRef.current.authEpoch === authEpoch && projectsLoadRef.current.request === request &&
      (!scope || scope.isCurrent(lease)) &&
      (!ownerId || actionResultStreamRef.current.ownerId === ownerId);
    setLoadingProjects(true);
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user || !isCurrentProjects(user.id)) return;
      const { data, error } = await supabase
        .from("projects" as any)
        .select("*")
        .eq("user_id", user.id)
        .order("created_at", { ascending: false });
      if (!isCurrentProjects(user.id)) return;
      if (error) { console.error(error); return; }
      setProjects(((data as any) as Project[]) || []);
    } finally {
      if (isCurrentProjects()) setLoadingProjects(false);
    }
  }, []);

  const createProject = async (name: string) => {
    const state = actionResultStreamRef.current, scope = state.authScope, lease = scope?.capture() ?? null;
    const authEpoch = state.authEpoch, sessionEpoch = state.sessionEpoch;
    const isCurrent = () => state.mounted && state.authEpoch === authEpoch && state.sessionEpoch === sessionEpoch
      && (!scope || scope.isCurrent(lease));
    if (!isCurrent()) return;
    const trimmed = name.trim();
    setCreatingProject(false);
    setNewProjectName("");
    if (!trimmed) return;
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user || !isCurrent() || scope && lease?.ownerId !== user.id) return;
      const { data, error } = await supabase
        .from("projects" as any)
        .insert({ user_id: user.id, name: trimmed, color: "cyan" })
        .select("*")
        .single();
      if (!isCurrent()) return;
      if (error) { toast.error(t("mirror.error")); return; }
      setProjects((prev) => isCurrent() ? [((data as any) as Project), ...prev] : prev);
    } catch {
      if (!isCurrent()) return;
      toast.error(t("mirror.error"));
    }
  };

  const renameProject = async (id: string, name: string) => {
    const trimmed = name.trim();
    setRenamingProjectId(null);
    if (!trimmed) return;
    setProjects((prev) => prev.map((p) => p.id === id ? { ...p, name: trimmed } : p));
    setProjectMenuOpenId(null);
    const { error } = await supabase.from("projects" as any).update({ name: trimmed }).eq("id", id);
    if (error) { toast.error(t("mirror.error")); loadProjects(); }
  };

  const deleteProject = async (id: string) => {
    setProjects((prev) => prev.filter((p) => p.id !== id));
    setProjectMenuOpenId(null);
    if (expandedProjectId === id) setExpandedProjectId(null);
    await supabase.from("projects" as any).delete().eq("id", id);
    loadHistorySessions();
  };

  const changeProjectColor = async (id: string, color: string) => {
    setProjects((prev) => prev.map((p) => p.id === id ? { ...p, color } : p));
    setChangingColorProjectId(null);
    setProjectMenuOpenId(null);
    await supabase.from("projects" as any).update({ color }).eq("id", id);
  };

  const moveSessionToProject = async (sid: string, projectId: string | null) => {
    setHistorySessions((prev) =>
      prev.map((s) => s.id === sid ? { ...s, project_id: projectId } : s)
    );
    setMovingSessionId(null);
    setMenuOpenId(null);
    const { error } = await supabase
      .from("mirror_sessions")
      .update({ project_id: projectId } as any)
      .eq("id", sid);
    if (error) { toast.error(t("mirror.error")); loadHistorySessions(); }
  };

  // ── Messaging ──
  //
  // The mirror-chat edge function now owns context loading and message
  // persistence. The client:
  //   1. Optimistically renders the user message in local state
  //   2. Ensures a mirror_sessions row exists
  //   3. Calls mirror-chat with { promptType, userId, sessionId, userMessage, language }
  //   4. Renders the returned assistant text
  //   5. On error, reverts the optimistic user message and surfaces a toast
  // Writes to mirror_messages happen on the server; no more saveMessageToDb here.

  const sendMessage = async (
    text: string,
    entryIntent?: EntryIntent,
    explicitAttachmentIds?: string[],
  ) => {
    // Sem lista explícita, o turno leva o que estiver PRONTO no compositor.
    // É por aqui que a F1 alimenta o caminho que a NANO-2 deixou construído e
    // sem produtor: até agora `attachmentIds` era [] em 100% dos turnos.
    const channelScope = actionResultStreamRef.current.authScope;
    const channelLease = channelScope?.capture() ?? null;
    if (channelScope && (!channelLease || actionResultStreamRef.current.authEpoch !== captureAuthEpoch)) return;
    const channelAuthEpoch = actionResultStreamRef.current.authEpoch;
    const attachmentIds = explicitAttachmentIds ?? attachments.readyIds;
    // A nota anexada entra no TEXTO do turno, rotulada. Uma cópia só: o que a
    // bolha mostra é byte a byte o que vai para o mirror-chat. Divergir os dois
    // (mostrar curto, mandar longo) cria um estado invisível — e "o que exatamente
    // o Espelho recebeu?" vira uma pergunta sem resposta na tela.
    const pendingNote = attachedNoteRef.current;
    const noteAuthEpoch = pendingNote ? actionResultStreamRef.current.authEpoch : null;
    const pendingGoal = ownedGoalContext(attachedGoalRef.current, actionResultStreamRef.current.ownerId);
    const composedText = composeNoteContextMessage(
      t("mirror.noteContext.label"),
      pendingNote,
      text,
    );
    const hasText = !!composedText.trim();
    const hasAttachments = attachmentIds.length > 0;
    // Arquivo sem texto é gesto legítimo ("olha isso aqui") — o corpo da
    // mensagem vira a lista de nomes, que é o que o usuário vê na conversa
    // depois de os chips saírem do compositor.
    if ((!hasText && !hasAttachments) || isLoading || (voiceCaptureRef.current && !voiceCaptureRef.current.reviewing) || actionResultStreamRef.current.sessionTransition) return;
    let whatsappReviewSelection: ReturnType<typeof attachments.reviewSelection>;
    try {
      whatsappReviewSelection = attachments.reviewSelection(attachmentIds);
      if (whatsappReviewSelection && (pendingNote || pendingGoal || moduleContext ||
        !channelLease || whatsappReviewSelection.ownerId !== channelLease.ownerId)) throw new Error("whatsapp_review_unavailable");
    } catch { toast.error(t("mirror.channel.reviewUnavailable")); return; }
    voiceCaptureRef.current = null;
    setVoiceDraftReady(false);
    actionResultStreamRef.current.speechMetrics?.finishCurrent("stop", "superseded");
    actionResultStreamRef.current.controller?.abort();
    const streamController = new AbortController();
    actionResultStreamRef.current.controller = streamController;
    const actionResultRequest = ++actionResultStreamRef.current.request;
    setWindsorReportOrigin(null);
    setFileEditOrigin(null);
    setNutritionMealPrefill(null); nutritionMealActor.current = null; nutritionMealLiveOrigins.current.clear();
    setNutritionHydrationPrefill(null); nutritionHydrationActor.current = null; nutritionHydrationLiveOrigins.current.clear();
    setLanguagePrefill(null); languageActor.current = null; languageLiveOrigins.current.clear();
    setLanguageClassPrefill(null); languageClassActor.current = null; languageClassLiveOrigins.current.clear();
    setLanguageTutorPrefill(null); languageTutorActor.current = null; languageTutorLiveOrigins.current.clear();
    brainNoteLiveOrigins.current.clear(); setBrainHandoffPrefill(null); brainHandoffActor.current = null; brainHandoffLiveOrigins.current.clear();
    setNutritionGoalsPrefill(null); nutritionGoalsActor.current = null; nutritionGoalsLiveOrigins.current.clear();
    setFitnessCuratedPlanPrefill(null); fitnessCuratedPlanActor.current = null; fitnessCuratedPlanLiveOrigins.current.clear();
    setFitnessDraftDiscardPrefill(null);
    setFitnessRuntimePrefill(null);
    setFitnessDraftRestorePrefill(null);
    setFitnessCurrentSetEditPrefill(null);
    setFitnessSetupStartPrefill(null);
    setFitnessCurrentSetCompletionPrefill(null);
    setFitnessSavedPlanPreparePrefill(null);
    setFitnessWorkoutFinishPrefill(null);
    setFitnessRestSkipPrefill(null);
    // Only the literal current input can authorize this private device read.
    // A note makes userMessage composite, so the server's literal-turn intent
    // cannot authorize this bridge. Attachments, history and tutor/live paths
    // also cannot opt into a device read on behalf of the current text.
    const localWorkoutFinishTurn = fitnessWorkoutFinishTargeted(text);
    const localWorkoutFinishRequested = MIRROR_FITNESS_CARDS_ENABLED && !live && !moduleContext && !pendingNote && !hasAttachments && fitnessWorkoutFinishRequested(text);
    let localWorkoutFinishRequest: FitnessWorkoutFinishEnvelope | null = null;
    const localSavedPlanPrepareTurn = fitnessSavedPlanPrepareTargeted(text);
    const localSavedPlanPrepareRequested = !localWorkoutFinishTurn && MIRROR_FITNESS_CARDS_ENABLED && !live && !moduleContext && !pendingNote && !hasAttachments && fitnessSavedPlanPrepareRequested(text);
    let localSavedPlanPrepareRequest: FitnessSavedPlanPrepareEnvelope | null = null;
    const localRestSkipTurn = !localSavedPlanPrepareTurn && !localWorkoutFinishTurn && fitnessRestSkipTargeted(text);
    const localRestSkipRequested = !localSavedPlanPrepareTurn && !localWorkoutFinishTurn && MIRROR_FITNESS_CARDS_ENABLED && !live && !moduleContext && !pendingNote && !hasAttachments && fitnessRestSkipRequested(text);
    let localRestSkipRequest: FitnessRestSkipEnvelope | null = null;
    const localSetCompletionTurn = !localSavedPlanPrepareTurn && !localWorkoutFinishTurn && !localRestSkipTurn && fitnessCurrentSetCompletionTargeted(text);
    const localSetCompletionRequested = !localSavedPlanPrepareTurn && !localWorkoutFinishTurn && !localRestSkipTurn && MIRROR_FITNESS_CARDS_ENABLED && !live && !moduleContext && !pendingNote && !hasAttachments && fitnessCurrentSetCompletionRequested(text);
    let localSetCompletionRequest: FitnessCurrentSetCompletionEnvelope | null = null;
    const localSetupStartTurn = !localSavedPlanPrepareTurn && !localWorkoutFinishTurn && !localRestSkipTurn && !localSetCompletionTurn && fitnessSetupStartTargeted(text);
    const localSetupStartRequested = !localSavedPlanPrepareTurn && !localWorkoutFinishTurn && !localRestSkipTurn && !localSetCompletionTurn && MIRROR_FITNESS_CARDS_ENABLED && !live && !moduleContext && !pendingNote && !hasAttachments && fitnessSetupStartRequested(text);
    let localSetupStartRequest: FitnessSetupStartEnvelope | null = null;
    const localSetEditTurn = !localSavedPlanPrepareTurn && !localWorkoutFinishTurn && !localRestSkipTurn && !localSetCompletionTurn && !localSetupStartTurn && fitnessCurrentSetEditTargeted(text);
    const localSetEditChanges = !localSavedPlanPrepareTurn && !localWorkoutFinishTurn && !localRestSkipTurn && !localSetCompletionTurn && MIRROR_FITNESS_CARDS_ENABLED && !live && !moduleContext && !pendingNote && !hasAttachments && !localSetupStartTurn ? parseFitnessCurrentSetEditRequest(text) : null;
    let localSetEditRequest: FitnessCurrentSetEditEnvelope | null = null;
    const localRestoreTurn = !localSavedPlanPrepareTurn && !localWorkoutFinishTurn && !localRestSkipTurn && !localSetCompletionTurn && !localSetupStartTurn && !localSetEditTurn && fitnessDraftRestoreTargeted(text);
    const localRestoreRequested = !localSavedPlanPrepareTurn && !localWorkoutFinishTurn && !localRestSkipTurn && !localSetCompletionTurn && MIRROR_FITNESS_CARDS_ENABLED && !live && !moduleContext && !pendingNote && !hasAttachments && !localSetupStartTurn && !localSetEditTurn && fitnessDraftRestoreRequested(text);
    let localRestoreRequest: FitnessLocalWorkoutEnvelope | null = null;
    const localRuntimeTurn = !localSavedPlanPrepareTurn && !localWorkoutFinishTurn && !localRestSkipTurn && !localSetCompletionTurn && !localSetupStartTurn && !localSetEditTurn && !localRestoreTurn && fitnessRuntimeTargeted(text);
    const localRuntimeAction = !localSavedPlanPrepareTurn && !localWorkoutFinishTurn && !localRestSkipTurn && !localSetCompletionTurn && !live && !moduleContext && !pendingNote && !hasAttachments && !localSetupStartTurn && !localSetEditTurn && !localRestoreTurn ? fitnessRuntimeActionRequested(text) : null;
    let localRuntimeRequest: FitnessRuntimeEnvelope | null = null;
    const localWorkoutRequested = !localSavedPlanPrepareTurn && !localWorkoutFinishTurn && !localRestSkipTurn && !localSetCompletionTurn && !live && !moduleContext && !pendingNote && !localSetupStartTurn && !localSetEditTurn && !localRestoreTurn && !localRuntimeTurn && !fitnessDraftDiscardTargeted(text) && fitnessLocalWorkoutReadRequested(text);
    const localDraftDiscardRequested = !localSavedPlanPrepareTurn && !localWorkoutFinishTurn && !localRestSkipTurn && !localSetCompletionTurn && !live && !moduleContext && !pendingNote && !hasAttachments && !localSetupStartTurn && !localSetEditTurn && !localRestoreTurn && !localRuntimeTurn && fitnessDraftDiscardRequested(text);
    const localWorkoutOrigin = {
      ownerId: actionResultStreamRef.current.ownerId,
      authEpoch: actionResultStreamRef.current.authEpoch,
      sessionEpoch: actionResultStreamRef.current.sessionEpoch,
      sessionId: activeSessionIdRef.current,
    };
    let requestIdentity: MirrorActionRequest | null = null;
    const isCurrentStream = () => !streamController.signal.aborted &&
      actionResultStreamRef.current.authEpoch === channelAuthEpoch &&
      (!channelScope || channelScope.isCurrent(channelLease)) &&
      (noteAuthEpoch === null || actionResultStreamRef.current.authEpoch === noteAuthEpoch) &&
      actionResultStreamRef.current.mounted && actionResultStreamRef.current.request === actionResultRequest &&
      (requestIdentity === null || isCurrentMirrorActionRequest(requestIdentity, {
        userId: actionResultStreamRef.current.ownerId, sessionId: activeSessionIdRef.current,
        authEpoch: actionResultStreamRef.current.authEpoch, request: actionResultStreamRef.current.request,
        mounted: actionResultStreamRef.current.mounted,
      }));
    const setRequestMessages: typeof setMessages = update => {
      if (!isCurrentStream()) return;
      setMessages(previous => isCurrentStream() ? (typeof update === "function" ? update(previous) : update) : previous);
    };

    const speechMeasurement = actionResultStreamRef.current.speechMetrics?.begin({
      isCurrent: isCurrentStream, visibleTextExpected: !live,
      mode: live ? "turn_voice" : "normal", trigger: "autoplay", voiceEnabled: !isMuted && (autoplayAudio || live),
    });
    analytics.mirrorMessageSent(false);

    // First send of the session (any modality) retires the entry surface: hide
    // the suggestion chips and disarm the pending spoken welcome so no stray
    // greeting audio fires once the conversation is underway.
    setSuggestionsArmed(false);
    setSpokenWelcomePending(false);

    // Auto-dismiss any pending proposals before sending new message.
    // Prevents UI lock when Mirror returns tool_use without accompanying text:
    // the chip stays visible but user wants to move on with conversation.
    setRequestMessages((prev) => prev.map((m) => {
      if (!m.proposals || m.proposals.length === 0) return m;
      const updated = m.proposals.map((p) =>
        p.status === "pending" ? { ...p, status: "dismissed" as const } : p
      );
      return { ...m, proposals: updated };
    }));

    // Group B trigger — DISABLED 27/04 (Group B revert)
    // setMirrorState("thinking");

    const attachedNames = attachments.chips
      .filter((c) => c.status === "ready")
      .map((c) => c.fileName);
    const fallbackText = attachedNames.length > 0
      ? "📎 " + attachedNames.join(", ")
      : "[User sent a file without text]";
    const cleanText = hasText ? composedText.trim() : fallbackText;
    const currentMessages = [...messages];
    // O chip sai do compositor no instante do envio, igual aos anexos: ele
    // pertence ao turno que partiu, não ao próximo.
    if (pendingNote) { attachedNoteRef.current = null; setAttachedNote(null); }
    if (pendingGoal) setAttachedGoal(null);

    const userMsg: Message = {
      role: "user",
      content: cleanText,
    };

    setShowConversation(true);
    setRequestMessages((prev) => [...prev, userMsg]);
    setInput("");
    // Os chips saem do compositor no instante do envio: eles pertencem ao turno
    // que acabou de partir, não ao próximo. Nada é apagado — os anexos seguem
    // vivos em executor_attachments (e vão para a Biblioteca no PR 2).
    if (hasAttachments && !whatsappReviewSelection) attachments.clear();
    setIsLoading(true);
    startThinking();

    try {
      const {
        data: { user },
        error: userError,
      } = await supabase.auth.getUser();

      if (!isCurrentStream()) return;
      if (userError || !user) throw new Error("User not authenticated");

      // JWT readiness check — warn if session is missing (needed when verify_jwt is re-enabled)
      const { data: { session }, error: sessionError } = await supabase.auth.getSession();
      if (!isCurrentStream()) return;
      if (sessionError || channelScope && !channelScope.matchesSession(session, channelLease)) throw new Error("Mirror session changed");
      if (!session) console.warn("[MirrorChat] No active session — edge function calls may fail when verify_jwt is enabled");
      // Bind any later module refresh to the identity that sent this request.
      // Token refreshes keep the epoch; signing out or changing account does not.
      if (session?.user.id !== user.id ||
        (actionResultStreamRef.current.ownerId !== null && actionResultStreamRef.current.ownerId !== user.id)) {
        throw new Error("Mirror session changed");
      }
      // Generic transport may acquire its owner here; production authority is observer-owned.
      if (!channelScope) actionResultStreamRef.current.ownerId = user.id;
      let requestSession = session;
      const actionResultAuthEpoch = actionResultStreamRef.current.authEpoch;

      const activeSessionId = await createSessionIfNeeded(cleanText);
      requestIdentity = { userId: user.id, sessionId: activeSessionId, authEpoch: actionResultAuthEpoch, request: actionResultRequest };
      if (!isCurrentStream()) return;
      const actionResultSessionEpoch = actionResultStreamRef.current.sessionEpoch;

      const body: Record<string, unknown> = {
        promptType: "chat",
        userId: user.id,
        sessionId: activeSessionId,
        userMessage: cleanText,
        // Stable for this frozen request body; never supplied by model tools.
        checkin_capture_origin: crypto.randomUUID(),
        language: lang,
        // mirrorTone is no longer tracked in local state. The edge function
        // falls back to the DB value on user_profiles when omitted/"balanced",
        // so "balanced" here is a safe default that defers to the server's own
        // lookup.
        mirrorTone: "balanced",
        // Apple 3.1.1 — tells mirror-chat to omit price + checkout URL on iOS native.
        platform: isIOSNative() ? "ios" : "web",
        // Modo Professor (/language/live) and future module tutors → per-module
        // system block in mirror-chat. Omitted for the global Espelho.
        ...(moduleContext ? { module_context: moduleContext } : {}),
        // Modo Professor: the app-selected word set of the day. The tutor
        // DELIVERS this exact set; the app owns selection. Only sent for the
        // language tutor so the global Espelho payload is untouched.
        ...(moduleContext === "language_tutor" && tutorLanguage ? { tutor_learning_language: tutorLanguage } : {}),
        ...(moduleContext === "language_tutor" && tutorWords && tutorWords.length > 0
          ? { tutor_words: tutorWords }
          : {}),
        // First-session hook: the chip the user tapped. Present ONLY on a
        // first-session chip send (typed input never sets it), so on the server
        // it doubles as the reliable "first conversation" signal that gates the
        // opening-turn play. Canonical values in @/lib/entryIntent.
        ...(entryIntent ? { entry_intent: entryIntent } : {}),
        // Camada de INPUT. O nome do campo mora em UM lugar
        // (attachmentBodyFields) e é prendido por teste de contrato — escrito à
        // mão aqui e no invoke do chip, é como um vira `attachmentIds` num
        // refactor e o anexo some sem erro nenhum. Omite quando vazio: turno
        // sem anexo sai com o corpo byte a byte igual ao de sempre.
        ...attachmentBodyFields(attachmentIds),
        ...(whatsappReviewSelection ? { whatsapp_review_message_id: whatsappReviewSelection.messageId } : {}),
        ...goalContextBody(pendingGoal, user.id),
      };

      if (localWorkoutFinishRequested) {
        const isCurrentWorkoutFinishTurn = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
          localWorkoutOrigin.ownerId === user.id && actionResultStreamRef.current.ownerId === user.id &&
          actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
          actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch &&
          actionResultSessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId &&
          (localWorkoutOrigin.sessionId === null || localWorkoutOrigin.sessionId === activeSessionId);
        if (!isCurrentWorkoutFinishTurn()) { if (!isCurrentStream()) return; throw new Error("Mirror session changed"); }
        const completion = await readFitnessWorkoutFinishForRequest({ text, ownerId: user.id, auth: supabase.auth, isCurrent: isCurrentWorkoutFinishTurn });
        if (!isCurrentWorkoutFinishTurn()) return;
        if (!completion || !isFitnessWorkoutFinishRequestCurrent(completion)) throw new Error("Mirror session changed");
        const freshWorkoutFinishSession = await supabase.auth.getSession();
        if (!isCurrentWorkoutFinishTurn()) return;
        if (freshWorkoutFinishSession.error || freshWorkoutFinishSession.data.session?.user.id !== user.id || !freshWorkoutFinishSession.data.session.access_token) throw new Error("Mirror session changed");
        if (!isFitnessWorkoutFinishRequestCurrent(completion)) throw new Error("Mirror session changed");
        if (channelScope && !channelScope.matchesSession(freshWorkoutFinishSession.data.session, channelLease)) throw new Error("Mirror session changed");
        requestSession = freshWorkoutFinishSession.data.session;
        localWorkoutFinishRequest = completion;
        body.fitness_workout_finish = completion;
      }

      if (localSavedPlanPrepareRequested) {
        const isCurrentSavedPlanPrepareTurn = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
          localWorkoutOrigin.ownerId === user.id && actionResultStreamRef.current.ownerId === user.id &&
          actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
          actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch &&
          actionResultSessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId &&
          (localWorkoutOrigin.sessionId === null || localWorkoutOrigin.sessionId === activeSessionId);
        if (!isCurrentSavedPlanPrepareTurn()) { if (!isCurrentStream()) return; throw new Error("Mirror session changed"); }
        const preparation = await readFitnessSavedPlanPrepareForRequest({ text, ownerId: user.id, auth: supabase.auth, bindings: supabase as unknown as FitnessSavedPlanPrepareBindings, isCurrent: isCurrentSavedPlanPrepareTurn });
        if (!isCurrentSavedPlanPrepareTurn()) return;
        if (!preparation || !isFitnessSavedPlanPrepareRequestCurrent(preparation)) throw new Error("Mirror session changed");
        const freshSavedPlanPrepareSession = await supabase.auth.getSession();
        if (!isCurrentSavedPlanPrepareTurn()) return;
        if (freshSavedPlanPrepareSession.error || freshSavedPlanPrepareSession.data.session?.user.id !== user.id || !freshSavedPlanPrepareSession.data.session.access_token) throw new Error("Mirror session changed");
        if (!isFitnessSavedPlanPrepareRequestCurrent(preparation)) throw new Error("Mirror session changed");
        if (channelScope && !channelScope.matchesSession(freshSavedPlanPrepareSession.data.session, channelLease)) throw new Error("Mirror session changed");
        requestSession = freshSavedPlanPrepareSession.data.session;
        localSavedPlanPrepareRequest = preparation;
        body.fitness_saved_plan_prepare = preparation;
      }

      if (localRestSkipRequested) {
        const isCurrentRestSkipTurn = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
          localWorkoutOrigin.ownerId === user.id && actionResultStreamRef.current.ownerId === user.id &&
          actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
          actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch &&
          actionResultSessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId &&
          (localWorkoutOrigin.sessionId === null || localWorkoutOrigin.sessionId === activeSessionId);
        if (!isCurrentRestSkipTurn()) { if (!isCurrentStream()) return; throw new Error("Mirror session changed"); }
        const rest = await readFitnessRestSkipForRequest({ text, ownerId: user.id, auth: supabase.auth, isCurrent: isCurrentRestSkipTurn });
        if (!isCurrentRestSkipTurn()) return;
        if (!rest || !isFitnessRestSkipRequestCurrent(rest)) throw new Error("Mirror session changed");
        const freshRestSkipSession = await supabase.auth.getSession();
        if (!isCurrentRestSkipTurn()) return;
        if (freshRestSkipSession.error || freshRestSkipSession.data.session?.user.id !== user.id || !freshRestSkipSession.data.session.access_token) throw new Error("Mirror session changed");
        if (!isFitnessRestSkipRequestCurrent(rest)) throw new Error("Mirror session changed");
        if (channelScope && !channelScope.matchesSession(freshRestSkipSession.data.session, channelLease)) throw new Error("Mirror session changed");
        requestSession = freshRestSkipSession.data.session;
        localRestSkipRequest = rest;
        body.fitness_rest_skip = rest;
      }

      if (localSetCompletionRequested) {
        const isCurrentSetCompletionTurn = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
          localWorkoutOrigin.ownerId === user.id && actionResultStreamRef.current.ownerId === user.id &&
          actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
          actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch &&
          actionResultSessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId &&
          (localWorkoutOrigin.sessionId === null || localWorkoutOrigin.sessionId === activeSessionId);
        if (!isCurrentSetCompletionTurn()) { if (!isCurrentStream()) return; throw new Error("Mirror session changed"); }
        const completion = await readFitnessCurrentSetCompletionForRequest({ text, ownerId: user.id, auth: supabase.auth, isCurrent: isCurrentSetCompletionTurn });
        if (!isCurrentSetCompletionTurn()) return;
        if (!completion || !isFitnessCurrentSetCompletionRequestCurrent(completion)) throw new Error("Mirror session changed");
        const freshSetCompletionSession = await supabase.auth.getSession();
        if (!isCurrentSetCompletionTurn()) return;
        if (freshSetCompletionSession.error || freshSetCompletionSession.data.session?.user.id !== user.id || !freshSetCompletionSession.data.session.access_token) throw new Error("Mirror session changed");
        if (!isFitnessCurrentSetCompletionRequestCurrent(completion)) throw new Error("Mirror session changed");
        if (channelScope && !channelScope.matchesSession(freshSetCompletionSession.data.session, channelLease)) throw new Error("Mirror session changed");
        requestSession = freshSetCompletionSession.data.session;
        localSetCompletionRequest = completion;
        body.fitness_set_completion = completion;
      }

      if (localSetupStartRequested) {
        const isCurrentSetupStartTurn = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
          localWorkoutOrigin.ownerId === user.id && actionResultStreamRef.current.ownerId === user.id &&
          actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
          actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch &&
          actionResultSessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId &&
          (localWorkoutOrigin.sessionId === null || localWorkoutOrigin.sessionId === activeSessionId);
        if (!isCurrentSetupStartTurn()) { if (!isCurrentStream()) return; throw new Error("Mirror session changed"); }
        const setup = await readFitnessSetupStartForRequest({ text, ownerId: user.id, auth: supabase.auth, isCurrent: isCurrentSetupStartTurn });
        if (!isCurrentSetupStartTurn()) return;
        if (!setup || !isFitnessSetupStartRequestCurrent(setup)) throw new Error("Mirror session changed");
        const freshSetupStartSession = await supabase.auth.getSession();
        if (!isCurrentSetupStartTurn()) return;
        if (freshSetupStartSession.error || freshSetupStartSession.data.session?.user.id !== user.id || !freshSetupStartSession.data.session.access_token) throw new Error("Mirror session changed");
        if (!isFitnessSetupStartRequestCurrent(setup)) throw new Error("Mirror session changed");
        if (channelScope && !channelScope.matchesSession(freshSetupStartSession.data.session, channelLease)) throw new Error("Mirror session changed");
        requestSession = freshSetupStartSession.data.session;
        localSetupStartRequest = setup;
        body.fitness_setup_start = setup;
      }

      if (localSetEditChanges) {
        const isCurrentSetEditTurn = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
          localWorkoutOrigin.ownerId === user.id && actionResultStreamRef.current.ownerId === user.id &&
          actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
          actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch &&
          actionResultSessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId &&
          (localWorkoutOrigin.sessionId === null || localWorkoutOrigin.sessionId === activeSessionId);
        if (!isCurrentSetEditTurn()) { if (!isCurrentStream()) return; throw new Error("Mirror session changed"); }
        const editor = await readFitnessCurrentSetEditForRequest({ text, ownerId: user.id, auth: supabase.auth, isCurrent: isCurrentSetEditTurn });
        if (!isCurrentSetEditTurn()) return;
        if (!editor || !isFitnessCurrentSetEditRequestCurrent(editor)) throw new Error("Mirror session changed");
        const freshSetEditSession = await supabase.auth.getSession();
        if (!isCurrentSetEditTurn()) return;
        if (freshSetEditSession.error || freshSetEditSession.data.session?.user.id !== user.id || !freshSetEditSession.data.session.access_token) throw new Error("Mirror session changed");
        if (!isFitnessCurrentSetEditRequestCurrent(editor)) throw new Error("Mirror session changed");
        if (channelScope && !channelScope.matchesSession(freshSetEditSession.data.session, channelLease)) throw new Error("Mirror session changed");
        requestSession = freshSetEditSession.data.session;
        localSetEditRequest = editor;
        body.fitness_current_set = editor;
      }

      if (localRestoreRequested) {
        const isCurrentRestoreTurn = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
          localWorkoutOrigin.ownerId === user.id && actionResultStreamRef.current.ownerId === user.id &&
          actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
          actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch &&
          actionResultSessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId &&
          (localWorkoutOrigin.sessionId === null || localWorkoutOrigin.sessionId === activeSessionId);
        if (!isCurrentRestoreTurn()) { if (!isCurrentStream()) return; throw new Error("Mirror session changed"); }
        const bindings = supabase as unknown as FitnessDraftRestoreBindings;
        const draft = await readFitnessDraftRestoreForRequest({ text, ownerId: user.id, auth: supabase.auth, bindings, isCurrent: isCurrentRestoreTurn });
        if (!isCurrentRestoreTurn()) return;
        if (!draft || !isFitnessDraftRestoreRequestCurrent(draft)) throw new Error("Mirror session changed");
        const freshRestoreSession = await supabase.auth.getSession();
        if (!isCurrentRestoreTurn()) return;
        if (freshRestoreSession.error || freshRestoreSession.data.session?.user.id !== user.id || !freshRestoreSession.data.session.access_token) throw new Error("Mirror session changed");
        if (!isFitnessDraftRestoreRequestCurrent(draft)) throw new Error("Mirror session changed");
        if (channelScope && !channelScope.matchesSession(freshRestoreSession.data.session, channelLease)) throw new Error("Mirror session changed");
        requestSession = freshRestoreSession.data.session;
        localRestoreRequest = draft;
        body.fitness_local_workout = draft;
      }

      if (localRuntimeAction) {
        const isCurrentRuntimeTurn = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
          localWorkoutOrigin.ownerId === user.id && actionResultStreamRef.current.ownerId === user.id &&
          actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
          actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch &&
          actionResultSessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId &&
          (localWorkoutOrigin.sessionId === null || localWorkoutOrigin.sessionId === activeSessionId);
        if (!isCurrentRuntimeTurn()) { if (!isCurrentStream()) return; throw new Error("Mirror session changed"); }
        const runtime = await readFitnessRuntimeForRequest({ text, ownerId: user.id, auth: supabase.auth, isCurrent: isCurrentRuntimeTurn });
        if (!isCurrentRuntimeTurn()) return;
        if (!runtime || !isFitnessRuntimeRequestCurrent(runtime)) throw new Error("Mirror session changed");
        const freshRuntimeSession = await supabase.auth.getSession();
        if (!isCurrentRuntimeTurn()) return;
        if (freshRuntimeSession.error || freshRuntimeSession.data.session?.user.id !== user.id || !freshRuntimeSession.data.session.access_token) throw new Error("Mirror session changed");
        if (!isFitnessRuntimeRequestCurrent(runtime)) throw new Error("Mirror session changed");
        if (channelScope && !channelScope.matchesSession(freshRuntimeSession.data.session, channelLease)) throw new Error("Mirror session changed");
        requestSession = freshRuntimeSession.data.session;
        localRuntimeRequest = runtime;
        body.fitness_runtime = runtime;
      }

      if (localWorkoutRequested) {
        const isCurrentLocalWorkoutTurn = () => isCurrentStream() &&
          !actionResultStreamRef.current.sessionTransition &&
          localWorkoutOrigin.ownerId === user.id && actionResultStreamRef.current.ownerId === user.id &&
          actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
          actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch &&
          actionResultSessionEpoch === localWorkoutOrigin.sessionEpoch &&
          activeSessionIdRef.current === activeSessionId &&
          (localWorkoutOrigin.sessionId === null || localWorkoutOrigin.sessionId === activeSessionId);
        if (!isCurrentLocalWorkoutTurn()) {
          if (!isCurrentStream()) return;
          // An initial Auth callback can settle after send began. Reuse the
          // existing rollback instead of leaving an optimistic turn stranded.
          throw new Error("Mirror session changed");
        }
        const localWorkout = await readFitnessLocalWorkoutForRequest({
          text, ownerId: user.id, auth: supabase.auth, isCurrent: isCurrentLocalWorkoutTurn,
        });
        if (!isCurrentLocalWorkoutTurn()) return;
        if (!localWorkout) throw new Error("Mirror session changed");
        const freshLocalSession = await supabase.auth.getSession();
        if (!isCurrentLocalWorkoutTurn()) return;
        if (freshLocalSession.error || freshLocalSession.data.session?.user.id !== user.id || !freshLocalSession.data.session.access_token) throw new Error("Mirror session changed");
        if (channelScope && !channelScope.matchesSession(freshLocalSession.data.session, channelLease)) throw new Error("Mirror session changed");
        requestSession = freshLocalSession.data.session;
        body.fitness_local_workout = localWorkout;
      }

      if (localDraftDiscardRequested) {
        const isCurrentDiscardTurn = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
          localWorkoutOrigin.ownerId === user.id && actionResultStreamRef.current.ownerId === user.id &&
          actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
          actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch &&
          actionResultSessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId &&
          (localWorkoutOrigin.sessionId === null || localWorkoutOrigin.sessionId === activeSessionId);
        if (!isCurrentDiscardTurn()) { if (!isCurrentStream()) return; throw new Error("Mirror session changed"); }
        const localDraft = await readFitnessLocalWorkoutForDiscardRequest({ text, ownerId: user.id, auth: supabase.auth, isCurrent: isCurrentDiscardTurn });
        if (!isCurrentDiscardTurn()) return;
        if (!localDraft) throw new Error("Mirror session changed");
        const freshDiscardSession = await supabase.auth.getSession();
        if (!isCurrentDiscardTurn()) return;
        if (freshDiscardSession.error || freshDiscardSession.data.session?.user.id !== user.id || !freshDiscardSession.data.session.access_token) throw new Error("Mirror session changed");
        if (channelScope && !channelScope.matchesSession(freshDiscardSession.data.session, channelLease)) throw new Error("Mirror session changed");
        requestSession = freshDiscardSession.data.session;
        body.fitness_local_workout = localDraft;
      }

      // Streaming via fetch + SSE (replaces supabase.functions.invoke)
      const supaUrl = import.meta.env.VITE_SUPABASE_URL;
      const supaAnonKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
      if (!isCurrentStream()) return;
      if (channelScope && !channelScope.matchesSession(requestSession, channelLease)) throw new Error("Mirror session changed");
      const accessToken = requestSession?.access_token || supaAnonKey;

      const streamRes = await fetch(`${supaUrl}/functions/v1/mirror-chat`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`,
          "apikey": supaAnonKey,
        },
        body: JSON.stringify(body),
        signal: streamController.signal,
      });
      if (!isCurrentStream()) return;

      // V4.3 — a 402 is a quota cap, NOT a dead connection. Read the body,
      // surface the right message (daily soft / monthly conversion), and bail
      // cleanly without the generic "conexão interrompida" toast.
      if (streamRes.status === 402) {
        const pe = await parsePaymentErrorFromResponse(streamRes);
        if (!isCurrentStream()) return;
        if (pe) {
          speechMeasurement?.finish("noaudio", "response_quota");
          handlePaymentError(pe);
          setRequestMessages((prev) =>
            prev.filter((m) => m !== userMsg && !(m.role === "assistant" && m.content === "" && !m.proposals))
          );
          goIdle();
          setIsLoading(false);
          return;
        }
      }

      if (!streamRes.ok || !streamRes.body) {
        throw new Error(`mirror-chat stream failed: ${streamRes.status}`);
      }

      // Add empty assistant message we will fill incrementally
      setRequestMessages((prev) => [...prev, { role: "assistant", content: "", ...(speechMeasurement ? { speechMeasurement: speechMeasurement.marker } : {}) }]);
      // Sonic identity — soft warm cue as the Mirror begins responding.
      sfx.mirrorSpeak();

      const reader = streamRes.body.getReader();
      const decoder = new TextDecoder();
      let buf = "";
      let finalReceived = false;
      let finalReplyText = "";
      // O `final` carrega o session_id resolvido pelo servidor. O state
      // `sessionId` ainda e null no primeiro turno de uma conversa nova, entao
      // e este valor — nao o do state — que localiza a linha recem-inserida.
      let finalSessionId: string | null = null;
      let finalMessageId: string | null = null;
      let finalProposals: ActionProposal[] = [];
      let finalActionResults: unknown[] = [];
      let finalBodyScanHandoff: MirrorBodyScanHandoff | null = null;
      let finalWindsorReportOrigin:MirrorWindsorReportOrigin|null=null;
      let finalFileEditOrigin:MirrorFileEditOrigin|null=null;
      let streamError: string | null = null;

      while (true) {
        const { done, value } = await reader.read();
        if (!isCurrentStream()) { await reader.cancel(); return; }
        if (done) break;
        buf += decoder.decode(value, { stream: true });

        const events = buf.split("\n\n");
        buf = events.pop() || "";

        for (const evtBlock of events) {
          if (!isCurrentStream()) { await reader.cancel(); return; }
          const eventLine = evtBlock.split("\n").find((l) => l.startsWith("event: "));
          const dataLine = evtBlock.split("\n").find((l) => l.startsWith("data: "));
          if (!eventLine || !dataLine) continue;

          const eventType = eventLine.slice(7).trim();
          const dataStr = dataLine.slice(6).trim();
          if (!dataStr) continue;

          try {
            const data = JSON.parse(dataStr);

            if (eventType === "delta" && typeof data.text === "string") {
              setRequestMessages((prev) =>
                prev.map((m, i) =>
                  i === prev.length - 1 && m.role === "assistant"
                    ? { ...m, content: m.content + data.text }
                    : m
                )
              );
            } else if (eventType === "final") {
              if (data.session_id !== activeSessionId) throw new Error("Mirror response session changed");
              finalReceived = true;
              // Defense-in-depth: never let an internal sentinel become a
              // visible bubble or a TTS payload, even if a path ever leaks it.
              finalReplyText = isInternalSentinel(data.response) ? "" : (data.response || "");
              speechMeasurement?.stableFinalText(typeof finalReplyText === "string" ? finalReplyText.length : 0);
              finalProposals = Array.isArray(data.proposals) ? data.proposals : [];
              finalSessionId = typeof data.session_id === "string" ? data.session_id : null;
              finalMessageId = typeof data.message_id === "string" ? data.message_id : null;
              finalActionResults = Array.isArray(data.action_results) ? data.action_results : [];
            } else if (eventType === "error") {
              streamError = data.error || "stream error";
            }
          } catch (parseErr) {
            console.warn("[MirrorChat] SSE parse error", parseErr);
          }
        }
      }

      speechMeasurement?.responseComplete();
      if (streamError) throw new Error(streamError);
      if (!finalReceived) throw new Error("Stream ended without final event");
      if (!isCurrentStream()) return;
      // A live literal edit grants selection only; history and unsolicited/mixed packets cannot open it.
      const fileEditPackets=finalProposals.filter(proposal=>String(proposal.tool)==='file_edit_request');
      if(mirrorFileEditTurnTargeted(text)||fileEditPackets.length>0){
        const authSessionId=fitnessCuratedPlanAuthSessionId(requestSession?.access_token);
        const isCurrent=()=>isCurrentStream()&&!actionResultStreamRef.current.sessionTransition
          &&actionResultStreamRef.current.ownerId===user.id&&activeSessionIdRef.current===activeSessionId
          &&actionResultStreamRef.current.authEpoch===actionResultAuthEpoch
          &&actionResultStreamRef.current.sessionEpoch===actionResultSessionEpoch
          &&fitnessCuratedPlanAuthSessionRef.current===authSessionId;
        const origin=!live&&!moduleContext&&!pendingNote&&!pendingGoal&&!hasAttachments
          ?prepareMirrorFileEditOrigin({ownerId:user.id,sessionId:activeSessionId,authSessionId,latestUserText:cleanText,
            proposals:finalProposals,actionResults:finalActionResults,finalSessionId,finalMessageId,isCurrent}):null;
        if(origin){finalFileEditOrigin=origin;setFileEditOrigin(origin);}
        finalProposals=[];
      }
      // Only the exact live packet can open Windsor selection. Never replay history
      // or allow an unsolicited report proposal to fall through to generic chips.
      const windsorPackets=finalProposals.filter(proposal=>String(proposal.tool)==='windsor_report_request');
      if(mirrorWindsorReportTurnTargeted(text)||windsorPackets.length>0){
        const authSessionId=fitnessCuratedPlanAuthSessionId(requestSession?.access_token);
        const isCurrent=()=>isCurrentStream()&&!actionResultStreamRef.current.sessionTransition
          &&actionResultStreamRef.current.ownerId===user.id&&activeSessionIdRef.current===activeSessionId
          &&actionResultStreamRef.current.authEpoch===actionResultAuthEpoch
          &&actionResultStreamRef.current.sessionEpoch===actionResultSessionEpoch
          &&fitnessCuratedPlanAuthSessionRef.current===authSessionId;
        const origin=!live&&!moduleContext&&!pendingNote&&!pendingGoal&&!hasAttachments
          ?prepareMirrorWindsorReportOrigin({ownerId:user.id,sessionId:activeSessionId,authSessionId,latestUserText:cleanText,
            proposals:finalProposals,actionResults:finalActionResults,finalSessionId,finalMessageId,isCurrent}):null;
        if(origin){finalWindsorReportOrigin=origin;setWindsorReportOrigin(origin);}
        finalProposals=[];
      }
      if (finalActionResults.length > 0 && finalSessionId === activeSessionId) {
        try {
          const currentAuth = await supabase.auth.getSession();
          if (!isCurrentStream()) return;
          if (channelScope && !channelScope.matchesSession(currentAuth.data.session, channelLease)) return;
          if (!currentAuth.error && currentAuth.data.session?.user.id === user.id) {
            finalBodyScanHandoff = bodyScanHandoffFromResults(finalActionResults, {
              ownerId: user.id, sessionId: activeSessionId, authEpoch: actionResultAuthEpoch,
              sessionEpoch: actionResultSessionEpoch, request: actionResultRequest,
            });
          }
          publishMirrorActionResults(finalActionResults, {
            userId: user.id,
            sessionId: activeSessionId,
            isCurrent: () => isCurrentStream() && !currentAuth.error && currentAuth.data.session?.user.id === user.id &&
              isCurrentMirrorActionRequest(
                { userId: user.id, sessionId: activeSessionId, authEpoch: actionResultAuthEpoch, request: actionResultRequest },
                { userId: actionResultStreamRef.current.ownerId, sessionId: activeSessionIdRef.current,
                  authEpoch: actionResultStreamRef.current.authEpoch, request: actionResultStreamRef.current.request,
                  mounted: actionResultStreamRef.current.mounted },
              ),
          });
        } catch {
          // A confirmed server write is still confirmed when a background
          // module refresh is unavailable. Keep the successful chat turn.
          console.warn("[MirrorChat] Confirmed action refresh unavailable");
        }
      }
      if (!isCurrentStream()) return;
      // Degenerate-but-successful turn: the stream completed (we DID get a
      // `final`) but it carried NO text AND NO proposal. This is the "corri de
      // bike" silent-loss (VYV-FRONTEND-1X): the old code threw here, the catch
      // reverted the user's message, and the capture vanished behind a generic
      // error. Instead — never drop it: the Espelho ASKS the user to repeat
      // (clarification ladder, capped at 3 by clarifyAttemptsRef), keeps their
      // message on screen, and stays out of the error path. Genuine upstream
      // failures throw earlier (streamError / no final received) and are
      // untouched, so this never masks a real outage.
      if (!finalReplyText && finalProposals.length === 0 && !finalBodyScanHandoff) {
        speechMeasurement?.finish("noaudio", "empty_response");
        clarifyAttemptsRef.current += 1;
        const giveUp = clarifyAttemptsRef.current >= 3;
        if (giveUp) clarifyAttemptsRef.current = 0; // reset the ladder after giving up
        const clarifyText = t(giveUp ? "mirror.clarify.giveUp" : "mirror.clarify.retry");
        // Replace the empty streaming placeholder with the clarification (mirrors
        // the success path below) so we never leave a blank bubble.
        setRequestMessages((prev) =>
          prev.map((m, i) =>
            i === prev.length - 1 && m.role === "assistant"
              ? { ...m, content: clarifyText }
              : m,
          ),
        );
        goIdle();
        if (autoplayAudio || live) speakResponse(clarifyText, isCurrentStream);
        return; // clean exit — `finally` clears isLoading; the user's message stays
      }
      // Any turn that actually said or proposed something clears the ladder.
      clarifyAttemptsRef.current = 0;

      // Route proposals through the universal-capture dispatcher: handlers
      // (e.g. agenda) intercept the proposals they claim (→ extractor → confirm
      // modal) and the UNHANDLED remainder flows to the legacy action-chip
      // pipeline. Old persisted proposals with non-handler tools (e.g.
      // create_agenda_event) still render via the chip's read-only branch.
      // Wrapped: a malformed proposal shape must NEVER bubble to the outer catch
      // (which reverts the user's message) — degrade to "no chips", never freeze.
      let chipProposals: ActionProposal[] = [];
      try {
        const financeProposals = finalProposals.filter(proposal => proposal.tool === 'propose_finance_action' || proposal.tool === 'propose_finance_log');
        if (financeMutationTargeted(text) || financeProposals.length > 0) {
          const prepared=createMirrorFinanceActions({userId:user.id,sessionId:activeSessionId,channel:'app',enabled:true,latestUserText:text}).prepare({raw_text:text});
          const proposal=financeProposals[0];
          const sameArgs=prepared&&proposal?.tool==='propose_finance_action'&&Object.keys(prepared).length===Object.keys(proposal.args).length
            &&Object.entries(prepared).every(([key,value])=>(proposal.args as unknown as Record<string,unknown>)[key]===value);
          const legacy=prepared&&prepared.entity==='transaction'&&prepared.action==='create'&&proposal?.tool==='propose_finance_log'
            &&Object.keys(proposal.args).length===1&&proposal.args.raw_text===text;
          finalProposals=financeProposals.length===1&&finalProposals.length===1&&!live&&!pendingNote&&!hasAttachments&&isCurrentStream()
            &&finalSessionId===activeSessionId&&financeUuid(proposal?.action_id)&&proposal.action_id===finalMessageId&&(sameArgs||legacy)?financeProposals:[];
        }
        const workoutFinishProposals = finalProposals.filter(proposal => proposal.tool === 'propose_fitness_workout_finish');
        finalProposals = finalProposals.filter(proposal => proposal.tool !== 'propose_fitness_workout_finish');
        if (localWorkoutFinishRequested && localWorkoutFinishRequest && workoutFinishProposals.length === 1 && finalProposals.length === 0 &&
          finalSessionId === activeSessionId && isCurrentStream()) {
          const proposal = workoutFinishProposals[0];
          if (!fitnessLocalWorkoutId(proposal.action_id)) throw new Error('invalid_request');
          const args = canonicalFitnessWorkoutFinishArgs(proposal.args, user.id);
          const isCurrent = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
            actionResultStreamRef.current.ownerId === user.id && actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
            actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId;
          if (JSON.stringify(args.snapshot) === JSON.stringify(localWorkoutFinishRequest) && isCurrent() && isFitnessWorkoutFinishRequestCurrent(localWorkoutFinishRequest)) {
            setFitnessWorkoutFinishPrefill({ ownerId: user.id, sessionId: activeSessionId, actionId: proposal.action_id, args, request: localWorkoutFinishRequest, isCurrent });
          }
        }
        // Unsupported or unsolicited finishing never authorizes siblings.
        if (localWorkoutFinishTurn || workoutFinishProposals.length > 0) finalProposals = [];
        const savedPlanPrepareProposals = finalProposals.filter(proposal => proposal.tool === 'propose_fitness_saved_plan_prepare');
        finalProposals = finalProposals.filter(proposal => proposal.tool !== 'propose_fitness_saved_plan_prepare');
        if (localSavedPlanPrepareRequested && localSavedPlanPrepareRequest && savedPlanPrepareProposals.length === 1 && finalProposals.length === 0 &&
          finalSessionId === activeSessionId && isCurrentStream()) {
          const proposal = savedPlanPrepareProposals[0];
          if (!fitnessLocalWorkoutId(proposal.action_id)) throw new Error('invalid_request');
          const args = canonicalFitnessSavedPlanPrepareArgs(proposal.args, user.id);
          const isCurrent = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
            actionResultStreamRef.current.ownerId === user.id && actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
            actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId;
          if (JSON.stringify(args.snapshot) === JSON.stringify(localSavedPlanPrepareRequest) && isCurrent() && isFitnessSavedPlanPrepareRequestCurrent(localSavedPlanPrepareRequest)) {
            setFitnessSavedPlanPreparePrefill({ ownerId: user.id, sessionId: activeSessionId, actionId: proposal.action_id, args, request: localSavedPlanPrepareRequest, isCurrent });
          }
        }
        // Unsupported or unsolicited preparation never authorizes siblings.
        if (localSavedPlanPrepareTurn || savedPlanPrepareProposals.length > 0) finalProposals = [];
        const restSkipProposals = finalProposals.filter(proposal => proposal.tool === 'propose_fitness_rest_skip');
        finalProposals = finalProposals.filter(proposal => proposal.tool !== 'propose_fitness_rest_skip');
        if (localRestSkipRequested && localRestSkipRequest && restSkipProposals.length === 1 && finalProposals.length === 0 &&
          finalSessionId === activeSessionId && isCurrentStream()) {
          const proposal = restSkipProposals[0];
          if (!fitnessLocalWorkoutId(proposal.action_id)) throw new Error('invalid_request');
          const args = canonicalFitnessRestSkipArgs(proposal.args, user.id);
          const isCurrent = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
            actionResultStreamRef.current.ownerId === user.id && actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
            actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId;
          if (JSON.stringify(args.snapshot) === JSON.stringify(localRestSkipRequest) && isCurrent() && isFitnessRestSkipRequestCurrent(localRestSkipRequest)) {
            setFitnessRestSkipPrefill({ ownerId: user.id, sessionId: activeSessionId, actionId: proposal.action_id, args, request: localRestSkipRequest, isCurrent });
          }
        }
        // Unsupported or unsolicited rest skip never authorizes siblings.
        if (localRestSkipTurn || restSkipProposals.length > 0) finalProposals = [];
        const setCompletionProposals = finalProposals.filter(proposal => proposal.tool === 'propose_fitness_current_set_completion');
        finalProposals = finalProposals.filter(proposal => proposal.tool !== 'propose_fitness_current_set_completion');
        if (localSetCompletionRequested && localSetCompletionRequest && setCompletionProposals.length === 1 && finalProposals.length === 0 &&
          finalSessionId === activeSessionId && isCurrentStream()) {
          const proposal = setCompletionProposals[0];
          if (!fitnessLocalWorkoutId(proposal.action_id)) throw new Error('invalid_request');
          const args = canonicalFitnessCurrentSetCompletionArgs(proposal.args, user.id);
          const isCurrent = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
            actionResultStreamRef.current.ownerId === user.id && actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
            actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId;
          if (JSON.stringify(args.snapshot) === JSON.stringify(localSetCompletionRequest) && isCurrent() && isFitnessCurrentSetCompletionRequestCurrent(localSetCompletionRequest)) {
            setFitnessCurrentSetCompletionPrefill({ ownerId: user.id, sessionId: activeSessionId, actionId: proposal.action_id, args, request: localSetCompletionRequest, isCurrent });
          }
        }
        // Unsupported or unsolicited set completion never authorizes siblings.
        if (localSetCompletionTurn || setCompletionProposals.length > 0) finalProposals = [];
        const setupStartProposals = finalProposals.filter(proposal => proposal.tool === 'propose_fitness_setup_start');
        finalProposals = finalProposals.filter(proposal => proposal.tool !== 'propose_fitness_setup_start');
        if (localSetupStartRequested && localSetupStartRequest && setupStartProposals.length === 1 && finalProposals.length === 0 &&
          finalSessionId === activeSessionId && isCurrentStream()) {
          const proposal = setupStartProposals[0];
          if (!fitnessLocalWorkoutId(proposal.action_id)) throw new Error('invalid_request');
          const args = canonicalFitnessSetupStartArgs(proposal.args, user.id);
          const isCurrent = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
            actionResultStreamRef.current.ownerId === user.id && actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
            actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId;
          if (JSON.stringify(args.snapshot) === JSON.stringify(localSetupStartRequest) && isCurrent() && isFitnessSetupStartRequestCurrent(localSetupStartRequest)) {
            setFitnessSetupStartPrefill({ ownerId: user.id, sessionId: activeSessionId, actionId: proposal.action_id, args, request: localSetupStartRequest, isCurrent });
          }
        }
        // Unsupported or unsolicited exercise control never authorizes siblings.
        if (localSetupStartTurn || setupStartProposals.length > 0) finalProposals = [];
        const setEditProposals = finalProposals.filter(proposal => proposal.tool === 'propose_fitness_current_set_edit');
        finalProposals = finalProposals.filter(proposal => proposal.tool !== 'propose_fitness_current_set_edit');
        if (localSetEditChanges && localSetEditRequest && setEditProposals.length === 1 && finalProposals.length === 0 &&
          finalSessionId === activeSessionId && isCurrentStream()) {
          const proposal = setEditProposals[0];
          if (!fitnessLocalWorkoutId(proposal.action_id)) throw new Error('invalid_request');
          const args = canonicalFitnessCurrentSetEditArgs(proposal.args, user.id);
          const isCurrent = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
            actionResultStreamRef.current.ownerId === user.id && actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
            actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId;
          if (JSON.stringify(args.snapshot) === JSON.stringify(localSetEditRequest) && JSON.stringify(args.changes) === JSON.stringify(localSetEditChanges) &&
            isCurrent() && isFitnessCurrentSetEditRequestCurrent(localSetEditRequest)) {
            setFitnessCurrentSetEditPrefill({ ownerId: user.id, sessionId: activeSessionId, actionId: proposal.action_id, args, request: localSetEditRequest, isCurrent });
          }
        }
        // A targeted or unsolicited editor proposal cannot authorize sibling
        // actions, module capture, historical chips or another set's editor.
        if (localSetEditTurn || setEditProposals.length > 0) finalProposals = [];
        const restoreProposals = finalProposals.filter(proposal => proposal.tool === 'propose_fitness_draft_restore');
        finalProposals = finalProposals.filter(proposal => proposal.tool !== 'propose_fitness_draft_restore');
        // Only the current literal request's issued object can stage a restore.
        if (localRestoreRequested && localRestoreRequest && restoreProposals.length === 1 && finalProposals.length === 0 &&
          finalSessionId === activeSessionId && isCurrentStream()) {
          const proposal = restoreProposals[0];
          if (!fitnessLocalWorkoutId(proposal.action_id)) throw new Error('invalid_request');
          const args = canonicalRestoreArgs(proposal.args, user.id);
          const isCurrent = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
            actionResultStreamRef.current.ownerId === user.id && actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
            actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId;
          if (JSON.stringify(args.snapshot) === JSON.stringify(localRestoreRequest) && isCurrent() && isFitnessDraftRestoreRequestCurrent(localRestoreRequest)) {
            setFitnessDraftRestorePrefill({ ownerId: user.id, sessionId: activeSessionId, actionId: proposal.action_id, args, request: localRestoreRequest, isCurrent });
          }
        }
        // Denied, mixed, historical and unsolicited restore batches cannot reach
        // any other module capture or generic chip execution.
        if (localRestoreTurn || restoreProposals.length > 0) finalProposals = [];
        const runtimeProposals = finalProposals.filter(proposal => proposal.tool === 'propose_fitness_runtime_action');
        finalProposals = finalProposals.filter(proposal => proposal.tool !== 'propose_fitness_runtime_action');
        // The reader-issued object pins private run/epoch/revision across SSE.
        // Historical, unsolicited, cloned or mixed proposals cannot stage control.
        if (localRuntimeAction && localRuntimeRequest && runtimeProposals.length === 1 && finalProposals.length === 0 &&
          finalSessionId === activeSessionId && isCurrentStream()) {
          const proposal = runtimeProposals[0];
          if (!fitnessLocalWorkoutId(proposal.action_id)) throw new Error('invalid_request');
          const args = canonicalFitnessRuntimeActionArgs(proposal.args, user.id);
          const isCurrent = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
            actionResultStreamRef.current.ownerId === user.id && actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
            actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId;
          if (args.action === localRuntimeAction && JSON.stringify(args.snapshot) === JSON.stringify(localRuntimeRequest) &&
            isCurrent() && isFitnessRuntimeRequestCurrent(localRuntimeRequest)) {
            setFitnessRuntimePrefill({ ownerId: user.id, sessionId: activeSessionId, actionId: proposal.action_id, args, request: localRuntimeRequest, isCurrent });
          }
        }
        // A targeted or unsolicited controller batch must not fall through into
        // another module's capture modal or a historical generic chip executor.
        if (localRuntimeTurn || runtimeProposals.length > 0) finalProposals = [];
        const draftProposals = finalProposals.filter(proposal => proposal.tool === 'propose_fitness_local_draft_discard');
        finalProposals = finalProposals.filter(proposal => proposal.tool !== 'propose_fitness_local_draft_discard');
        // Only this new literal request and its frozen SSE origin may open a
        // local review. Persisted/unsolicited proposals never gain authority.
        if (localDraftDiscardRequested && draftProposals.length === 1 && finalSessionId === activeSessionId && isCurrentStream()) {
          const proposal = draftProposals[0];
          if (!fitnessLocalWorkoutId(proposal.action_id)) throw new Error('invalid_request');
          const args = canonicalDiscardArgs(proposal.args, user.id);
          const isCurrent = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition &&
            actionResultStreamRef.current.ownerId === user.id && actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch &&
            actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch && activeSessionIdRef.current === activeSessionId;
          if (isCurrent()) setFitnessDraftDiscardPrefill({ ownerId: user.id, sessionId: activeSessionId, actionId: proposal.action_id, args, isCurrent });
        }
        const mealProposals = finalProposals.filter(proposal => proposal.tool === 'propose_nutrition_meal_action');
        if (mealProposals.length === 1 && finalProposals.length === 1 && !live && !moduleContext && !pendingNote && !hasAttachments && isCurrentStream()) {
          const proposal = mealProposals[0], args = proposal.args as NutritionMealProposalArgs;
          const prepared = createMirrorNutritionMealActions({ userId: user.id, sessionId: activeSessionId, channel: 'app', enabled: true, latestUserText: text }).prepare({
            action: args.action, ...(args.meal_id ? { meal_id: args.meal_id } : {}), ...(args.fields ? { fields: args.fields } : {}),
          });
          const isCurrent = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition && actionResultStreamRef.current.ownerId === user.id && activeSessionIdRef.current === activeSessionId;
          if (prepared && sameNutritionMealValue(prepared, args)) nutritionMealLiveOrigins.current.set(proposal.action_id, { args: prepared, isCurrent });
        }
        const hydrationProposals = finalProposals.filter(proposal => proposal.tool === 'propose_nutrition_hydration_action');
        if (hydrationProposals.length === 1 && finalProposals.length === 1 && !live && !moduleContext && !pendingNote && !hasAttachments && isCurrentStream()) {
          const proposal = hydrationProposals[0], args = proposal.args as NutritionHydrationProposalArgs;
          const requested = nutritionHydrationCurrentRequest(text);
          const isCurrent = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition && actionResultStreamRef.current.ownerId === user.id
            && actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch && actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch
            && activeSessionIdRef.current === activeSessionId;
          if (requested && args && Object.keys(args).length === 3 && requested.action === args.action && requested.cups === args.cups
            && validNutritionHydrationDate(args.date) && (!requested.literalDate || requested.literalDate === args.date)) {
            nutritionHydrationLiveOrigins.current.set(proposal.action_id, { args: structuredClone(args), isCurrent });
          }
        }
        const languageProposals = finalProposals.filter(proposal => proposal.tool === 'propose_language_action');
        if (languageProposals.length === 1 && finalProposals.length === 1 && !live && !moduleContext && !pendingNote && !hasAttachments && isCurrentStream()) {
          const proposal = languageProposals[0], args = proposal.args as LanguageProposalArgs;
          const prepared = createMirrorLanguageActions({ userId: user.id, sessionId: activeSessionId, channel: 'app', enabled: true, latestUserText: text }).prepare({raw_text:text});
          const isCurrent = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition && actionResultStreamRef.current.ownerId === user.id
            && actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch && actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch
            && activeSessionIdRef.current === activeSessionId;
          if (prepared && sameLanguageValue(prepared, args)) languageLiveOrigins.current.set(proposal.action_id, { args: structuredClone(prepared), isCurrent });
        }
        const languageClassProposals = finalProposals.filter(proposal => proposal.tool === 'propose_language_class_action');
        if (languageClassProposals.length === 1 && finalProposals.length === 1 && !live && !moduleContext && !pendingNote && !hasAttachments && isCurrentStream()) {
          const proposal = languageClassProposals[0], args = proposal.args as LanguageClassProposalArgs;
          const prepared = createMirrorLanguageClassActions({ userId: user.id, sessionId: activeSessionId, channel: 'app', enabled: true, tutorEnabled: true, latestUserText: text }).prepare('propose_language_class_action', {raw_text:text});
          const isCurrent = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition && actionResultStreamRef.current.ownerId === user.id
            && actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch && actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch
            && activeSessionIdRef.current === activeSessionId;
          if (prepared && sameLanguageClassValue(prepared, args)) languageClassLiveOrigins.current.set(proposal.action_id, { args: structuredClone(prepared as LanguageClassProposalArgs), isCurrent });
        }
        const tutorProposals = finalProposals.filter(proposal => proposal.tool === 'prepare_language_tutor_handoff');
        if (tutorProposals.length === 1 && finalProposals.length === 1 && !live && !moduleContext && !pendingNote && !hasAttachments && isCurrentStream()) {
          const proposal = tutorProposals[0], args = proposal.args as LanguageTutorHandoffArgs;
          const prepared = createMirrorLanguageClassActions({ userId: user.id, sessionId: activeSessionId, channel: 'app', enabled: true, tutorEnabled: true, latestUserText: text }).prepare('prepare_language_tutor_handoff', {raw_text:text});
          const isCurrent = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition && actionResultStreamRef.current.ownerId === user.id
            && actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch && actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch
            && activeSessionIdRef.current === activeSessionId;
          if (prepared && sameLanguageClassValue(prepared, args)) languageTutorLiveOrigins.current.set(proposal.action_id, { args: structuredClone(args), isCurrent });
        }
        const brainProposals = finalProposals.filter(proposal => ['propose_brain_note_action', 'prepare_brain_handoff'].includes(proposal.tool));
        if (brainProposals.length === 1 && finalProposals.length === 1 && !live && !moduleContext && !pendingNote && !hasAttachments && isCurrentStream()) {
          const proposal = brainProposals[0];
          const prepared = prepareCurrentBrainProposal(proposal.tool, proposal.args, user.id, activeSessionId, text);
          const isCurrent = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition && actionResultStreamRef.current.ownerId === user.id
            && actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch && actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch
            && activeSessionIdRef.current === activeSessionId;
          if (prepared && isCurrent()) {
            if (proposal.tool === 'propose_brain_note_action') brainNoteLiveOrigins.current.set(proposal.action_id, { args: prepared as BrainNoteProposalArgs, isCurrent });
            else brainHandoffLiveOrigins.current.set(proposal.action_id, { args: prepared as BrainHandoffArgs, isCurrent });
          }
        }
        const goalsProposals = finalProposals.filter(proposal => proposal.tool === 'propose_nutrition_goals_action');
        if (goalsProposals.length === 1 && finalProposals.length === 1 && !live && !moduleContext && !pendingNote && !hasAttachments && isCurrentStream()) {
          const proposal = goalsProposals[0], args = proposal.args as NutritionGoalsProposalArgs;
          const prepared = createMirrorNutritionGoalsActions({ userId: user.id, sessionId: activeSessionId, channel: 'app', enabled: true, latestUserText: text }).prepare({raw_text:text});
          const isCurrent = () => isCurrentStream() && !actionResultStreamRef.current.sessionTransition && actionResultStreamRef.current.ownerId === user.id
            && actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch && actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch
            && activeSessionIdRef.current === activeSessionId;
          if (prepared && sameNutritionGoalsValue(prepared, args)) nutritionGoalsLiveOrigins.current.set(proposal.action_id, { args: structuredClone(prepared), isCurrent });
        }
        const curatedProposals = finalProposals.filter(proposal => proposal.tool === 'propose_fitness_curated_plan');
        if (curatedProposals.length === 1 && finalProposals.length === 1 && !live && !moduleContext && !pendingNote && !hasAttachments && isCurrentStream()) {
          const proposal = curatedProposals[0], args = proposal.args as FitnessCuratedPlanProposalArgs;
          const prepared = createMirrorFitnessCuratedPlans({ userId: user.id, sessionId: activeSessionId, channel: 'app', enabled: true, latestUserText: text, language: lang }).prepare({raw_text:text});
          const authSession = fitnessCuratedPlanAuthSessionRef.current;
          const isCurrent = () => !!authSession && fitnessCuratedPlanAuthSessionRef.current === authSession && isCurrentStream() && !actionResultStreamRef.current.sessionTransition && actionResultStreamRef.current.ownerId === user.id
            && actionResultStreamRef.current.authEpoch === localWorkoutOrigin.authEpoch && actionResultStreamRef.current.sessionEpoch === localWorkoutOrigin.sessionEpoch
            && activeSessionIdRef.current === activeSessionId;
          if (prepared && sameFitnessCuratedPlanValue(prepared, args)) fitnessCuratedPlanLiveOrigins.current.set(proposal.action_id, { args: structuredClone(prepared), isCurrent });
        }
        chipProposals = captureRef.current.routeProposals(finalProposals, text);
      } catch (routeErr) {
        console.error("[MirrorChat] routeProposals threw — proposals not routed", routeErr);
      }

      // F1 PR 2 — a procedência vem do SERVIDOR quando ele a manda. Até aqui o
      // cliente guardava a própria lista, o que são dois caminhos para o mesmo
      // fato: ele envia 3 ids, o servidor resolve só os 2 que estão `ready`, e
      // o chip levaria 3 para o deliverable-generate. O eco do servidor é a
      // lista REALMENTE usada no turno.
      //
      // O fallback existe pela janela de deploy, não como segunda fonte: o
      // front sobe pela Vercel a cada merge e as edge functions vão a mão
      // (regra 4.3), então por algumas horas roda um cliente novo contra um
      // mirror-chat velho, que não carimba nada. Sem o fallback, nesse
      // intervalo o anexo simplesmente sumiria do chip.
      const proposalStates: ProposalChipState[] = chipProposals.map((p) => ({
        proposal: p,
        attachmentIds:
          p.tool === "propose_deliverable" && Array.isArray(p.attachment_ids)
            ? p.attachment_ids
            : attachmentIds,
        status: "pending",
      }));

      setRequestMessages((prev) =>
        prev.map((m, i) =>
          i === prev.length - 1 && m.role === "assistant"
            ? {
                ...m,
                content: finalReplyText,
                proposals: proposalStates.length > 0 ? proposalStates : undefined,
                bodyScanHandoff: finalBodyScanHandoff,
                ...(finalWindsorReportOrigin?{id:finalWindsorReportOrigin.actionId}:{}),
                ...(finalFileEditOrigin?{id:finalFileEditOrigin.actionId}:{}),
              }
            : m
        )
      );

      // Denuncia (Google AI-content policy): a bolha que ACABOU de chegar nao
      // tem id. O `final` do SSE carrega { response, proposals, session_id } e
      // nada mais — so as mensagens carregadas do historico trazem
      // mirror_messages.id. Sem um id estavel a denuncia nao teria o que
      // identificar e o corte nao sobreviveria a recarga.
      //
      // Nao ha corrida: o mirror-chat INSERE a linha do assistant ANTES de
      // emitir o `final` (index.ts, persist.assistant -> sendEvent). Quando
      // este codigo roda, a linha ja existe. Um SELECT de uma linha e o preco
      // de nao mexer no contrato do edge fn — que tem historico de revert por
      // scope creep (588849a) e so vai ao ar por deploy manual (regra 4.3),
      // ou seja: mudar o SSE deixaria o app sem denuncia ate o Rafa deployar.
      void stampAssistantMessageId(finalSessionId, finalReplyText, setRequestMessages, isCurrentStream);

      // Release the REFLETINDO state machine. presenceState lives in
      // useMirrorState, which has no auto-transition out of "thinking" —
      // it relies on TTS firing to flip "thinking" → "speaking" → "idle".
      // When Sonnet emits only tool_use without an accompanying text bubble
      // (e.g. on a re-emit caught by the module-capture guard), finalReplyText
      // is empty, TTS never fires, and the avatar stays stuck on REFLETINDO
      // until the user manually navigates away. Always call goIdle() first;
      // if TTS does fire below, its useEffect transitions idle → speaking
      // on the next tick.
      goIdle();
      // V4.3: no auto-play by default (it silently burned the Free 3-min TTS
      // cap). Speak only when the user opted in via Settings; otherwise the
      // per-message "listen" button plays on demand.
      // Live (Option C) is voice-first and Premium-gated, and it HIDES the
      // conversation panel where the on-demand "listen" button lives — so the
      // reply must auto-speak there regardless of the autoplay setting, or the
      // Mirror would be silent with no trigger.
      if (finalReplyText && (autoplayAudio || live)) {
        if (speechMeasurement && speechMeasurement.voiceEnabled === false) speechMeasurement.finish("noaudio", "voice_disabled");
        else if (speechMeasurement) speakResponse(finalReplyText, isCurrentStream, speechMeasurement);
        else speakResponse(finalReplyText, isCurrentStream);
      } else speechMeasurement?.finish("noaudio", finalReplyText ? "voice_disabled" : "empty_response");

      // Modo Professor: the tutor emits [[learned:WORD]] on success. Parse it
      // here (same place [[tr]] is handled at display/TTS), credit each word
      // once per session, and hand it to the wrapper for mastery + XP. Gated to
      // the language tutor so the Espelho is never affected.
      if (moduleContext === "language_tutor" && onWordLearned && finalReplyText) {
        const markerRe = /\[\[learned:\s*([^\]]+?)\s*\]\]/gi;
        let mk: RegExpExecArray | null;
        while ((mk = markerRe.exec(finalReplyText)) !== null) {
          const w = mk[1].trim();
          const key = w.toLowerCase();
          if (w && !learnedThisSessionRef.current.has(key)) {
            learnedThisSessionRef.current.add(key);
            onWordLearned(w);
          }
        }
      }

      // Only auto-title brand-new sessions (no prior messages AND no title yet).
      // Reads `reply` from the edge function response (legacy branch returns it
      // under that key; `data.title` was a bug that stopped titles from persisting).
      if (currentMessages.length === 0) {
        void (async () => {
          try {
            if (!isCurrentStream()) return;
            const titleRes = await supabase.functions.invoke("mirror-chat", {
              headers: { Authorization: "Bearer " + accessToken },
              body: {
                promptType: "generate_title",
                messages: [{ role: "user", content: cleanText }],
                // Apple 3.1.1 — passed for uniformity; title generation doesn't surface prices but
                // keeps the contract identical across all mirror-chat call sites.
                platform: isIOSNative() ? "ios" : "web",
              },
            });
            const rawTitle: string | undefined = titleRes.data?.reply || titleRes.data?.title;
            if (!isCurrentStream()) return;
            const title = rawTitle?.trim().replace(/^["']|["']$/g, "").slice(0, 80);
            if (title && title.length > 0) {
              await supabase.from("mirror_sessions").update({ title } as any).eq("id", activeSessionId).eq("user_id", user.id);
              if (!isCurrentStream()) return;
              // Refresh history so the new title appears immediately
              void loadHistorySessions();
            }
          } catch (err) {
            console.warn("[generate_title] failed:", err);
          }
        })();
      }

      if (whatsappReviewSelection) attachments.clearReview(whatsappReviewSelection.messageId);
      void loadHistorySessions();
    } catch (err) {
      if (!isCurrentStream()) return;
      speechMeasurement?.finish("error", "response_error");
      console.error("Mirror chat error:", err);
      // Revert optimistic user message AND any empty streaming assistant message
      setRequestMessages((prev) =>
        prev.filter((m) => m !== userMsg && !(m.role === "assistant" && m.content === "" && !m.proposals))
      );
      // The edge fn persisted NOTHING for a failed turn (12/06 contract) —
      // give the text back to the input so one tap resends it.
      if (hasText && (!whatsappReviewSelection || !reviewComposerDraftRef.current.trim())) setInput(text);
      // Honest error (11/06 blip showed "connection" errors for an Anthropic
      // outage): upstream markers come from the edge fn's SSE error events /
      // 5xx, network failures throw TypeError from fetch itself.
      const errMsg = String((err as Error)?.message ?? err);
      const isUpstream =
        errMsg.includes("claude upstream failed") ||
        errMsg.includes("empty_response") ||
        errMsg.includes("stream failed") ||
        errMsg.includes("Empty response") ||
        errMsg.includes("Stream ended") ||
        /stream failed: 5\d\d/.test(errMsg);
      toast.error(isUpstream ? t("mirror.error.upstream") : t("mirror.error"));
      try {
        Sentry.captureException(err instanceof Error ? err : new Error(errMsg), {
          tags: { feature: "mirror_send_failed" },
          extra: { upstream: isUpstream, live, moduleContext: moduleContext ?? null },
        });
      } catch { /* Sentry not initialized in dev */ }
      goIdle();
    } finally {
      if (isCurrentStream()) {
        setIsLoading(false);
        actionResultStreamRef.current.controller = null;
      }
    }
  };

  const handleCancelVoice = (restoreDraft = true) => {
    const capture = voiceCaptureRef.current;
    voiceCaptureRef.current = null;
    voiceWhisper.cancelListening(capture?.guard);
    voiceLegacy.cancelListening();
    if (!actionResultStreamRef.current.mounted) return;
    setIsVoiceStarting(false);
    setVoiceDraftReady(false);
    if (restoreDraft && capture) setInput(capture.draft);
    goIdle();
  };
  cancelVoiceRef.current = handleCancelVoice;

  const handleVoicePress = async () => {
    if (actionResultStreamRef.current.authScope && actionResultStreamRef.current.authEpoch !== captureAuthEpoch) return;
    if (isVoiceStarting || isTranscribing || voiceCaptureRef.current?.starting) return;
    // The first tap still speaks the existing welcome. Later taps record.
    if (spokenWelcomePending && !voice.isListening) {
      wakeSpokenWelcome();
      return;
    }
    if (voice.isListening) {
      const capture = voiceCaptureRef.current;
      if (!capture || capture.stopping) return;
      capture.stopping = true;
      const finalText = VOICE_WHISPER_ENABLED
        ? await voiceWhisper.stopListening(capture.guard)
        : voiceLegacy.stopListening();
      const state = actionResultStreamRef.current;
      if (voiceCaptureRef.current !== capture || !state.mounted || state.authEpoch !== capture.authEpoch || state.sessionEpoch !== capture.sessionEpoch) return;
      const text = finalText || (!VOICE_WHISPER_ENABLED ? voiceLegacy.transcript : "");
      goIdle();
      if (!text.trim()) {
        voiceCaptureRef.current = null;
        setInput(capture.draft);
        toast.error(t("mirror.didntCatch"));
        return;
      }
      sfx.confirm("mirror");
      if (live) {
        voiceCaptureRef.current = null;
        void sendMessage(text);
      } else {
        setInput(capture.draft ? capture.draft + "\n" + text : text);
        capture.reviewing = true;
        setVoiceDraftReady(true);
      }
    } else if (!isLoading) {
      // Preserve any typed draft so Cancel is lossless and repeated recordings
      // append to the text the user is reviewing, rather than silently erase it.
      const state = actionResultStreamRef.current;
      const scope = state.authScope, lease = scope?.capture() ?? null;
      if (scope && !lease) return;
      const capture: NonNullable<typeof voiceCaptureRef.current> = { draft: input, authEpoch: state.authEpoch, sessionEpoch: state.sessionEpoch, stopping: false, starting: true, reviewing: false, ...(lease ? { lease } : {}) };
      voiceCaptureRef.current = capture;
      setVoiceDraftReady(false);
      setIsVoiceStarting(true);
      setShowConversation(true);
      handleStopSpeaking();
      const isCurrent = () => voiceCaptureRef.current === capture && state.mounted && state.authEpoch === capture.authEpoch && state.sessionEpoch === capture.sessionEpoch
        && (!scope || scope.isCurrent(lease));
      if (scope && lease) capture.guard = { ownerId: lease.ownerId, authSessionId: lease.authSessionId, isCurrent };
      try {
        let started: boolean | void = undefined;
        if (VOICE_WHISPER_ENABLED) {
          started = await voiceWhisper.startListening(capture.guard);
        } else {
          // Keep the existing iOS playback unlock, with cancellation checked
          // after its await so a cancelled start cannot open the microphone.
          try {
            const audioEl = audioElementRef.current;
            if (audioEl) {
              audioEl.pause(); audioEl.src = SILENT_MP3; audioEl.load();
              await audioEl.play();
              if (!isCurrent()) return;
              audioEl.pause(); audioEl.src = ""; audioEl.removeAttribute("src"); audioEl.load();
            }
          } catch { /* iOS session reset best-effort */ }
          if (isCurrent()) started = voiceLegacy.startListening();
        }
        if (started === false && isCurrent()) {
          voiceCaptureRef.current = null;
          setIsVoiceStarting(false);
          setInput(capture.draft);
          goIdle();
        }
      } catch (error) {
        if (isCurrent()) { console.warn("[MirrorChat] Voice capture unavailable", error); handleCancelVoice(); }
      } finally {
        if (isCurrent()) { capture.starting = false; setIsVoiceStarting(false); }
      }
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (voiceBusy || isLoading || (voiceCaptureRef.current && !voiceCaptureRef.current.reviewing)) return;
    voiceCaptureRef.current = null;
    setVoiceDraftReady(false);
    void sendMessage(input);
  };

  // Modo Professor auto-kickoff — fire ONE auto-spoken opener once the day-set
  // is ready, so the tutor greets first and introduces 2-3 day-words instead of
  // waiting for the user to speak. NON-gesture: this is the single place a turn
  // is auto-sent on mount. Guarded against double-fire (and React 18 strict
  // double-mount) by kickoffFiredRef. Gated to live + language_tutor + an
  // explicit autoKickoff prop, so the plain Espelho Live never auto-talks.
  const kickoffFiredRef = useRef(false);
  useEffect(() => {
    if (!autoKickoff || !live || moduleContext !== "language_tutor") return;
    if (kickoffFiredRef.current) return;
    // Wait until the wrapper SETTLED the day-set build (success, empty,
    // failure or timeout) — NOT until words exist. Gating on a non-empty set
    // froze the kickoff forever whenever the build failed or resolved empty
    // (the production spine bug). With no words, the opener goes generic —
    // mirror-chat handles a missing TODAY'S WORDS block.
    if (!tutorWordsReady) return;
    kickoffFiredRef.current = true;
    // If the user already spoke first (slow set build), the session is
    // underway — injecting the seed now would interrupt mid-conversation.
    if (messages.some((m) => m.role === "user")) return;
    // The seed is the "user" turn that prompts the tutor to begin; the opener
    // few-shot in mirror-chat turns it into a spoken greeting (+ day-words
    // when the set exists).
    sendMessage(t("language.tutor.kickoffSeed"));
    // sendMessage is a stable-enough closure for a one-shot; deps intentionally
    // limited to the kickoff gate + set readiness.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoKickoff, live, moduleContext, tutorWordsReady]);

  // Agenda-extract delegation (propose_agenda_event → agenda-extract →
  // CreateEventModal) moved to useModuleCapture + agendaCaptureHandler. The
  // dispatch happens in `capture.routeProposals(...)` at the SSE seam above.

  // ── Mirror action chip handlers ──
  const updateProposalState = (
    msgIdx: number,
    propIdx: number,
    patch: Partial<ProposalChipState>,
  ) => {
    setMessages((prev) =>
      prev.map((m, i) => {
        if (i !== msgIdx || !m.proposals) return m;
        return {
          ...m,
          proposals: m.proposals.map((p, j) => (j === propIdx ? { ...p, ...patch } : p)),
        };
      }),
    );
  };

  const showNutritionMealActionModal = async (proposal: ActionProposal) => {
    if (proposal.tool !== 'propose_nutrition_meal_action') throw new Error('invalid_request');
    const state = actionResultStreamRef.current, ownerId = state.ownerId, originalSession = activeSessionIdRef.current;
    const origin = { authEpoch: state.authEpoch, sessionEpoch: state.sessionEpoch, request: state.request };
    const isCurrent = () => state.mounted && !state.sessionTransition && state.ownerId === ownerId && activeSessionIdRef.current === originalSession
      && state.authEpoch === origin.authEpoch && state.sessionEpoch === origin.sessionEpoch && state.request === origin.request;
    const assert = () => { if (!isCurrent() || !ownerId || !originalSession) throw new Error('invalid_session'); };
    assert(); const operationId = await nutritionMealOriginOperationId(ownerId!, originalSession!, proposal.action_id, assert); assert();
    const liveOrigin = nutritionMealLiveOrigins.current.get(proposal.action_id), args = liveOrigin?.isCurrent() ? liveOrigin.args : proposal.args as NutritionMealProposalArgs;
    if (!['update', 'delete'].includes(args.action) || typeof args.picker_only !== 'boolean' || args.meal_id && nutritionMealId(args.meal_id) !== args.meal_id) throw new Error('invalid_request');
    const fields = args.fields === undefined ? undefined : canonicalNutritionMealFields(args.fields);
    nutritionMealActor.current = { operation_id: operationId, isCurrent };
    setNutritionMealPrefill(parseNutritionMealActionPrefill({ action: args.action, action_id: proposal.action_id, operation_id: operationId,
      ...(args.meal_id ? { meal_id: args.meal_id } : {}), ...(fields ? { fields } : {}), picker_only: args.picker_only,
      ...(args.scope ? { scope: structuredClone(args.scope) } : {}),
      expected_user_id: ownerId!, expected_session_id: originalSession!, recovery_only: !liveOrigin?.isCurrent() }));
  };

  const showNutritionHydrationActionModal = async (proposal: ActionProposal) => {
    if (proposal.tool !== 'propose_nutrition_hydration_action') throw new Error('invalid_request');
    const state = actionResultStreamRef.current, ownerId = state.ownerId, originalSession = activeSessionIdRef.current;
    const origin = { authEpoch: state.authEpoch, sessionEpoch: state.sessionEpoch, request: state.request };
    const isCurrent = () => state.mounted && !state.sessionTransition && state.ownerId === ownerId && activeSessionIdRef.current === originalSession
      && state.authEpoch === origin.authEpoch && state.sessionEpoch === origin.sessionEpoch && state.request === origin.request;
    const assert = () => { if (!isCurrent() || !ownerId || !originalSession) throw new Error('invalid_session'); };
    assert(); const operationId = await nutritionHydrationOriginOperationId(ownerId!, originalSession!, proposal.action_id, assert); assert();
    const liveOrigin = nutritionHydrationLiveOrigins.current.get(proposal.action_id), args = liveOrigin?.isCurrent() ? liveOrigin.args : proposal.args as NutritionHydrationProposalArgs;
    const prefill = parseNutritionHydrationActionPrefill({ ...args, action_id: proposal.action_id, operation_id: operationId,
      expected_user_id: ownerId!, expected_session_id: originalSession!, recovery_only: !liveOrigin?.isCurrent() });
    nutritionHydrationActor.current = { operation_id: operationId, isCurrent }; setNutritionHydrationPrefill(prefill);
  };

  const showLanguageActionModal = async (proposal: ActionProposal) => {
    if (proposal.tool !== 'propose_language_action') throw new Error('invalid_request');
    const state = actionResultStreamRef.current, ownerId = state.ownerId, originalSession = activeSessionIdRef.current;
    const origin = { authEpoch: state.authEpoch, sessionEpoch: state.sessionEpoch, request: state.request };
    const isCurrent = () => state.mounted && !state.sessionTransition && state.ownerId === ownerId && activeSessionIdRef.current === originalSession
      && state.authEpoch === origin.authEpoch && state.sessionEpoch === origin.sessionEpoch && state.request === origin.request;
    const assert = () => { if (!isCurrent() || !ownerId || !originalSession) throw new Error('invalid_session'); };
    assert(); const operationId = await languageOriginOperationId(ownerId!, originalSession!, proposal.action_id, assert); assert();
    const liveOrigin = languageLiveOrigins.current.get(proposal.action_id), args = liveOrigin?.isCurrent() ? liveOrigin.args : proposal.args as LanguageProposalArgs;
    const prefill = parseLanguageActionPrefill({ ...args, fields: args.fields ?? {}, action_id: proposal.action_id, operation_id: operationId,
      expected_user_id: ownerId!, expected_session_id: originalSession!, recovery_only: !liveOrigin?.isCurrent() });
    languageActor.current = { operation_id: operationId, isCurrent }; setLanguagePrefill(prefill);
  };

  const showLanguageClassActionModal = async (proposal: ActionProposal) => {
    if (proposal.tool !== 'propose_language_class_action') throw new Error('invalid_request');
    const state = actionResultStreamRef.current, ownerId = state.ownerId, originalSession = activeSessionIdRef.current;
    const origin = { authEpoch: state.authEpoch, sessionEpoch: state.sessionEpoch, request: state.request };
    const isCurrent = () => state.mounted && !state.sessionTransition && state.ownerId === ownerId && activeSessionIdRef.current === originalSession
      && state.authEpoch === origin.authEpoch && state.sessionEpoch === origin.sessionEpoch && state.request === origin.request;
    const assert = () => { if (!isCurrent() || !ownerId || !originalSession) throw new Error('invalid_session'); };
    assert(); const operationId = await languageClassOriginOperationId(ownerId!, originalSession!, proposal.action_id, assert); assert();
    const liveOrigin = languageClassLiveOrigins.current.get(proposal.action_id), args = liveOrigin?.isCurrent() ? liveOrigin.args : proposal.args as LanguageClassProposalArgs;
    const prefill = parseLanguageClassActionPrefill({ ...args, fields: args.fields ?? {}, action_id: proposal.action_id, operation_id: operationId,
      expected_user_id: ownerId!, expected_session_id: originalSession!, recovery_only: !liveOrigin?.isCurrent() });
    languageClassActor.current = { operation_id: operationId, isCurrent }; setLanguageClassPrefill(prefill);
  };

  const showLanguageTutorHandoff = async (proposal: ActionProposal) => {
    if (proposal.tool !== 'prepare_language_tutor_handoff') throw new Error('invalid_request');
    if (!MIRROR_LANGUAGE_TUTOR_HANDOFF_ENABLED) throw new Error('feature_disabled');
    const liveOrigin = languageTutorLiveOrigins.current.get(proposal.action_id);
    if (!liveOrigin?.isCurrent() || !sameLanguageClassValue(liveOrigin.args, proposal.args)) throw new Error('invalid_session');
    const state = actionResultStreamRef.current, ownerId = state.ownerId, originalSession = activeSessionIdRef.current;
    if (!ownerId || !originalSession) throw new Error('invalid_session');
    const isCurrent = () => liveOrigin.isCurrent() && state.mounted && !state.sessionTransition
      && state.ownerId === ownerId && activeSessionIdRef.current === originalSession;
    languageTutorActor.current = { action_id: proposal.action_id, isCurrent };
    setLanguageTutorPrefill({ language: liveOrigin.args.language, expected_user_id: ownerId, expected_session_id: originalSession, action_id: proposal.action_id });
  };

  const showBrainNoteActionModal = async (proposal: ActionProposal) => {
    const state = actionResultStreamRef.current, ownerId = state.ownerId, originalSession = activeSessionIdRef.current;
    const origin = { authEpoch: state.authEpoch, sessionEpoch: state.sessionEpoch, request: state.request };
    const isCurrent = () => state.mounted && !state.sessionTransition && state.ownerId === ownerId && activeSessionIdRef.current === originalSession
      && state.authEpoch === origin.authEpoch && state.sessionEpoch === origin.sessionEpoch && state.request === origin.request;
    if (!ownerId || !originalSession || !isCurrent()) throw new Error('invalid_session');
    const prefill = await prepareBrainNoteModal(proposal, { ownerId, sessionId: originalSession, isCurrent,
      liveOrigin: brainNoteLiveOrigins.current.get(proposal.action_id) });
    if (!isCurrent()) throw new Error('invalid_session');
    setRecoveredNotePrefill(prefill);
  };
  const showBrainHandoff = async (proposal: ActionProposal) => {
    if (proposal.tool !== 'prepare_brain_handoff') throw new Error('invalid_request');
    const liveOrigin = brainHandoffLiveOrigins.current.get(proposal.action_id);
    if (!liveOrigin?.isCurrent() || !sameBrainProposalValue(liveOrigin.args, proposal.args)) throw new Error('invalid_session');
    const state = actionResultStreamRef.current, ownerId = state.ownerId, originalSession = activeSessionIdRef.current;
    if (!ownerId || !originalSession) throw new Error('invalid_session');
    const isCurrent = () => liveOrigin.isCurrent() && state.mounted && !state.sessionTransition
      && state.ownerId === ownerId && activeSessionIdRef.current === originalSession;
    brainHandoffActor.current = { action_id: proposal.action_id, isCurrent };
    setBrainHandoffPrefill(parseBrainHandoffPrefill({ target: liveOrigin.args.target, ...(liveOrigin.args.zen !== undefined ? { zen: liveOrigin.args.zen } : {}),
      expected_user_id: ownerId, expected_session_id: originalSession, action_id: proposal.action_id }));
  };

  const showNutritionGoalsActionModal = async (proposal: ActionProposal) => {
    if (proposal.tool !== 'propose_nutrition_goals_action') throw new Error('invalid_request');
    const state = actionResultStreamRef.current, ownerId = state.ownerId, originalSession = activeSessionIdRef.current;
    const origin = { authEpoch: state.authEpoch, sessionEpoch: state.sessionEpoch, request: state.request };
    const isCurrent = () => state.mounted && !state.sessionTransition && state.ownerId === ownerId && activeSessionIdRef.current === originalSession
      && state.authEpoch === origin.authEpoch && state.sessionEpoch === origin.sessionEpoch && state.request === origin.request;
    const assert = () => { if (!isCurrent() || !ownerId || !originalSession) throw new Error('invalid_session'); };
    assert(); const operationId = await nutritionGoalsOriginOperationId(ownerId!, originalSession!, proposal.action_id, assert); assert();
    const liveOrigin = nutritionGoalsLiveOrigins.current.get(proposal.action_id), args = liveOrigin?.isCurrent() ? liveOrigin.args : proposal.args as NutritionGoalsProposalArgs;
    const prefill = parseNutritionGoalsActionPrefill({ ...args, action: 'save', action_id: proposal.action_id, operation_id: operationId,
      expected_user_id: ownerId!, expected_session_id: originalSession!, recovery_only: !liveOrigin?.isCurrent() });
    nutritionGoalsActor.current = { operation_id: operationId, isCurrent }; setNutritionGoalsPrefill(prefill);
  };

  const showFitnessCuratedPlanModal = async (proposal: ActionProposal) => {
    if (proposal.tool !== 'propose_fitness_curated_plan') throw new Error('invalid_request');
    const state = actionResultStreamRef.current, ownerId = state.ownerId, originalSession = activeSessionIdRef.current;
    const authSession = fitnessCuratedPlanAuthSessionRef.current;
    const origin = { authEpoch: state.authEpoch, sessionEpoch: state.sessionEpoch, request: state.request };
    const isCurrent = () => !!authSession && fitnessCuratedPlanAuthSessionRef.current === authSession && state.mounted && !state.sessionTransition && state.ownerId === ownerId && activeSessionIdRef.current === originalSession
      && state.authEpoch === origin.authEpoch && state.sessionEpoch === origin.sessionEpoch && state.request === origin.request;
    const assert = () => { if (!isCurrent() || !ownerId || !originalSession) throw new Error('invalid_session'); };
    assert(); const operationId = await fitnessCuratedPlanOriginOperationId(ownerId!, originalSession!, proposal.action_id, assert); assert();
    const liveOrigin = fitnessCuratedPlanLiveOrigins.current.get(proposal.action_id), args = liveOrigin?.isCurrent() ? liveOrigin.args : proposal.args as FitnessCuratedPlanProposalArgs;
    const prefill = parseFitnessCuratedPlanPrefill({ ...args, action_id: proposal.action_id,
      expected_user_id: ownerId!, expected_session_id: originalSession!, recovery_only: !liveOrigin?.isCurrent() });
    fitnessCuratedPlanActor.current = { operation_id: operationId, action_id: proposal.action_id, isCurrent }; setFitnessCuratedPlanPrefill(prefill);
  };

  const showFitnessActionModal = async (proposal: ActionProposal) => {
    if (proposal.tool !== "propose_fitness_action") throw new Error("invalid_request");
    const state = actionResultStreamRef.current, ownerId = state.ownerId, currentSessionId = activeSessionIdRef.current;
    const origin = { authEpoch: state.authEpoch, sessionEpoch: state.sessionEpoch, request: state.request };
    const isCurrent = () => state.mounted && !state.sessionTransition && state.ownerId === ownerId && activeSessionIdRef.current === currentSessionId && state.authEpoch === origin.authEpoch && state.sessionEpoch === origin.sessionEpoch && state.request === origin.request;
    const assertCurrent = () => { if (!isCurrent() || !ownerId || !currentSessionId) throw new Error("invalid_session"); };
    assertCurrent();
    const operationId = await fitnessOriginOperationId(ownerId!, currentSessionId!, proposal.action_id, assertCurrent);
    assertCurrent();
    // Stable proposal origin permits receipt recovery even when fresh writes are OFF.
    setRecoveredFitnessPrefill({ ...structuredClone(proposal.args), operation_id: operationId, action_id: proposal.action_id, expected_user_id: ownerId!, expected_session_id: currentSessionId! });
  };

  const showSleepActionModal = async (proposal: ActionProposal) => {
    if (!MIRROR_SLEEP_CARDS_ENABLED) throw new Error("sleep_disabled");
    const state = actionResultStreamRef.current, ownerId = state.ownerId, sessionId = activeSessionIdRef.current;
    const origin = { authEpoch: state.authEpoch, sessionEpoch: state.sessionEpoch, request: state.request };
    const isCurrent = () => state.mounted && !state.sessionTransition && state.ownerId === ownerId &&
      activeSessionIdRef.current === sessionId && state.authEpoch === origin.authEpoch &&
      state.sessionEpoch === origin.sessionEpoch && state.request === origin.request;
    const assertCurrent = () => { if (!isCurrent()) throw new Error("invalid_session"); };
    assertCurrent();
    const handler = proposal.tool === "propose_sleep_action" ? sleepActionCaptureHandler : sleepCaptureHandler;
    const prefill = await handler.extract(handler.getRawText(proposal), proposal,
      { ownerId, sessionId, lang, t, assertCurrent, surfaceQuota: surfaceQuotaError });
    assertCurrent();
    if (!prefill) throw new Error("sleep_review_unavailable");
    // Manual reopening preserves the same operation after dismissal. Durable
    // pending state is loaded by the modal before any subsequent write.
    setRecoveredSleepPrefill(prefill);
  };

  const showBodyHealthActionModal = async (proposal: ActionProposal) => {
    if (!MIRROR_BODY_HEALTH_CARDS_ENABLED) throw new Error("body_health_disabled");
    const state = actionResultStreamRef.current, ownerId = state.ownerId, sessionId = activeSessionIdRef.current;
    const origin = { authEpoch: state.authEpoch, sessionEpoch: state.sessionEpoch, request: state.request };
    const isCurrent = () => state.mounted && !state.sessionTransition && state.ownerId === ownerId &&
      activeSessionIdRef.current === sessionId && state.authEpoch === origin.authEpoch &&
      state.sessionEpoch === origin.sessionEpoch && state.request === origin.request;
    const assertCurrent = () => { if (!isCurrent()) throw new Error("invalid_session"); };
    assertCurrent();
    const handler = proposal.tool === "propose_body_health_action" ? bodyHealthActionCaptureHandler : bodyHealthLegacyCaptureHandler;
    const prefill = await handler.extract(handler.getRawText(proposal), proposal,
      { ownerId, sessionId, lang, t, assertCurrent, surfaceQuota: surfaceQuotaError });
    assertCurrent();
    if (!prefill) throw new Error("body_health_review_unavailable");
    // Manual reopening preserves the same operation after dismissal. Durable
    // pending state is loaded by the modal before any subsequent write.
    setRecoveredBodyHealthPrefill(prefill);
  };

  const handleBodyScanHandoff = (handoff: MirrorBodyScanHandoff) => {
    openBodyScanHandoff(handoff, {
      ...actionResultStreamRef.current, sessionId: activeSessionIdRef.current,
    }, BODY_SCAN_PROVIDER_ENABLED, navigate);
  };

  const handleProposalConfirm = async (msgIdx: number, propIdx: number) => {
    const state = actionResultStreamRef.current, scope = state.authScope, lease = scope?.capture() ?? null;
    const authEpoch = state.authEpoch, sessionEpoch = state.sessionEpoch, originalSession = activeSessionIdRef.current;
    const isCurrent = () => state.mounted && state.authEpoch === authEpoch && state.sessionEpoch === sessionEpoch
      && activeSessionIdRef.current === originalSession && (!scope || state.authEpoch === captureAuthEpoch && scope.isCurrent(lease));
    if (!isCurrent()) return;
    const msg = messages[msgIdx];
    const chip = msg?.proposals?.[propIdx];
    if (!chip || chip.status !== "pending") return;
    if (chip.proposal.tool === "propose_finance_action" || chip.proposal.tool === "propose_finance_log") throw new Error("finance_review_required");
    if (chip.proposal.tool === 'propose_nutrition_meal_action') { await showNutritionMealActionModal(chip.proposal); return; }
    if (chip.proposal.tool === 'propose_fitness_curated_plan') { await showFitnessCuratedPlanModal(chip.proposal); return; }
    if (chip.proposal.tool === 'propose_language_action') { await showLanguageActionModal(chip.proposal); return; }
    if (chip.proposal.tool === 'propose_language_class_action') { await showLanguageClassActionModal(chip.proposal); return; }
    if (chip.proposal.tool === 'prepare_language_tutor_handoff') { await showLanguageTutorHandoff(chip.proposal); return; }
    if (chip.proposal.tool === 'propose_brain_note_action') { await showBrainNoteActionModal(chip.proposal); return; }
    if (chip.proposal.tool === 'prepare_brain_handoff') { await showBrainHandoff(chip.proposal); return; }
    if (chip.proposal.tool === 'propose_nutrition_goals_action') { await showNutritionGoalsActionModal(chip.proposal); return; }
    if (chip.proposal.tool === 'propose_nutrition_hydration_action') { await showNutritionHydrationActionModal(chip.proposal); return; }
    if (chip.proposal.tool === 'propose_fitness_local_draft_discard') throw new Error('fitness_draft_review_required');
    if (chip.proposal.tool === 'propose_fitness_runtime_action') throw new Error('fitness_runtime_review_required');
    if (chip.proposal.tool === "propose_fitness_action") {
      await showFitnessActionModal(chip.proposal);
      return;
    }
    if (chip.proposal.tool === "propose_body_log" || chip.proposal.tool === "propose_body_health_action") {
      await showBodyHealthActionModal(chip.proposal);
      return;
    }
    if (chip.proposal.tool === "propose_sleep_log" || chip.proposal.tool === "propose_sleep_action") {
      // History chips reopen the same review; opening a draft is not a write.
      await showSleepActionModal(chip.proposal);
      return;
    }
    // Espelho Executor (F1): generation happens SERVER-side — invoke the edge
    // fn with the chip's action_id as idempotency ref, then append the result
    // to the conversation as a normal assistant bubble. 402 → the standard
    // invoke paywall surface. Failures RETHROW so the chip resets to pending
    // (its own catch handles it) instead of flashing "created".
    // (Full result card + Library link UX lands in PR-D.)
    if (chip.proposal.tool === "propose_deliverable") {
      const rawArgs = (chip.proposal.args ?? {}) as { raw_text?: string };
      const rawText = typeof rawArgs.raw_text === "string" ? rawArgs.raw_text : "";
      // F2: erros de IMAGEM têm copy própria (bloqueio de conteúdo /
      // kill-switch OFF) — lê o código do body do FunctionsHttpError sem
      // consumir o Response (clone), mesmo caminho do parser de 402.
      const readErrorCode = async (err: unknown): Promise<string> => {
        const ctx = (err as { context?: Response } | null | undefined)?.context;
        try {
          if (ctx && typeof ctx.json === "function") {
            const src = typeof ctx.clone === "function" ? ctx.clone() : ctx;
            const body = (await src.json()) as { error?: unknown } | null;
            if (body && typeof body.error === "string") return body.error;
          }
        } catch {
          // corpo não-JSON/já consumido → cai no erro genérico
        }
        return "";
      };
      try {
        let accessToken = lease?.accessToken;
        if (scope && lease) {
          const auth = await supabase.auth.getSession();
          if (!isCurrent() || auth.error || !scope.matchesSession(auth.data.session, lease)) return;
          accessToken = auth.data.session!.access_token;
        }
        const { data, error } = await supabase.functions.invoke("deliverable-generate", {
          ...(accessToken ? { headers: { Authorization: "Bearer " + accessToken } } : {}),
          body: {
            raw_text: rawText,
            channel: "app",
            client_ref: chip.proposal.action_id,
            // NANO-2: o motor precisa dos MESMOS arquivos do turno, e do
            // session_id para a entrega ficar ancorada na conversa certa.
            ...attachmentBodyFields(chip.attachmentIds ?? []),
            ...(sessionId ? { session_id: sessionId } : {}),
          },
        });
        if (!isCurrent()) return;
        if (error) {
          if (await surfaceQuotaError(error)) {
            throw new Error("quota_402"); // paywall is up; chip stays pending for a post-upgrade retry
          }
          const code = await readErrorCode(error);
          if (!isCurrent()) return;
          if (code === "image_blocked" || code === "image_disabled") {
            toast.error(t(code === "image_blocked"
              ? "mirror.deliverable.imageBlocked"
              : "mirror.deliverable.imageDisabled"));
            throw new Error("image_error_shown"); // toast específico já dado; não duplicar o genérico
          }
          throw error;
        }
        const generated = (data ?? {}) as {
          title?: string;
          content_text?: string;
          deliverable_id?: string;
          kind?: string;
          requested_format?: string;
          file_url?: string;
        };
        const contentText = typeof generated.content_text === "string" ? generated.content_text : "";
        if (!contentText) throw new Error("deliverable_empty");
        const title = typeof generated.title === "string" ? generated.title.trim() : "";
        // Arquivo gerado → o chip criado ganha BAIXAR (PR-D). storage_path
        // segue a convenção {user_id}/{deliverable_id}.{ext} do PR-A
        // (comentário da coluna; assertada pelo eval do PR-C) — dá ao util o
        // fallback de re-download autenticado se a signed URL expirar.
        let deliverableFile: ProposalChipState["deliverableFile"] = null;
        if (
          typeof generated.file_url === "string" && generated.file_url &&
          typeof generated.deliverable_id === "string" && generated.deliverable_id
        ) {
          // F2: requested_format vem 'png' pra imagem (invariante formato ===
          // extensão); o fallback segue o kind pra nunca montar um path .pdf
          // de uma imagem num response malformado.
          const fmt = typeof generated.requested_format === "string" && generated.requested_format
            ? generated.requested_format
            : (generated.kind === "image" ? "png" : "pdf");
          const { data: authData } = await supabase.auth.getUser();
          if (!isCurrent() || scope && authData.user?.id !== lease?.ownerId) return;
          const uid = authData.user?.id ?? "";
          deliverableFile = {
            fileUrl: generated.file_url,
            storagePath: uid ? uid + "/" + generated.deliverable_id + "." + fmt : null,
            fileName: deliverableFileName(title || rawText.slice(0, 40), fmt),
            format: fmt,
            kind: typeof generated.kind === "string" && generated.kind ? generated.kind : "document",
          };
        }
        updateProposalState(msgIdx, propIdx, { status: "created", deliverableFile });
        // ARQUIVO (PR-E): content_text já é a mensagem-link de 1 linha com o
        // título dentro ("📄 Título: aivyv.com/d/x · válido por N dias") — não
        // prefixar o título de novo, e nenhuma signed URL crua no corpo (o
        // download imediato é o botão Baixar do chip). TEXTO segue como era.
        // IMAGEM (PR-A): a imagem em si rende inline na bolha (thumbnail →
        // viewer compartilhado); o texto vira só a legenda curta "🖼️ Título"
        // — o link curto sai do corpo (Baixar/viewer cobrem o acesso).
        const isImageResult = deliverableFile?.kind === "image" && !!deliverableFile.storagePath;
        setMessages((prev) => !isCurrent() ? prev : [
          ...prev,
          {
            role: "assistant",
            content: isImageResult
              ? "🖼️ " + (title || t("mirror.actions.deliverable.title"))
              : deliverableFile
                ? contentText
                : title
                  ? title + "\n\n" + contentText
                  : contentText,
            deliverableImage: isImageResult
              ? {
                storagePath: deliverableFile!.storagePath as string,
                title: title || "",
                deliverableId: generated.deliverable_id,
              }
              : null,
          },
        ]);
        return;
      } catch (err) {
        if (!isCurrent()) return;
        if (
          !(err instanceof Error &&
            (err.message === "quota_402" || err.message === "image_error_shown"))
        ) {
          console.error("[MirrorChat] deliverable generation failed:", err);
          toast.error(t("mirror.deliverable.error"));
        }
        throw err;
      }
    }
    try {
      const result = await mirrorActions.executeProposal(
        chip.proposal,
        chip.proposal.action_id,
      );
      if (!isCurrent()) return;
      updateProposalState(msgIdx, propIdx, {
        status: "created",
        createdRecord: result,
      });
      // C1 recap — surface what the chip just created in-conversation. (Spine
      // tools agenda/nutrition emit their own recap from inside the modal.)
      const p = chip.proposal;
      if (p.tool === "create_task") {
        emitCaptureRecap({ kind: "task", title: t("mirror.recap.task"), subtitle: p.args.title });
      } else if (p.tool === "create_note") {
        emitCaptureRecap({ kind: "note", title: t("mirror.recap.note"), subtitle: p.args.content });
      } else if (p.tool === "create_agenda_event") {
        emitCaptureRecap({ kind: "agenda", title: t("mirror.recap.agenda"), subtitle: p.args.title });
      }
    } catch (err) {
      if (!isCurrent()) return;
      console.error("[MirrorChat] proposal confirm failed:", err);
      toast.error(t("mirror.error"));
    }
  };

  const handleProposalCancel = (msgIdx: number, propIdx: number) => {
    updateProposalState(msgIdx, propIdx, { status: "cancelled" });
  };

  // BAIXAR do chip criado (PR-D) — mesmo util da Biblioteca; erros viram o
  // mesmo toast localizado.
  const handleDeliverableDownload = async (chip: ProposalChipState) => {
    const f = chip.deliverableFile;
    if (!f) return;
    try {
      // PR-A: imagem usa o fluxo blob próprio — nunca window.open (PNG
      // renderiza inline no browser/WebView e prendia o usuário sem volta).
      const opts = {
        fileUrl: f.fileUrl,
        storagePath: f.storagePath,
        fileName: f.fileName,
      };
      const source = f.kind === "image"
        ? await downloadImageDeliverable(opts)
        : await downloadDeliverable(opts);
      analytics.deliverableDownloaded({
        format: f.format,
        kind: f.kind,
        source: "chip",
        refreshedUrl: source === "storage_refetch",
      });
    } catch (err) {
      console.error("[MirrorChat] deliverable download failed:", err);
      toast.error(t("library.downloadError"));
    }
  };

  const handleProposalUndo = async (msgIdx: number, propIdx: number) => {
    const msg = messages[msgIdx];
    const chip = msg?.proposals?.[propIdx];
    if (!chip || !chip.createdRecord) return;
    if (chip.createdRecord.tableName === "tasks") {
      const owner = actionResultStreamRef.current.ownerId, session = activeSessionIdRef.current;
      if (!owner || !session || actionResultStreamRef.current.sessionTransition) return;
      setRecoveredTaskPrefill({ action: "delete", task_id: chip.createdRecord.id, operation_id: newTaskOperationId(), action_id: "review-delete:" + newTaskOperationId(), expected_user_id: owner, expected_session_id: session });
      return;
    }
    if (chip.createdRecord.tableName === "focus_sessions") {
      const owner = actionResultStreamRef.current.ownerId, session = activeSessionIdRef.current;
      if (!owner || !session || actionResultStreamRef.current.sessionTransition) return;
      setRecoveredFocusPrefill({ action: "delete", focus_session_id: chip.createdRecord.id, operation_id: newFocusOperationId(), action_id: "review-delete:" + newFocusOperationId(), expected_user_id: owner, expected_session_id: session });
      return;
    }
    if (chip.createdRecord.tableName === "notes") {
      const owner = actionResultStreamRef.current.ownerId, session = activeSessionIdRef.current;
      if (!owner || !session || actionResultStreamRef.current.sessionTransition) return;
      setRecoveredNotePrefill({ action: "delete", note_id: chip.createdRecord.id, operation_id: newNoteOperationId(), action_id: "review-delete:" + newNoteOperationId(), expected_user_id: owner, expected_session_id: session });
      return;
    }
    try {
      await mirrorActions.undoAction(
        chip.createdRecord.tableName,
        chip.createdRecord.id,
      );
      updateProposalState(msgIdx, propIdx, { status: "undone" });
    } catch (err) {
      console.error("[MirrorChat] proposal undo failed:", err);
      toast.error(t("mirror.error"));
    }
  };

  // ── Nutrition photo attach ──
  // Single camera affordance in the input bar. Reads the picked meal photo,
  // runs it through nutrition-photo-analyze (Premium-gated in the hook), then
  // opens the SAME NutritionLogModal as the voice path (source 'photo').
  const handlePhotoPick = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (e.target) e.target.value = ""; // allow re-pick of the same file
      if (!file) return;

      const dataUrl = await new Promise<string>((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = () => resolve("");
        reader.readAsDataURL(file);
      });
      if (!dataUrl) {
        toast.error(t("nutrition.photo.error"));
        return;
      }
      const commaIdx = dataUrl.indexOf(",");
      const base64 = commaIdx >= 0 ? dataUrl.slice(commaIdx + 1) : dataUrl;

      setShowConversation(true);
      const { result, error } = await analyzePhoto(base64);
      if (error === "free_photo_used") {
        // Gratuita vitalícia usada e sem créditos — copy específica + CTA
        // fica na tela da Nutrição; aqui no Espelho um toast direto basta.
        toast.error(t("nutrition.photo.upgrade_limit"));
        return;
      }
      if (error === "photo_daily_cap") {
        toast.error(t("nutrition.photo.daily_cap"));
        return;
      }
      if (error || !result) {
        toast.error(t("nutrition.photo.error"));
        return;
      }

      const validMeals = ["breakfast", "lunch", "dinner", "snack", "pre_workout", "post_workout"];
      const mealType = (validMeals.includes(result.meal_type_guess)
        ? result.meal_type_guess
        : "snack") as NutritionPrefill["meal_type"];

      setPhotoPrefill({
        description: result.description,
        meal_type: mealType,
        kcal: result.kcal,
        protein: result.protein,
        carbs: result.carbs,
        fat: result.fat,
        confidence: result.confidence,
        ingredients_detected: result.ingredients,
        source: "photo",
        client_action_id: "mirror_photo_" + crypto.randomUUID(),
        imageDataUrl: dataUrl,
      });
    },
    [analyzePhoto, t],
  );

  const openHistory = () => {
    goIdle();
    setShowHistory(true);
    setShowConversation(false);
    setViewingSessionId(null);
    setViewingMessages([]);
    loadHistorySessions();
    loadProjects();
  };

  const closeHistory = () => {
    if (actionResultStreamRef.current.sessionTransition) {
      actionResultStreamRef.current.sessionEpoch++;
      actionResultStreamRef.current.sessionTransition = false;
      transcriptPagingRef.current.request++;
      transcriptPagingRef.current.loading = false;
      activeSessionIdRef.current = transcriptPagingRef.current.previousSessionId;
      setLoadingSessionId(null);
    }
    historyPagingRef.current.request++;
    projectsLoadRef.current.request++;
    historyPagingRef.current.loading = false;
    setLoadingHistory(false);
    setLoadingProjects(false);
    setShowHistory(false);
    setViewingSessionId(null);
    setViewingMessages([]);
    setSearchQuery("");
    setMenuOpenId(null);
    setRenamingId(null);
    setMovingSessionId(null);
    setProjectMenuOpenId(null);
    setRenamingProjectId(null);
    setChangingColorProjectId(null);
    setCreatingProject(false);
    setNewProjectName("");
    goIdle();
  };

  const deleteSession = async (sid: string) => {
    setHistorySessions((prev) => prev.filter((s) => s.id !== sid));
    setConfirmDeleteId(null);
    setMenuOpenId(null);

    if (viewingSessionId === sid) {
      setViewingSessionId(null);
      setViewingMessages([]);
    }
    if (sessionId === sid) {
      resetCurrentConversation();
      setShowHistory(false);
    }

    await supabase.from("mirror_sessions").delete().eq("id", sid);
  };

  const renameSession = async (sid: string, newTitle: string) => {
    const trimmed = newTitle.trim();
    if (!trimmed) { setRenamingId(null); return; }

    setHistorySessions((prev) =>
      prev.map((s) => (s.id === sid ? { ...s, title: trimmed } : s))
    );
    setRenamingId(null);
    setMenuOpenId(null);

    const { error } = await supabase
      .from("mirror_sessions")
      .update({ title: trimmed } as any)
      .eq("id", sid);

    if (error) {
      toast.error(t("mirror.error"));
      loadHistorySessions();
    }
  };

  // ── Delete individual message ──
  const deleteMessage = async (idx: number) => {
    const msg = messages[idx];
    setMessages((prev) => prev.filter((_, i) => i !== idx));
    setLongPressIdx(null);
    if (msg.id && sessionId) {
      await supabase.from("mirror_messages").delete().eq("id", msg.id);
    }
  };

  // ── State indicator label ──
  const stateLabel = {
    idle: t("mirror.ready"),
    listening: t("mirror.listening"),
    thinking: t("mirror.reflecting"),
    speaking: t("mirror.speaking"),
  }[livePresence];

  // ── Session row renderer (shared between projects and conversations) ──
  const renderSessionRow = (session: HistorySession, inProject: boolean) => (
    <motion.div
      key={session.id}
      initial={{ opacity: 1, height: "auto" }}
      exit={{ opacity: 0, height: 0, overflow: "hidden" }}
      transition={{ duration: 0.2, ease: "easeInOut" }}
      className="group relative"
    >
      {renamingId === session.id ? (
        <div className="px-5 py-3">
          <input
            value={renameValue}
            onChange={(e) => setRenameValue(e.target.value)}
            onBlur={() => renameSession(session.id, renameValue)}
            onKeyDown={(e) => {
              if (e.key === "Enter") renameSession(session.id, renameValue);
              if (e.key === "Escape") { setRenamingId(null); setMenuOpenId(null); }
            }}
            autoFocus
            className="w-full bg-foreground/[0.06] border border-primary/25 rounded-lg px-3 py-2 text-[13px] text-foreground/85 outline-none font-body"
          />
        </div>
      ) : (
        <div className="flex items-center pr-2">
          <button
            type="button"
            aria-busy={loadingSessionId === session.id}
            onClick={() => {
              setConfirmDeleteId(null);
              setMenuOpenId(null);
              setMovingSessionId(null);
              loadSessionMessages(session.id);
            }}
            className="flex-1 text-left px-5 py-3 hover:bg-foreground/[0.05] active:bg-foreground/[0.08] transition-colors min-w-0"
          >
            <p className="flex items-center gap-2 text-[13px] text-foreground/80 leading-snug group-hover:text-foreground/95 transition-colors">
              {loadingSessionId === session.id && <Loader2 size={13} className="shrink-0 animate-spin" />}
              <span className="truncate">{session.title || session.preview || t("history.untitled")}</span>
            </p>
            <p className="text-[10px] text-foreground/30 mt-0.5">
              {relativeTime(session.updated_at || session.created_at)}
            </p>
          </button>

          {/* Three-dot menu — always visible on mobile, hover-reveal on desktop */}
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setConfirmDeleteId(null);
              setMovingSessionId(null);
              setMenuOpenId(menuOpenId === session.id ? null : session.id);
            }}
            className="shrink-0 w-7 h-7 flex items-center justify-center rounded-lg opacity-60 sm:opacity-0 sm:group-hover:opacity-100 transition-all duration-200 text-foreground/40 hover:text-foreground/75 hover:bg-foreground/[0.07]"
          >
            <MoreVertical size={14} />
          </button>
        </div>
      )}

      {/* ── Inline action menu ── */}
      <AnimatePresence>
        {menuOpenId === session.id && (
          <motion.div
            initial={{ opacity: 0, y: -4, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -4, scale: 0.97 }}
            transition={{ duration: 0.14, ease: "easeOut" }}
            className="mx-5 mb-1 rounded-xl border border-foreground/[0.10] overflow-hidden"
            style={{ backgroundColor: "hsl(222 38% 9% / 0.97)" }}
          >
            <button
              type="button"
              onClick={() => {
                setRenamingId(session.id);
                setRenameValue(session.title || session.preview || "");
                setMenuOpenId(null);
              }}
              className="w-full flex items-center gap-3 px-4 py-3 text-left text-[13px] text-foreground/75 hover:bg-foreground/[0.05] hover:text-foreground/95 transition-colors font-body border-b border-foreground/[0.07]"
            >
              {t("history.rename")}
            </button>
            {!inProject ? (
              <button
                type="button"
                onClick={() => { setMovingSessionId(session.id); setMenuOpenId(null); }}
                className="w-full flex items-center gap-3 px-4 py-3 text-left text-[13px] text-foreground/75 hover:bg-foreground/[0.05] hover:text-foreground/95 transition-colors font-body border-b border-foreground/[0.07]"
              >
                {t("history.moveToProject")}
              </button>
            ) : (
              <button
                type="button"
                onClick={() => { moveSessionToProject(session.id, null); }}
                className="w-full flex items-center gap-3 px-4 py-3 text-left text-[13px] text-foreground/75 hover:bg-foreground/[0.05] hover:text-foreground/95 transition-colors font-body border-b border-foreground/[0.07]"
              >
                {t("history.removeFromProject")}
              </button>
            )}
            <button
              type="button"
              onClick={() => { setConfirmDeleteId(session.id); setMenuOpenId(null); }}
              className="w-full flex items-center gap-3 px-4 py-3 text-left text-[13px] text-red-400/75 hover:bg-red-400/[0.05] hover:text-red-400 transition-colors font-body"
            >
              {t("history.delete")}
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      {/* ── Move to project submenu ── */}
      <AnimatePresence>
        {movingSessionId === session.id && (
          <motion.div
            initial={{ opacity: 0, y: -4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -4 }}
            transition={{ duration: 0.14 }}
            className="mx-5 mb-1 rounded-xl border border-foreground/[0.10] overflow-hidden"
            style={{ backgroundColor: "hsl(222 38% 9% / 0.97)" }}
          >
            <div className="px-4 py-2 border-b border-foreground/[0.07]">
              <p className="text-[10px] font-display tracking-[0.2em] uppercase text-foreground/35">
                {t("history.moveToProject")}
              </p>
            </div>
            {projects.length === 0 ? (
              <div className="px-4 py-3">
                <p className="text-[12px] text-foreground/40">{t("mirror.noProjectsYet")}</p>
              </div>
            ) : (
              projects.map((p) => (
                <button
                  key={p.id}
                  type="button"
                  onClick={() => moveSessionToProject(session.id, p.id)}
                  className="w-full flex items-center gap-3 px-4 py-3 text-left text-[13px] text-foreground/75 hover:bg-foreground/[0.05] hover:text-foreground/95 transition-colors font-body border-b border-foreground/[0.07] last:border-0"
                >
                  <span
                    className="w-2 h-2 rounded-full shrink-0"
                    style={{ backgroundColor: PROJECT_COLORS[p.color] || PROJECT_COLORS.cyan }}
                  />
                  {p.name}
                </button>
              ))
            )}
            <button
              type="button"
              onClick={() => setMovingSessionId(null)}
              className="w-full px-4 py-2.5 text-[11px] text-foreground/35 hover:text-foreground/60 transition-colors font-body"
            >
              {t("common.cancel")}
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      {/* ── Delete confirmation ── */}
      <AnimatePresence>
        {confirmDeleteId === session.id && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.18, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <div className="flex items-center gap-3 px-5 pb-3 pt-0.5">
              <p className="text-[11px] text-foreground/45 flex-1">
                {t("history.confirmDelete")}
              </p>
              <button
                onClick={() => deleteSession(session.id)}
                className="text-[11px] font-display font-medium text-red-400/80 hover:text-red-400 transition-colors px-2 py-1 rounded-lg hover:bg-red-400/[0.08]"
              >
                {t("history.confirmYes")}
              </button>
              <button
                onClick={() => setConfirmDeleteId(null)}
                className="text-[11px] font-display text-foreground/40 hover:text-foreground/65 transition-colors px-2 py-1 rounded-lg hover:bg-foreground/[0.06]"
              >
                {t("history.confirmCancel")}
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );

  // ── Render ──

  // Gate do LIVE — hoje ABERTO ao Free (LIVE_REQUIRES_PREMIUM=false, decisão
  // Rafa 30/08: mesmo pipeline e mesma cota do Espelho por voz; o mirror-stt
  // debita por segundo antes de gastar). Religa quando o Realtime entrar —
  // ver o comentário da constante em @/lib/liveAccess. Com a constante em
  // true, este if volta a ser o defense-in-depth de rota original: fecha
  // direct URL / deep-link / cached route, com a disciplina de isLoading do
  // useRequirePremium (NUNCA redireciona durante o load — #232/#235).
  // Scoped to the plain live screen (live && !moduleContext): the language
  // tutor live (/language/live, gated in LanguageLive) and /mirror
  // push-to-talk (live === false) are untouched.
  if (live && !moduleContext && LIVE_REQUIRES_PREMIUM && premiumRedirect) {
    return premiumRedirect;
  }

  return (
    <div
      className="flex flex-col overflow-hidden"
      style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, height: "100%", background: "radial-gradient(ellipse at 50% 45%, rgba(0, 229, 255, 0.03) 0%, rgba(124, 58, 237, 0.02) 30%, #0a0a0f 70%, #0d1117 100%)", touchAction: "pan-y" }}
      /* Reverso do gesto de recolher: com a conversa RECOLHIDA (mensagens
         existem, palco à vista), puxar para CIMA em qualquer ponto do palco
         devolve a thread. Só arma nesse estado — com a conversa aberta, com
         o histórico ou no live o toque não é observado. */
      onTouchStart={(e) => {
        restoreTrackerRef.current =
          !live && !showConversation && !showHistory && messages.length > 0
            ? beginRestore(e.touches[0].clientY)
            : null;
      }}
      onTouchMove={(e) => {
        if (trackRestore(restoreTrackerRef.current, e.touches[0].clientY)) {
          restoreTrackerRef.current = null;
          setShowConversation(true);
        }
      }}
      onTouchEnd={() => {
        restoreTrackerRef.current = null;
      }}
    >
      {/* ═══ Presence Stage — immersive reactive background (Presence Engine, Stage 1) ═══ */}
      {/* MirrorStage (non-frozen; already prod-rendered on MirrorReady) mounted as
          the backmost layer, driven by the SAME `visuals` object that feeds
          MirrorAvatar — so idle → listening → thinking → speaking animate via
          MirrorStage's own CSS transitions, with no new animation code here.
          z-1: above the root gradient, below the avatar layer (zIndex 5) and all
          chat UI (z-10…z-40). pointer-events:none + o MESMO transform do layer
          do avatar (--vv-offset-top + env(safe-area-inset-top) — ver o palco
          abaixo) so the beam / portal-arch stay locked to the avatar when the
          iOS keyboard opens E sob o inset da status bar no app iOS
          (Capacitor). Gated to the push-to-talk /mirror
          (!live); /mirror/live keeps its own MirrorLiveAvatar presentation
          (see PR — known limitation, Stage 1.2). */}
      {!live && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1,
            pointerEvents: "none",
            overflow: "hidden",
            transform: "translateY(calc(var(--vv-offset-top, 0px) + env(safe-area-inset-top, 0px)))",
            willChange: "transform",
          }}
        >
          <MirrorStage visuals={visuals} />
        </div>
      )}

      {/* Push soft-ask — self-gated (>=1 mirror_message, push_opt_in NULL, not
          snoozed). Renders its own bottom sheet only when it decides to show. */}
      {/* ÁRBITRO do primeiro momento. Os dois querem o mesmo instante, e no D0
          o push SEMPRE tem direito (todo usuário novo nasce com push_opt_in
          NULL). Por padrão o push ganha — a config whatsapp.soft_ask_owns_d0
          inverte, e quando ela inverte o sheet cede para o chip em vez de cair
          por cima dele 1,5s depois. */}
      <MirrorPushSoftAsk
        firstExchangeComplete={firstExchangeComplete}
        ttsSpeaking={isSpeaking || waSoftAsk.visible}
        onSettled={() => setPushSettled(true)}
      />

      {/* ═══ Stage + Avatar — own fixed layer, immune to keyboard layout ═══ */}
      {/* translateY = --vv-offset-top (cancela o scroll do visual viewport do
          iOS quando o teclado abre — só o input bar sobe; 0px em
          Android/desktop) + env(safe-area-inset-top) (fix 24/07, app iOS:
          com viewport-fit=cover + contentInset:'never' a webview do Capacitor
          monta SOB a status bar, então o y=0 deste layer é o notch — ~47-59px
          acima de onde a composição foi calibrada no Safari/Android, onde
          env() resolve 0. Compensar o inset aqui alinha o palco à mesma
          posição física dos outros ambientes; na web calc(x + 0px) rende
          idêntico ao anterior — no-op garantido). */}
      <div
        className="pointer-events-none"
        style={{ position: "fixed", top: 0, left: 0, right: 0, height: "100vh", zIndex: 5, overflow: "hidden", background: "transparent", borderBottom: "none", transform: "translateY(calc(var(--vv-offset-top, 0px) + env(safe-area-inset-top, 0px)))", willChange: "transform" }}
      >
        {/* Fase 5 lip sync — useVoice owns audioElement + alignment.
            analyserNode is gated by alignment presence as the primary safety
            net; AvatarCore's animate() gate (Fase 4.5) is the secondary net. */}
        {/* Mirror render: avatar quando o usuário TEM um E a superfície
            escolhida não é a energia (toggle 21/08 — user_profiles.
            mirror_surface via useMirrorSurface); VyvEnergy (Cosmic Orb) nos
            demais casos — a energia substitui o AvatarPortal SÓ
            no Espelho (task portal_tasks c7406112, decisões e19cb217/d8c60a71);
            as demais superfícies (MirrorHome, Modules, mini-mirrors,
            FitnessBodyMap) continuam no portal. Estados do Presence Engine +
            voz: level = amplitude que o Whisper já calcula no listening,
            source = o <audio> persistente do TTS no speaking (o wrapper cuida
            do ciclo único do createMediaElementSource e do fallback iOS). */}
        {live ? (
          // Live (Option C): bust framing + same lip-sync wiring. Handles its
          // own no-avatar fallback (VyvEnergy) internally.
          <MirrorLiveAvatar
            audioElement={realtimeLive ? null : tts.audioElement}
            alignment={realtimeLive ? null : tts.alignment}
            presenceState={livePresence}
            micLevel={realtimeLive ? undefined : amplitude}
            micStream={realtimeLive ? rt.micStream : null}
            remoteStream={realtimeLive ? rt.remoteStream : null}
            analyserNode={realtimeLive ? rt.remoteAnalyser : null}
          />
        ) : !mirrorSurfaceResolving && mirrorShowsAvatar ? (
          <MirrorAvatar
            visuals={visuals}
            cameraDistanceOverride={MIRROR_CAM.distance}
            lookAtYOverride={MIRROR_CAM.lookAtY}
            entered={entered}
            animationUrl={animationUrl}
            audioElement={tts.audioElement}
            alignment={tts.alignment}
            analyserNode={null}
          />
        ) : null /* energia mora no FLUXO da content area (fix
          posição vertical 07/08): centrada por flexbox entre o conteúdo do
          topo e a barra, coisa que este layer fixed de 100vh não sabe fazer. */}

        {/* DEV-only lip-sync calibration HUD. Portals to <body>; returns null in
            production. Mounted on the Live screen, where bust framing makes the
            output-latency phase drift visible. */}
        {live && <LipSyncCalibrationHUD />}
      </div>

      {/* ═══ Header (navigation) ═══ */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.35, duration: 0.8 }}
        className="relative z-30 flex items-center justify-between px-5 pt-5 pb-3 shrink-0"
        style={{ paddingTop: "max(20px, env(safe-area-inset-top, 20px))" }}
      >
        <button
          onClick={live ? () => navigate("/home") : () => { setNavModulesOpen(false); setNavOpen(true); }}
          title={live ? undefined : t("nav.menu")}
          aria-label={live ? undefined : t("nav.menu")}
          className="text-foreground/70 hover:text-foreground/95 transition-all duration-300 p-2 -ml-1.5 rounded-xl bg-foreground/[0.08] border border-foreground/[0.15] hover:border-foreground/25 shadow-[0_0_14px_hsl(var(--primary)/0.08)]"
        >
          {/* Voice-first hub: on /mirror the left slot opens the nav drawer
              (Meu Dia / Check-in / Módulos / Progresso / Settings) that descends
              over the avatar — /home moved INTO that drawer as "Meu Dia". In
              Live it stays a plain back chevron → /home (unchanged). */}
          {live ? <ChevronLeft size={18} /> : <Menu size={18} />}
        </button>

        <div className="w-[80px]" />

        <div className="flex items-center gap-2">
          {/* Voltar ao avatar/energia (Rafa 30/08): com a conversa aberta o
              palco fica atrás sem caminho de volta. Este controle e o gesto
              de puxar a thread para baixo são as DUAS saídas — a conversa é
              PRESERVADA (recolhe, não apaga; tocar no campo ou puxar o
              palco para cima devolve). Só aparece quando há o que recolher. */}
          {!live && showConversation && (
            <button
              onClick={returnToStage}
              title={t("mirror.backToStage")}
              aria-label={t("mirror.backToStage")}
              className="text-foreground/40 hover:text-foreground/70 transition-colors p-1.5"
            >
              <ChevronDown size={15} />
            </button>
          )}
          <button
            onClick={() => {
              const next = !isMuted;
              setIsMuted(next);
              // Realtime: silencia o áudio remoto da chamada; pipeline
              // antigo: para o TTS em curso ao mutar.
              if (realtimeLive) rt.setMuted(next);
              else if (next) handleStopSpeaking();
            }}
            className="text-foreground/40 hover:text-foreground/70 transition-colors p-1.5"
            title={isMuted ? t("mirror.unmute") : t("mirror.mute")}
          >
            {isMuted ? <VolumeX size={14} /> : <Volume2 size={14} />}
          </button>
          {/* History — hidden in Live (presence-focused, voice-only). */}
          {!live && (
            <button
              onClick={() => (showHistory ? closeHistory() : openHistory())}
              className="text-foreground/55 hover:text-foreground/85 transition-colors p-1.5 -mr-1.5 text-[9px] font-display tracking-[0.25em] uppercase"
            >
              {showHistory ? <X size={15} /> : t("mirror.history")}
            </button>
          )}
          {/* Subtle Live ↔ Chat toggle. In Live → back to chat; in chat →
              enter Live. Aberto a TODOS enquanto LIVE_REQUIRES_PREMIUM for
              false (Rafa 30/08 — mesma cota do Espelho por voz); com a
              constante em true volta a ser Premium-only. */}
          {live ? (
            <button
              onClick={() => navigate("/mirror")}
              className="text-foreground/55 hover:text-foreground/85 transition-colors p-1.5 -mr-1.5 text-[9px] font-display tracking-[0.25em] uppercase"
            >
              {t("mirror.live.toChat")}
            </button>
          ) : (
            (!LIVE_REQUIRES_PREMIUM || isPremium) && (
              <button
                onClick={() => navigate("/mirror/live")}
                className="text-primary/70 hover:text-primary transition-colors p-1.5 -mr-1.5 text-[9px] font-display tracking-[0.25em] uppercase"
              >
                {t("mirror.live.toLive")}
              </button>
            )
          )}
        </div>
      </motion.div>

      {/* ═══ Mirror hub nav drawer — descends from the top over the (dimmed)
          avatar. /mirror only; hidden in Live (presence/voice-only). ═══ */}
      {!live && <MirrorNavDrawer open={navOpen} initialModulesOpen={navModulesOpen} onClose={() => setNavOpen(false)} />}
      {/* Subtle push opt-in nudge — floats above the avatar's top, self-gated
          (only when push_opt_in is null + supported + not dismissed). /mirror
          chat only, never in Live (presence/voice-only). */}
      {!live && <MirrorReminderBubble />}

      {/* ═══ History sidebar ═══ */}
      <AnimatePresence>
        {showHistory && (
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
            className="absolute inset-0 z-40 flex flex-col"
            style={{ backgroundColor: `hsl(222 38% 7% / 0.97)`, backdropFilter: "blur(24px)" }}
          >
            {/* Sidebar header */}
            <div
              className="shrink-0 flex items-center justify-between px-5 pt-5 pb-4 border-b border-foreground/[0.07]"
              style={{ paddingTop: "max(20px, env(safe-area-inset-top, 20px))" }}
            >
              <button
                onClick={closeHistory}
                className="w-9 h-9 flex items-center justify-center rounded-xl text-foreground/50 hover:text-foreground/85 hover:bg-foreground/[0.06] transition-all"
              >
                <ChevronLeft size={18} />
              </button>

              <span className="text-[11px] font-display font-semibold tracking-[0.3em] uppercase text-foreground/60">
                {t("mirror.history")}
              </span>

              <button
                onClick={startNewReflection}
                className="w-9 h-9 flex items-center justify-center rounded-xl text-foreground/50 hover:text-primary/80 hover:bg-primary/[0.08] transition-all"
                title={t("mirror.newReflection")}
              >
                <Plus size={18} />
              </button>
            </div>

            {/* Sidebar body */}
            <div className="flex-1 overflow-y-auto" style={{ touchAction: "pan-y" }}>
              {/* Session viewer path removed — tapping a session now loads it into the active conversation.
                  viewingSessionId / viewingMessages state kept for backward compat but no longer rendered. */}
              {false ? null : (
                /* ── Main history list ── */
                <div className="py-2">

                  {/* ── SECTION A: Projects ── */}
                  <div className="px-5 pt-4 pb-2 flex items-center justify-between">
                    <p className="text-[9px] font-display font-semibold tracking-[0.3em] uppercase text-foreground/30">
                      {t("history.projects")}
                    </p>
                    <button
                      type="button"
                      onClick={() => { setCreatingProject(true); setNewProjectName(""); }}
                      className="w-5 h-5 flex items-center justify-center rounded text-foreground/30 hover:text-primary/70 hover:bg-primary/[0.08] transition-all"
                      title={t("history.newProject")}
                    >
                      <Plus size={12} />
                    </button>
                  </div>

                  {creatingProject && (
                    <div className="px-5 pb-2">
                      <input
                        value={newProjectName}
                        onChange={(e) => setNewProjectName(e.target.value)}
                        onBlur={() => createProject(newProjectName)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") createProject(newProjectName);
                          if (e.key === "Escape") { setCreatingProject(false); setNewProjectName(""); }
                        }}
                        autoFocus
                        placeholder={t("history.projectName")}
                        className="w-full bg-foreground/[0.06] border border-primary/25 rounded-lg px-3 py-2 text-[13px] text-foreground/85 placeholder:text-foreground/25 outline-none font-body"
                      />
                    </div>
                  )}

                  {loadingProjects ? (
                    <div className="px-5 py-2">
                      <p className="text-[12px] text-foreground/25">{t("mirror.reflecting")}</p>
                    </div>
                  ) : projects.length === 0 && !creatingProject ? (
                    <div className="px-5 py-1 pb-3">
                      <p className="text-[12px] text-foreground/28 leading-relaxed">
                        {t("mirror.noProjectsYet")}
                      </p>
                    </div>
                  ) : (
                    <div className="mb-1">
                      {projects.map((project) => {
                        const projectCount = historySessions.filter((s) => s.project_id === project.id).length;
                        const isExpanded = expandedProjectId === project.id;
                        const dotColor = PROJECT_COLORS[project.color] || PROJECT_COLORS.cyan;

                        return (
                          <div key={project.id}>
                            {renamingProjectId === project.id ? (
                              <div className="px-5 py-2">
                                <input
                                  value={renameProjectValue}
                                  onChange={(e) => setRenameProjectValue(e.target.value)}
                                  onBlur={() => renameProject(project.id, renameProjectValue)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") renameProject(project.id, renameProjectValue);
                                    if (e.key === "Escape") setRenamingProjectId(null);
                                  }}
                                  autoFocus
                                  className="w-full bg-foreground/[0.06] border border-primary/25 rounded-lg px-3 py-2 text-[13px] text-foreground/85 outline-none font-body"
                                />
                              </div>
                            ) : (
                              <div className="group flex items-center gap-1 pr-2">
                                <button
                                  type="button"
                                  onClick={() => setExpandedProjectId(isExpanded ? null : project.id)}
                                  className="flex-1 flex items-center gap-3 px-5 py-3 hover:bg-foreground/[0.04] active:bg-foreground/[0.06] transition-colors min-w-0"
                                >
                                  <span
                                    className="w-2.5 h-2.5 rounded-full shrink-0 ring-1 ring-white/10"
                                    style={{ backgroundColor: dotColor }}
                                  />
                                  <span className="flex-1 text-[13px] text-foreground/75 font-body truncate text-left">
                                    {project.name}
                                  </span>
                                  <span className="text-[10px] text-foreground/28 shrink-0">
                                    {projectCount} {t("history.sessions")}
                                  </span>
                                  {isExpanded
                                    ? <ChevronDown size={12} className="text-foreground/30 shrink-0" />
                                    : <ChevronRight size={12} className="text-foreground/30 shrink-0" />
                                  }
                                </button>

                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setProjectMenuOpenId(projectMenuOpenId === project.id ? null : project.id);
                                    setChangingColorProjectId(null);
                                  }}
                                  className="shrink-0 w-7 h-7 flex items-center justify-center rounded-lg opacity-60 sm:opacity-0 sm:group-hover:opacity-100 transition-all text-foreground/40 hover:text-foreground/75 hover:bg-foreground/[0.07]"
                                >
                                  <MoreVertical size={14} />
                                </button>
                              </div>
                            )}

                            {/* Project action menu */}
                            <AnimatePresence>
                              {projectMenuOpenId === project.id && (
                                <motion.div
                                  initial={{ opacity: 0, y: -4, scale: 0.97 }}
                                  animate={{ opacity: 1, y: 0, scale: 1 }}
                                  exit={{ opacity: 0, y: -4, scale: 0.97 }}
                                  transition={{ duration: 0.14 }}
                                  className="mx-5 mb-1 rounded-xl border border-foreground/[0.10] overflow-hidden"
                                  style={{ backgroundColor: "hsl(222 38% 9% / 0.97)" }}
                                >
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setRenamingProjectId(project.id);
                                      setRenameProjectValue(project.name);
                                      setProjectMenuOpenId(null);
                                    }}
                                    className="w-full flex items-center gap-3 px-4 py-3 text-left text-[13px] text-foreground/75 hover:bg-foreground/[0.05] hover:text-foreground/95 transition-colors font-body border-b border-foreground/[0.07]"
                                  >
                                    {t("history.rename")}
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => setChangingColorProjectId(changingColorProjectId === project.id ? null : project.id)}
                                    className="w-full flex items-center gap-3 px-4 py-3 text-left text-[13px] text-foreground/75 hover:bg-foreground/[0.05] hover:text-foreground/95 transition-colors font-body border-b border-foreground/[0.07]"
                                  >
                                    {t("history.changeColor")}
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => deleteProject(project.id)}
                                    className="w-full flex items-center gap-3 px-4 py-3 text-left text-[13px] text-red-400/75 hover:bg-red-400/[0.05] hover:text-red-400 transition-colors font-body"
                                  >
                                    {t("history.delete")}
                                  </button>
                                </motion.div>
                              )}
                            </AnimatePresence>

                            {/* Color picker */}
                            <AnimatePresence>
                              {changingColorProjectId === project.id && (
                                <motion.div
                                  initial={{ opacity: 0, height: 0 }}
                                  animate={{ opacity: 1, height: "auto" }}
                                  exit={{ opacity: 0, height: 0 }}
                                  className="overflow-hidden px-5 pb-2"
                                >
                                  <div className="flex gap-3 py-2">
                                    {COLOR_OPTIONS.map((color) => (
                                      <button
                                        key={color}
                                        type="button"
                                        onClick={() => changeProjectColor(project.id, color)}
                                        className={`w-6 h-6 rounded-full ring-1 transition-all ${project.color === color ? "ring-white/60 scale-110" : "ring-white/10 hover:ring-white/30"}`}
                                        style={{ backgroundColor: PROJECT_COLORS[color] }}
                                      />
                                    ))}
                                  </div>
                                </motion.div>
                              )}
                            </AnimatePresence>

                            {/* Expanded project sessions */}
                            <AnimatePresence>
                              {isExpanded && (
                                <motion.div
                                  initial={{ opacity: 0, height: 0 }}
                                  animate={{ opacity: 1, height: "auto" }}
                                  exit={{ opacity: 0, height: 0 }}
                                  className="overflow-hidden"
                                >
                                  <div className="border-l border-foreground/[0.07] ml-8 mr-2 mb-2">
                                    <button
                                      type="button"
                                      onClick={startNewReflection}
                                      className="w-full flex items-center gap-2 px-3 py-2.5 text-left text-[11px] text-primary/45 hover:text-primary/75 hover:bg-primary/[0.05] transition-colors font-body rounded-lg"
                                    >
                                      <Plus size={11} />
                                      {t("history.newChatInProject")} {project.name}
                                    </button>
                                    <AnimatePresence initial={false}>
                                      {historySessions
                                        .filter((s) => s.project_id === project.id)
                                        .map((session) => renderSessionRow(session, true))}
                                    </AnimatePresence>
                                    {historySessions.filter((s) => s.project_id === project.id).length === 0 && (
                                      <p className="px-3 py-2 text-[11px] text-foreground/25">
                                        {t("history.noSessions")}
                                      </p>
                                    )}
                                  </div>
                                </motion.div>
                              )}
                            </AnimatePresence>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {/* ── SECTION B: Conversations ── */}
                  <div className="border-t border-foreground/[0.07] mx-5 mt-3 mb-3" />

                  <div className="px-5 pb-2 flex items-center justify-between">
                    <p className="text-[9px] font-display font-semibold tracking-[0.3em] uppercase text-foreground/30">
                      {t("history.conversations")}
                    </p>
                  </div>

                  {/* Search bar */}
                  <div className="px-5 pb-3">
                    <div className="flex items-center gap-2 px-3 py-2 rounded-xl bg-foreground/[0.05] border border-foreground/[0.08]">
                      <Search size={12} className="text-foreground/30 shrink-0" />
                      <input
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder={t("history.searchPlaceholder")}
                        className="flex-1 bg-transparent text-[12px] text-foreground/75 placeholder:text-foreground/28 outline-none border-none min-w-0"
                      />
                      {searchQuery && (
                        <button type="button" onClick={() => setSearchQuery("")}>
                          <X size={11} className="text-foreground/35 hover:text-foreground/60 transition-colors" />
                        </button>
                      )}
                    </div>
                    {searchQuery.trim() && hasMoreHistory && (
                      <p className="mt-2 text-[11px] text-foreground/40">{t("history.searchLoaded")}</p>
                    )}
                  </div>

                  {historyLoadError && (
                    <div className="px-5 pb-3" role="status">
                      <p className="text-[12px] text-foreground/60">
                        {t(historyLoadError === "preview" ? "history.previewUnavailable" : "history.loadFailed")}
                      </p>
                      <button
                        type="button"
                        disabled={loadingHistory}
                        onClick={() => loadHistorySessions(historyLoadError === "page" && historyPagingRef.current.retryAppend)}
                        className="mt-2 text-[12px] text-primary disabled:opacity-40"
                      >{t("history.retry")}</button>
                    </div>
                  )}
                  {loadingHistory && historySessions.length === 0 ? (
                    <div className="px-5 py-3">
                      <p className="text-[12px] text-foreground/35">{t("mirror.reflecting")}</p>
                    </div>
                  ) : (() => {
                    const ungrouped = historySessions.filter((s) => !s.project_id);
                    const filtered = searchQuery.trim()
                      ? ungrouped.filter((s) =>
                          (s.title || s.preview || "").toLowerCase().includes(searchQuery.toLowerCase())
                        )
                      : ungrouped;

                    if (filtered.length === 0 && !historyLoadError) {
                      return (
                        <div className="px-5 py-4">
                          <p className="text-[12px] text-foreground/35 leading-relaxed">
                            {t("history.noSessions")}
                          </p>
                        </div>
                      );
                    }

                    const groups = groupSessionsByDate(filtered);
                    const groupKeys: { key: string; label: string }[] = [
                      { key: "today", label: t("history.today") },
                      { key: "yesterday", label: t("history.yesterday") },
                      { key: "lastWeek", label: t("history.lastWeek") },
                      { key: "older", label: t("history.older") },
                    ];

                    return (
                      <>
                        {groupKeys.map(({ key, label }) => {
                          const sessions = groups[key];
                          if (!sessions || sessions.length === 0) return null;
                          return (
                            <div key={key}>
                              <div className="px-5 pt-3 pb-1">
                                <p className="text-[9px] font-display font-semibold tracking-[0.3em] uppercase text-foreground/20">
                                  {label}
                                </p>
                              </div>
                              <AnimatePresence initial={false}>
                                {sessions.map((session) => renderSessionRow(session, false))}
                              </AnimatePresence>
                            </div>
                          );
                        })}
                      </>
                    );
                  })()}

                  {hasMoreHistory && (
                    <div className="px-5 py-4">
                      <button
                        type="button"
                        disabled={loadingHistory}
                        onClick={() => loadHistorySessions(true)}
                        className="w-full flex items-center justify-center gap-2 rounded-xl border border-foreground/10 px-3 py-2 text-[12px] text-foreground/70 disabled:opacity-40"
                      >
                        {loadingHistory && <Loader2 size={13} className="animate-spin" />}
                        {t("history.loadMore")}
                      </button>
                    </div>
                  )}

                </div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* ═══ Content area (sits on top of stage) ═══ */}
      {/* flex-col: o card de avatar (quando visível), o slot da energia e o
          spacer da barra são filhos de FLUXO — a energia centra no vão livre
          e re-centra sozinha quando o card sai. Os overlays (backdrop,
          painel de conversa, nudge) seguem absolutos e não participam. */}
      <div className="relative z-10 flex-1 overflow-hidden pointer-events-none flex flex-col">
        {/* Avatar incomplete overlay — takes priority over nudges when user
            has no avatar of their own (hasAvatar=false means they're seeing
            the global placeholder GLB). */}
        {!live && !showConversation && !showHistory && !hasAvatar && !avatarPromptDismissed && (
          /* Em FLUXO (era absolute top: inset+56px; o marginTop preserva a
             posição exata) para que o flex abaixo saiba que ele existe: com
             o card visível a energia centra no vão restante; no X ele
             desmonta e a energia re-centra sozinha. */
          <div
            className="relative z-[26] px-4 pointer-events-auto shrink-0"
            style={{ marginTop: "calc(env(safe-area-inset-top, 16px) + 56px)" }}
          >
            <div className="max-w-[360px] mx-auto">
              <button
                type="button"
                onClick={() => navigate("/onboarding/avatar")}
                className="relative w-full rounded-2xl border backdrop-blur-xl px-5 py-4 text-left transition-all active:scale-[0.98]"
                style={{
                  backgroundColor: "hsl(222 35% 9% / 0.88)",
                  borderColor: "hsl(var(--primary) / 0.38)",
                  boxShadow: "0 0 28px hsl(var(--primary) / 0.18), inset 0 1px 0 hsl(var(--primary) / 0.08)",
                }}
              >
                <button
                  type="button"
                  aria-label={t("mirror.avatarIncomplete.dismiss")}
                  onClick={(e) => {
                    e.stopPropagation();
                    setAvatarPromptDismissed(true);
                  }}
                  className="absolute top-2 right-2 p-1 rounded-full hover:bg-white/10 transition-colors"
                >
                  <X size={14} className="text-white/60" />
                </button>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary/15 border border-primary/30 flex items-center justify-center shrink-0">
                    <Sparkles size={16} className="text-primary" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-display text-[13px] font-semibold text-foreground leading-tight mb-0.5">
                      {t("mirror.avatarIncomplete.title")}
                    </p>
                    <p className="text-[11px] text-foreground/65 font-body leading-snug">
                      {t("mirror.avatarIncomplete.subtitle")}
                    </p>
                  </div>
                  <ChevronRight size={16} className="text-primary/80 shrink-0" />
                </div>
              </button>
            </div>
          </div>
        )}

        {/* ═══ Energia — filho de FLUXO, centrada por flexbox no vão livre ═══
            Regra do fix de posição (07/08, PR #447): a energia fica no CENTRO
            VERTICAL do espaço entre o conteúdo do topo (header + card acima,
            quando visível) e a barra de escrever. flex-1 + items-center fazem
            a re-centralização SOZINHOS quando o card é dispensado — nenhuma
            margem fixa. Barra, mic e chips não se movem: o spacer abaixo só
            reserva a zona da barra fixa dentro do fluxo.
            Tamanho: METADE do círculo do portal antigo (veredito 07/08) —
            e bem abaixo dos 420px a lens do wrapper fica sempre ligada
            custando ~1/4 dos pixels de shader do tamanho cheio. */}
        <div className="relative z-[5] flex-1 min-h-0 flex items-center justify-center">
          {!live && !mirrorSurfaceResolving && !mirrorShowsAvatar && (
            <div
              style={{
                width: "min(35vw, 17.5vh, 200px)",
                aspectRatio: "1 / 1",
                maxHeight: "100%",
              }}
            >
              <VyvEnergy
                state={presenceState}
                level={presenceState === "listening" ? amplitude : undefined}
                source={presenceState === "speaking" ? tts.audioElement : null}
              />
            </div>
          )}
        </div>
        {/* Toggle avatar × energia (decisão Rafa 21/08) — filho de FLUXO
            entre o slot da energia e o spacer da barra: não colide com o
            card/nudge (que vivem no topo) e o flex re-centra a energia
            sozinho quando ele entra. Visível também para quem NÃO tem
            avatar — nesse caso o lado "avatar" NAVEGA para o seletor
            (/onboarding/avatar, o mesmo destino do card acima) em vez de
            renderizar o GLB placeholder: 2.372 pessoas não sabem que o
            avatar existe, e um boneco genérico ensinaria a coisa errada. */}
        {!live && !showConversation && !showHistory && (
          <div className="relative z-[6] shrink-0 flex justify-center pb-2 pointer-events-auto">
            <MirrorSurfaceToggle
              value={mirrorSurface}
              onSelect={(next) => {
                if (next === "avatar" && !hasAvatar) {
                  navigate("/onboarding/avatar");
                  return;
                }
                setMirrorSurface(next);
              }}
            />
          </div>
        )}
        {/* Spacer da zona da barra (bottom 8px + altura medida + lift do
            idle): fecha o flex exatamente no topo da barra fixa. Dinâmico
            via estado — muda a barra, muda o lift, a energia re-centra. */}
        <div
          className="shrink-0"
          style={{ height: inputBarHeight + 8 + idleInputLift }}
        />

        {/* Smart nudge — only teach_mirror_incomplete, only on idle stage.
            Other nudge types stay on Home so the chat view isn't cluttered.
            Gated by hasAvatar so it doesn't collide with the avatar overlay. */}
        {!live && !showConversation && !showHistory && hasAvatar && activeNudge?.type === "teach_mirror_incomplete" && (
          <div
            className="absolute left-0 right-0 z-[25] px-4 pointer-events-auto"
            style={{ top: "calc(env(safe-area-inset-top, 16px) + 56px)" }}
          >
            <div className="max-w-[360px] mx-auto">
              <NudgeCard
                nudge={activeNudge}
                onDismiss={dismissNudge}
                onAct={actOnNudge}
              />
            </div>
          </div>
        )}

        {/* A conversa não fecha ao tocar no avatar: depois do primeiro turno,
            ela se comporta como uma thread estável. Histórico ou nova reflexão
            são as saídas deliberadas; não existe mais backdrop acidental. */}

        {/* Conversation panel — only visible when there are messages */}
        <AnimatePresence>
          {!live && showConversation && !showHistory && (messages.length > 0 || isLoading || hasEarlierMessages) && (
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 16 }}
              transition={{ duration: 0.28 }}
              className="absolute inset-x-0 top-0 z-20 px-4 pointer-events-auto"
              /* Thread e compositor compartilham a mesma borda inferior do
                 visual viewport. A thread ocupa TODO o espaço útil acima do
                 compositor; quando o teclado abre, ambos sobem juntos. */
              style={{ bottom: `calc(${inputBarHeight}px + var(--keyboard-offset, 0px) + 8px)` }}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                className="relative h-full max-w-[680px] mx-auto overflow-hidden flex flex-col"
                style={{
                  background: `linear-gradient(180deg, ${MIRROR_STAGE_BG}1f 0%, ${MIRROR_STAGE_BG}b8 18%, ${MIRROR_STAGE_BG}f2 100%)`,
                  borderTop: "1px solid hsl(var(--primary) / 0.10)",
                  backdropFilter: "blur(14px)",
                }}
              >
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-16 h-[1px] bg-gradient-to-r from-transparent via-primary/25 to-transparent" />

                {/* Thread contínua: o contêiner externo já termina exatamente
                    no compositor. flex-1 usa toda a área visível e o scroll
                    acontece só aqui, preservando header, avatar e campo. */}
                <div
                  ref={threadRef}
                  className="flex-1 min-h-0 overflow-y-auto px-2 sm:px-4 py-4"
                  style={{ touchAction: "pan-y" }}
                  /* Puxar a thread para BAIXO revela o avatar/energia. A
                     decisão é pura (mirrorStageGesture): só arma com a
                     thread no TOPO — no meio da conversa o dedo é scroll,
                     e o tracker desarma sozinho se o scroll andar. */
                  onTouchStart={(e) => {
                    pullTrackerRef.current = beginPull(
                      threadRef.current?.scrollTop ?? 1,
                      e.touches[0].clientY,
                    );
                  }}
                  onTouchMove={(e) => {
                    const r = trackPull(
                      pullTrackerRef.current,
                      threadRef.current?.scrollTop ?? 1,
                      e.touches[0].clientY,
                    );
                    pullTrackerRef.current = r.tracker;
                    if (r.reveal) returnToStage();
                  }}
                  onTouchEnd={() => {
                    pullTrackerRef.current = null;
                  }}
                >
                  {(hasEarlierMessages || earlierLoadError) && (
                    <div className="flex flex-col items-center gap-2 pb-4">
                      {earlierLoadError && <p className="text-[12px] text-foreground/60" role="status">{t("history.loadFailed")}</p>}
                      <button
                        type="button"
                        disabled={loadingEarlierMessages || isLoading}
                        onClick={loadEarlierMessages}
                        className="flex items-center gap-2 rounded-xl border border-foreground/10 px-3 py-2 text-[12px] text-foreground/65 disabled:opacity-40"
                      >
                        {loadingEarlierMessages && <Loader2 size={13} className="animate-spin" />}
                        {t(earlierLoadError ? "history.retry" : "history.loadEarlier")}
                      </button>
                    </div>
                  )}
                  <div className="space-y-2">
                    {messages.map((msg, i) => {
                      // Corte pos-denuncia. Cobre as DUAS identidades que uma
                      // bolha pode ter: o texto (mirror_messages.id) e a
                      // imagem gerada dentro dela (mirror_deliverables.id) —
                      // denunciar a imagem tem de sumir com a bolha inteira,
                      // que e o que o usuario ve como "aquele conteudo".
                      if (isReported(REPORT_SURFACES.MIRROR_MESSAGE, msg.id)) return null;
                      if (isReported(REPORT_SURFACES.DELIVERABLE_IMAGE, msg.deliverableImage?.deliverableId)) return null;

                      // Fala e denuncia tem condicoes DIFERENTES, e junta-las
                      // foi um bug real deste PR: o controle de denuncia vivia
                      // dentro do gate de `msg.content`, entao uma bolha de
                      // imagem sem legenda levaria o botao embora — e imagem
                      // gerada e UMA DAS DUAS telas da evidencia do Google.
                      //
                      // Falar exige TEXTO: mandar string vazia pro TTS devolve
                      // 400. Denunciar exige IDENTIDADE: o que o usuario viu
                      // pode ser so a imagem.
                      const speakable =
                        msg.role === "assistant" && !!msg.content && !isInternalSentinel(msg.content);
                      const reportableId =
                        msg.role === "assistant"
                          ? (msg.deliverableImage?.deliverableId ?? msg.id ?? null)
                          : null;
                      const reportAsImage = !!msg.deliverableImage?.deliverableId;

                      return (
                      <motion.div
                        key={`thread-${i}`}
                        initial={{ opacity: 0, y: 8 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.25 }}
                        className={`flex ${msg.role === "user" ? "justify-end" : "justify-start"}`}
                        onPointerDown={() => {
                          longPressTimerRef.current = window.setTimeout(() => {
                            setLongPressIdx(i);
                          }, 600);
                        }}
                        onPointerUp={() => {
                          if (longPressTimerRef.current) window.clearTimeout(longPressTimerRef.current);
                        }}
                        onPointerLeave={() => {
                          if (longPressTimerRef.current) window.clearTimeout(longPressTimerRef.current);
                        }}
                      >
                        {longPressIdx === i && (
                          <div className="absolute inset-0 z-30 flex items-center justify-center" onClick={() => setLongPressIdx(null)}>
                            <button
                              onClick={(e) => { e.stopPropagation(); deleteMessage(i); }}
                              className="px-4 py-2 rounded-xl bg-red-500/15 border border-red-500/25 text-red-400 text-[11px] font-display font-semibold"
                            >
                              Delete
                            </button>
                          </div>
                        )}
                        <div className={`max-w-[86%] flex flex-col gap-1.5 ${msg.role === "user" ? "items-end" : "items-start"}`}>
                          {/* A bolha de anexo do usuário sai junto com o resto do
                              caminho morto de base64: nada podia populá-la. A F1
                              reconstrói contra executor_attachments, com estado
                              por chip (enviando / lendo / pronto / falhou) — que é
                              outro componente, não este preview estático. */}
                          {msg.recap && (
                            <button
                              type="button"
                              aria-label={t("common.close")}
                              onClick={(e) => {
                                e.stopPropagation();
                                setMessages((prev) =>
                                  prev.filter((m) => m.recapId !== msg.recapId),
                                );
                              }}
                              className="group/recap px-3 py-2 rounded-2xl rounded-bl-sm flex items-center gap-2.5 max-w-full text-left transition-all active:scale-[0.98]"
                              style={{
                                background: "hsl(187 72% 50% / 0.08)",
                                border: "1px solid hsl(187 72% 50% / 0.18)",
                              }}
                            >
                              <span className="text-[16px] leading-none shrink-0">
                                {CAPTURE_RECAP_ICON[msg.recap.kind]}
                              </span>
                              <div className="min-w-0 flex-1">
                                <p className="text-[12px] font-display font-semibold text-primary/85 leading-tight">
                                  {msg.recap.title}
                                </p>
                                {msg.recap.subtitle && (
                                  <p className="text-[12px] font-body text-foreground/70 leading-snug truncate">
                                    {msg.recap.subtitle}
                                  </p>
                                )}
                              </div>
                              <span className="shrink-0 flex items-center text-primary/45 group-hover/recap:text-primary/75 transition-colors">
                                <X size={13} />
                              </span>
                            </button>
                          )}
                          {/* A bolha renderiza com TEXTO ou com IMAGEM. Antes
                              exigia texto, e a imagem morava dentro deste gate:
                              uma imagem sem legenda levaria junto o thumbnail e o
                              controle de denuncia. */}
                          {((msg.content && !isInternalSentinel(msg.content)) ||
                            (msg.role === "assistant" && msg.deliverableImage)) && (
                            <div
                              className={`px-3 py-2 rounded-2xl text-[15px] leading-[1.55] ${
                                msg.role === "user"
                                  ? "bg-primary/[0.10] border border-primary/[0.16] text-foreground rounded-br-sm"
                                  : "bg-foreground/[0.05] border border-foreground/[0.08] text-foreground/80 rounded-bl-sm"
                              }`}
                            >
                              {/* PR-A F2: imagem gerada É o conteúdo da bolha —
                                  thumbnail clicável (viewer compartilhado) com a
                                  legenda curta embaixo. */}
                              {msg.role === "assistant" && msg.deliverableImage && (
                                <DeliverableChatImage
                                  storagePath={msg.deliverableImage.storagePath}
                                  title={msg.deliverableImage.title}
                                  onOpen={() => {
                                    analytics.deliverableViewed({
                                      format: "png",
                                      kind: "image",
                                      surface: "chat",
                                    });
                                    setImageView(msg.deliverableImage!);
                                  }}
                                />
                              )}
                              {msg.content && !isInternalSentinel(msg.content) && (
                                msg.role === "assistant" ? (
                                  <div ref={node => {
                                    if (!msg.speechMeasurement) return;
                                    if (node) speechTextNodesRef.current.set(msg.speechMeasurement, node);
                                    else speechTextNodesRef.current.delete(msg.speechMeasurement);
                                  }} className="prose prose-base prose-invert max-w-none [&_p]:mb-1 [&_p:last-child]:mb-0 [&_strong]:text-primary/75">
                                    <ReactMarkdown>{msg.content}</ReactMarkdown>
                                  </div>
                                ) : (
                                  <p className="whitespace-pre-wrap">{msg.content}</p>
                                )
                              )}
                            </div>
                          )}
                          {/* Linha de acoes da bolha. Aparece se HOUVER pelo
                              menos uma acao — cada uma com a sua condicao. */}
                          {(speakable || reportableId) && (
                            <div className="self-start mt-1 flex items-center gap-1">
                              {/* V4.3 on-demand TTS — no auto-play; o usuario toca
                                  pra ouvir. Exige texto: TTS de string vazia da 400. */}
                              {speakable && (
                                <button
                                  type="button"
                                  onClick={() => speakResponse(msg.content, () => true, undefined, true)}
                                  className="inline-flex items-center gap-1 text-[11px] text-foreground/45 hover:text-primary/80 transition-colors"
                                  aria-label={t("mirror.listen")}
                                >
                                  <Volume2 size={12} />
                                  {t("mirror.listen")}
                                </button>
                              )}
                              {/* Denuncia — ao lado de "Ouvir", nao atras de um
                                  long-press. O long-press ja existe nesta thread
                                  (apagar) e e exatamente o padrao que a rejeicao
                                  chama de inexistente: quem revisa a submissao
                                  precisa VER o controle.
                                  So exige IDENTIDADE, nunca texto: a bolha de
                                  imagem gerada traz a sua (mirror_deliverables.id)
                                  e o botao aparece mesmo sem legenda. */}
                              {reportableId && (
                                reportAsImage ? (
                                  <ReportContentButton
                                    surface={REPORT_SURFACES.DELIVERABLE_IMAGE}
                                    contentId={reportableId}
                                    snapshot={msg.deliverableImage!.storagePath}
                                    snapshotKind="image_path"
                                    context={{ title: msg.deliverableImage!.title, caption: msg.content, source: "chat" }}
                                  />
                                ) : (
                                  <ReportContentButton
                                    surface={REPORT_SURFACES.MIRROR_MESSAGE}
                                    contentId={reportableId}
                                    snapshot={msg.content}
                                    context={{ session_id: sessionId, module_context: moduleContext ?? null }}
                                  />
                                )
                              )}
                            </div>
                          )}
                          {msg.role === "assistant" && msg.bodyScanHandoff && isCurrentBodyScanHandoff(msg.bodyScanHandoff, {
                            ...actionResultStreamRef.current, sessionId: activeSessionIdRef.current,
                          }) && (
                            <MirrorBodyScanHandoffCard onOpen={() => handleBodyScanHandoff(msg.bodyScanHandoff!)} />
                          )}
                          {msg.role==="assistant"&&fileEditOrigin&&msg.id===fileEditOrigin.actionId&&fileEditOrigin.isCurrent()&&(
                            <MirrorFileEditLauncher key={fileEditOrigin.actionId} origin={fileEditOrigin}
                              onCancel={()=>setFileEditOrigin(null)} onConfirmedReceipt={acknowledgeFileEdit}/>
                          )}
                          {msg.role==="assistant"&&windsorReportOrigin&&msg.id===windsorReportOrigin.actionId
                            &&windsorReportOrigin.isCurrent()&&(
                              <MirrorWindsorReportLauncher key={windsorReportOrigin.actionId} origin={windsorReportOrigin}
                                onCancel={()=>setWindsorReportOrigin(null)}/>
                            )}
                          {msg.role === "assistant" && msg.proposals && msg.proposals.length > 0 && (
                            <div className="flex flex-col gap-2 w-full">
                              {msg.proposals.map((chip, pi) => {
                                if (chip.proposal.tool === 'propose_fitness_local_draft_discard') return null;
                                if (chip.status === "cancelled") return null;
                                return (
                                  <MirrorActionChip
                                    key={`${i}-proposal-${pi}-${chip.proposal.action_id}`}
                                    proposal={chip.proposal}
                                    onConfirm={() => handleProposalConfirm(i, pi)}
                                    onCancel={() => handleProposalCancel(i, pi)}
                                    onUndo={
                                      chip.createdRecord
                                        ? () => handleProposalUndo(i, pi)
                                        : undefined
                                    }
                                    onDownload={
                                      chip.deliverableFile
                                        ? () => handleDeliverableDownload(chip)
                                        : undefined
                                    }
                                  />
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </motion.div>
                      );
                    })}

                    {/* Item 2 — convite de WhatsApp, INLINE no fio. Entra
                        depois da última bolha, como se fosse mais uma coisa
                        que o Espelho disse. Não é sheet: o slot modal deste
                        instante é do push soft-ask, e dois pedidos no mesmo
                        minuto matam os dois. Auto-gated pelo hook (braço do
                        experimento + já vinculado + árbitro do D0). */}
                    {waSoftAsk.visible && (
                      <div className="flex justify-start">
                        <WaSoftAskChip
                          onAccept={() => { void waSoftAsk.accept(); }}
                          onDecline={waSoftAsk.decline}
                          activating={waSoftAsk.activating}
                          failed={waSoftAsk.failed}
                        />
                      </div>
                    )}

                    {/* Integração — mesmo slot, nunca junto com o de cima:
                        dois pedidos na mesma respiração é exatamente o que o
                        comentário do soft-ask diz para não fazer. */}
                    {!waSoftAsk.visible && integrationSuggest.suggestion && (
                      <div className="flex justify-start">
                        <IntegrationSuggestChip
                          suggestion={integrationSuggest.suggestion}
                          onAccept={() => {
                            integrationSuggest.accept();
                            navigate("/settings/connections");
                          }}
                          onDecline={integrationSuggest.dismiss}
                        />
                      </div>
                    )}

                    {/* FALAR COM O WELFARE OFFICER — mesmo slot inline, e a
                        mesma disciplina: nunca junto com os dois de cima.
                        A diferença é que este NÃO é pedido do sistema — é uma
                        porta que fica aberta e só se abre por toque da pessoa.
                        Por isso ele não some depois de recusado: quem precisa
                        de ajuda amanhã precisa achar a porta amanhã.
                        ⛔ Só morador de organização. B2C não vê nada. */}
                    {orgMembership.isResident &&
                      !orgMembership.loading &&
                      !waSoftAsk.visible &&
                      !integrationSuggest.suggestion && (
                        <div className="flex justify-start">
                          {welfareSent ? (
                            <p
                              className="text-[11px] font-body px-1 py-2"
                              style={{ color: "hsl(142 60% 62%)" }}
                              role="status"
                            >
                              {t("welfareOfficer.sent")}
                            </p>
                          ) : welfareOpen ? (
                            <WelfareOfficerChip
                              sessionId={sessionId}
                              origin="mirror"
                              onSent={() => {
                                setWelfareOpen(false);
                                setWelfareSent(true);
                              }}
                              onDismiss={() => setWelfareOpen(false)}
                            />
                          ) : (
                            <button
                              type="button"
                              onClick={() => setWelfareOpen(true)}
                              className="text-[11px] font-display underline underline-offset-2 px-1 py-2 text-foreground/55 hover:text-foreground/85 transition-colors"
                              style={{ minHeight: 44 }}
                            >
                              {t("welfareOfficer.open")}
                            </button>
                          )}
                        </div>
                      )}

                    {isLoading && (
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        className="flex justify-start"
                      >
                        <div className="max-w-[86%] px-3 py-2 rounded-2xl rounded-bl-sm bg-foreground/[0.05] border border-foreground/[0.08] text-foreground/65">
                          <p className="text-[11px] font-body">{t("mirror.reflecting")}</p>
                        </div>
                      </motion.div>
                    )}
                  </div>
                </div>

                <div className="border-t border-foreground/[0.06] px-4 py-2">
                  <p className="text-center text-[9px] font-display tracking-[0.3em] uppercase text-foreground/45">
                    {stateLabel}
                  </p>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
        {/* Owner recovery stays reachable after the last message or its
            conversation is deleted, including the empty mirror stage. */}
        {!live && !nutritionHydrationPrefill && !nutritionGoalsPrefill && !fitnessCuratedPlanPrefill && (
          <div className="absolute inset-x-0 z-30 px-4 pointer-events-none"
            style={{ bottom: `calc(${inputBarHeight}px + var(--keyboard-offset, 0px) + 8px)` }}>
            <div className="mx-auto max-w-[680px] max-h-[50dvh] overflow-y-auto pointer-events-auto">
              {captureOwnerId&&sessionId&&<ConnectedFileEditRecoveryPanel ownerId={captureOwnerId} sessionId={sessionId}
                isCurrent={()=>actionResultStreamRef.current.mounted&&!actionResultStreamRef.current.sessionTransition
                  &&actionResultStreamRef.current.ownerId===captureOwnerId&&activeSessionIdRef.current===sessionId}
                onRecovered={async(entry,current)=>{
                  const context=entry.body.mirror_context;
                  if(!current()||context?.session_id!==sessionId)return false;
                  const receipt=await mirrorFileEditReceiptReference(entry,{userId:captureOwnerId,sessionId,actionId:context.action_id,authSessionId:entry.authSessionId});
                  return !!receipt&&current()&&await acknowledgeFileEdit(receipt,current)&&current();
                }}/>}
              {captureOwnerId && sessionId && <FilePendingRecoveryPanel ownerId={captureOwnerId} sessionId={sessionId}
                isCurrent={() => actionResultStreamRef.current.mounted && !actionResultStreamRef.current.sessionTransition
                  && actionResultStreamRef.current.ownerId === captureOwnerId && activeSessionIdRef.current === sessionId}
                onRecovered={async (entry, current) => {
                  const context = entry.body.mirror_context;
                  if (!current() || !context || typeof context !== 'object' || Array.isArray(context)
                    || !('session_id' in context) || context.session_id !== sessionId
                    || !('action_id' in context) || typeof context.action_id !== 'string') return false;
                  const receipt = mirrorFileReceiptReference(entry, { userId: captureOwnerId, sessionId, actionId: context.action_id });
                  return !!receipt && current() && await acknowledgeCapture('propose_file_action', receipt) && current();
                }} />}
              {captureOwnerId && sessionId && <ConnectedTaskPendingRecoveryPanel ownerId={captureOwnerId} sessionId={sessionId}
                isCurrent={() => actionResultStreamRef.current.mounted && !actionResultStreamRef.current.sessionTransition
                  && actionResultStreamRef.current.ownerId === captureOwnerId && activeSessionIdRef.current === sessionId}
                onRecovered={async (entry, current) => {
                  const context = entry.body.mirror_context;
                  if (!current() || !context || typeof context !== 'object' || Array.isArray(context)
                    || !('session_id' in context) || context.session_id !== sessionId
                    || !('action_id' in context) || typeof context.action_id !== 'string') return false;
                  const receipt = mirrorConnectedTaskReceiptReference(entry, { userId: captureOwnerId, sessionId, actionId: context.action_id });
                  return !!receipt && current() && await acknowledgeCapture('propose_connected_task_action', receipt) && current();
                }} />}
              {captureOwnerId && sessionId && <ConnectedTaskMutationRecoveryPanel ownerId={captureOwnerId} sessionId={sessionId}
                isCurrent={() => actionResultStreamRef.current.mounted && !actionResultStreamRef.current.sessionTransition
                  && actionResultStreamRef.current.ownerId === captureOwnerId && activeSessionIdRef.current === sessionId}
                onRecovered={async (entry, current) => {
                  const context = entry.body.mirror_context;
                  if (!current() || !context || typeof context !== 'object' || Array.isArray(context)
                    || !('session_id' in context) || context.session_id !== sessionId
                    || !('action_id' in context) || typeof context.action_id !== 'string') return false;
                  const receipt = mirrorConnectedTaskReceiptReference(entry, { userId: captureOwnerId, sessionId, actionId: context.action_id });
                  return !!receipt && current() && await acknowledgeCapture('propose_connected_task_action', receipt) && current();
                }} />}
              {captureOwnerId && sessionId && <ConnectedTaskDeleteRecoveryPanel ownerId={captureOwnerId} sessionId={sessionId}
                isCurrent={() => actionResultStreamRef.current.mounted && !actionResultStreamRef.current.sessionTransition
                  && actionResultStreamRef.current.ownerId === captureOwnerId && activeSessionIdRef.current === sessionId}
                onRecovered={async (entry, current) => {
                  const context = entry.body.mirror_context;
                  if (!current() || !context || typeof context !== 'object' || Array.isArray(context)
                    || !('session_id' in context) || context.session_id !== sessionId
                    || !('action_id' in context) || typeof context.action_id !== 'string') return false;
                  const receipt = mirrorConnectedTaskReceiptReference(entry, { userId: captureOwnerId, sessionId, actionId: context.action_id });
                  return !!receipt && current() && await acknowledgeCapture('propose_connected_task_action', receipt) && current();
                }} />}
              {captureOwnerId && sessionId && <ConnectedMessagePendingRecoveryPanel ownerId={captureOwnerId} sessionId={sessionId}
                isCurrent={() => actionResultStreamRef.current.mounted && !actionResultStreamRef.current.sessionTransition
                  && actionResultStreamRef.current.ownerId === captureOwnerId && activeSessionIdRef.current === sessionId}
                onRecovered={async (entry, current) => {
                  const context = entry.body.mirror_context;
                  if (!current() || !context || typeof context !== 'object' || Array.isArray(context)
                    || !('session_id' in context) || context.session_id !== sessionId
                    || !('action_id' in context) || typeof context.action_id !== 'string') return false;
                  const receipt = mirrorConnectedMessageReceiptReference(entry, { userId: captureOwnerId, sessionId, actionId: context.action_id });
                  return !!receipt && current() && await acknowledgeCapture('propose_connected_message_action', receipt) && current();
                }} />}
              <NutritionHydrationPendingRecoveryPanel refreshKey={(sessionId ?? 'none') + ':' + messages.length} />
              <LanguagePendingRecoveryPanel refreshKey={(sessionId ?? 'none') + ':' + messages.length} />
              <LanguageClassPendingRecoveryPanel refreshKey={(sessionId ?? 'none') + ':' + messages.length} />
              {captureOwnerId && <NotePendingActionLauncher ownerId={captureOwnerId} brainKind="map" onMirrorResume={locator => navigate('/mirror', { state: { brainNoteActionRecovery: locator } })} />}
              {captureOwnerId && <NotePendingActionLauncher ownerId={captureOwnerId} brainKind="emotion" onMirrorResume={locator => navigate('/mirror', { state: { brainNoteActionRecovery: locator } })} />}

              <NutritionGoalsPendingRecoveryPanel refreshKey={(sessionId ?? 'none') + ':' + messages.length} />
              <FitnessCuratedPlanActionPanel refreshKey={(sessionId ?? 'none') + ':' + messages.length} />
            </div>
          </div>
        )}
      </div>

      {/* ═══ Input bar — fixed above keyboard ═══ */}
      <style>{`
        @keyframes voicePulse {
          0%, 100% { box-shadow: 0 0 0 8px hsl(187 72% 55% / 0.15), 0 0 0 16px hsl(187 72% 55% / 0.08), 0 0 24px hsl(187 72% 55% / 0.4); }
          50% { box-shadow: 0 0 0 12px hsl(187 72% 55% / 0.20), 0 0 0 24px hsl(187 72% 55% / 0.10), 0 0 36px hsl(187 72% 55% / 0.6); }
        }
        @keyframes voiceRipple {
          0% { transform: scale(1); opacity: 0.6; }
          100% { transform: scale(1.8); opacity: 0; }
        }
      `}</style>

      {/* Modo Professor caption — discrete subtitle band (NOT a chat bubble),
          current turn only, sits just above the push-to-talk button. */}
      {live && tutorCaption && (
        <div
          className="fixed left-0 right-0 z-30 px-6 pointer-events-none flex justify-center"
          style={{ bottom: "calc(env(safe-area-inset-bottom, 16px) + 132px)" }}
        >
          <div
            className="max-w-[360px] w-full text-center rounded-2xl px-4 py-2.5"
            style={{
              background: "hsl(222 35% 9% / 0.72)",
              border: "1px solid hsl(var(--primary) / 0.18)",
              backdropFilter: "blur(12px)",
            }}
          >
            <p className="font-display text-[15px] leading-snug text-foreground">
              {tutorCaption.spoken}
            </p>
            {tutorCaption.translation && (
              <p className="font-body text-[12px] leading-snug text-foreground/55 mt-1">
                {tutorCaption.translation}
              </p>
            )}
          </div>
        </div>
      )}

      <motion.div
        ref={inputBarRef}
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: entered ? 1 : 0, y: entered ? 0 : 18 }}
        transition={{ delay: 0.55, duration: 0.8 }}
        className="px-5 pt-4"
        style={{
          position: "fixed",
          bottom: "calc(8px + var(--keyboard-offset, 0px))",
          left: 0,
          right: 0,
          zIndex: 30,
          paddingBottom: isKeyboardOpen ? 0 : "env(safe-area-inset-bottom, 16px)",
          background: "transparent",
        }}
      >
        {/* Lift do idle da energia: transform num wrapper INTERNO porque o
            framer é dono do transform do motion.div acima, e porque transform
            não altera offsetHeight — o painel de conversa (bottom:
            inputBarHeight) e a medição do ResizeObserver seguem corretos. */}
        <div
          style={{
            transform: `translateY(${-idleInputLift}px)`,
            transition: "transform 0.5s cubic-bezier(0.22, 1, 0.36, 1)",
            willChange: "transform",
          }}
        >
        {!live && !showConversation && !showHistory && !isKeyboardOpen && suggestionsArmed && !moduleContext && <MirrorDayEntry />}
        {/* Outcome actions use the existing send pipeline and its quota gates. */}
        {!live && !showConversation && !showHistory && !isKeyboardOpen && suggestionsArmed && !moduleContext && (
          <div className="flex flex-wrap gap-2 justify-center max-w-[680px] mx-auto w-full mb-3">
            {["priorities", "summary"].map(action => <button key={action} type="button" disabled={isLoading}
              onClick={() => { analytics.mirrorSuggestionTap(`mirror.ready.${action}`); sendMessage(t(`mirror.ready.${action}Send`)); }}
              className="min-h-11 px-4 py-2 rounded-xl text-sm font-medium text-foreground border border-primary/25 bg-background/90 hover:bg-primary/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-50">
              {t(`mirror.ready.${action}`)}
            </button>)}
          </div>
        )}

        {!live && <div className="max-w-[680px] mx-auto w-full">
      <FitnessPendingActionLauncher ownerId={captureOwnerId ?? ""} busy={isLoading || !!recoveredFitnessPrefill}
        onMirrorResume={locator => navigate(location.pathname + location.search, { state: { fitnessActionRecovery: locator } })} />
      <FitnessDraftDiscardRecovery key={[captureOwnerId, sessionId, actionResultStreamRef.current.authEpoch, actionResultStreamRef.current.sessionEpoch, actionResultStreamRef.current.request].join(':')}
        ownerId={captureOwnerId ?? ''} sessionId={sessionId} busy={isLoading || !!fitnessDraftDiscardPrefill}
        isCurrent={(() => { const state = actionResultStreamRef.current, owner = captureOwnerId, currentSession = sessionId, authEpoch = state.authEpoch, sessionEpoch = state.sessionEpoch, request = state.request;
          return () => state.mounted && !state.sessionTransition && state.ownerId === owner && activeSessionIdRef.current === currentSession && state.authEpoch === authEpoch && state.sessionEpoch === sessionEpoch && state.request === request;
        })()} onLocalReceipt={publishLocalDraftReceipt} />
        </div>}
        {/* Text input row — hidden in Live (push-to-talk only). */}
        {!live && (
        <>
        {/* Fila de anexos do turno (F1). Fica ACIMA do campo: um chip dentro da
            barra empurraria o input e o botão de enviar a cada arquivo. */}
        <div className="max-w-[680px] mx-auto w-full">
          {/* Nota vinda de Notas → "Enviar ao Espelho". Visível ANTES do envio:
              o usuário confere o que está anexado e pode remover. */}
          {attachedNote && (
            <div className="flex items-start gap-2 mb-1.5 px-2.5 py-2 rounded-xl border"
              style={{
                backgroundColor: "hsl(187 72% 50% / 0.06)",
                borderColor: "hsl(187 72% 50% / 0.22)",
              }}>
              <Sparkles size={12} className="mt-0.5 shrink-0" style={{ color: "hsl(187 72% 55%)" }} />
              <div className="min-w-0 flex-1">
                <div className="text-[9px] font-display tracking-wide" style={{ color: "hsl(187 72% 55%)" }}>
                  {t("mirror.noteContext.label")}
                </div>
                <div className="text-[11px] text-foreground/70 truncate">{attachedNote}</div>
              </div>
              <button
                type="button"
                onClick={() => { attachedNoteRef.current = null; setAttachedNote(null); }}
                title={t("common.close")}
                aria-label={t("common.close")}
                className="shrink-0 text-foreground/35 hover:text-foreground/70 transition-colors"
              >
                <X size={12} />
              </button>
            </div>
          )}
          {attachedGoal && <div className="mb-1.5 flex items-center gap-2 rounded-xl border border-border px-3 py-2">
            <div className="min-w-0 flex-1"><div className="text-xs font-medium">{t("mirror.goalContext.label")}</div><p className="truncate text-sm">{attachedGoal.title}</p></div>
            <button type="button" className="min-h-11 min-w-11" aria-label={t("goalAction.removeContext")} onClick={() => setAttachedGoal(null)}><X size={16} /></button>
          </div>}
          <AttachmentChips
            chips={attachments.chips}
            onRemove={(id) => void attachments.remove(id)}
            onRetry={(id) => void attachments.retry(id)}
          />
        </div>
        <form
          onSubmit={handleSubmit}
          className="flex flex-wrap gap-1.5 max-w-[680px] mx-auto w-full items-center px-1 py-1 rounded-[22px] border transition-all duration-500"
          style={{
            backgroundColor: "hsl(222 35% 9% / 0.85)",
            borderColor: input.trim()
              ? "hsl(var(--primary) / 0.35)"
              : "hsl(var(--primary) / 0.12)",
            boxShadow: input.trim()
              ? "0 0 24px hsl(var(--primary) / 0.12), inset 0 1px 0 hsl(var(--primary) / 0.06)"
              : "0 0 12px hsl(var(--primary) / 0.06), inset 0 1px 0 hsl(255 100% 100% / 0.03)",
            backdropFilter: "blur(20px)",
          }}
        >
          <VoiceRecordingIndicator
            isRecording={voice.isListening}
            isTranscribing={isTranscribing}
            isStarting={isVoiceStarting}
            isReviewing={voiceDraftReady}
            seconds={recordingSeconds}
            amplitude={amplitude}
            onCancel={handleCancelVoice}
            onStop={() => void handleVoicePress()}
          />
          {/* P2: menu multitarefa — descoberta permanente das capacidades do
              Espelho. Abre o bottom-sheet; o item ENVIA a semente ao Espelho
              (Ajuste A: a conversa começa no clique) ou navega (Meus Agentes). */}
          <button
            type="button"
            onClick={() => {
              analytics.mirrorComposerMenuOpened();
              setComposerMenuOpen(true);
            }}
            disabled={isAnalyzingPhoto || voiceBusy}
            title={t("mirror.composerMenu.open")}
            aria-label={t("mirror.composerMenu.open")}
            className="h-10 w-10 rounded-xl shrink-0 flex items-center justify-center text-foreground/40 hover:text-primary/80 hover:bg-primary/10 transition-all duration-300 disabled:opacity-50"
          >
            {/* A análise da foto de refeição leva segundos e antes tinha
                spinner no botão da câmera. Com a câmera dentro do menu, o `+`
                herda o sinal — é o único afordance visível agora, e é de onde
                o usuário acabou de sair. Sem isso a espera fica sem feedback. */}
            {isAnalyzingPhoto ? <Loader2 size={17} className="animate-spin" /> : <Plus size={18} />}
          </button>
          {/* ── ENTRADAS DE ARQUIVO ────────────────────────────────────────
              Os <input> ficam AQUI, montados na barra, e não dentro do
              <DrawerContent>: o Drawer desmonta o conteúdo ao fechar, e um
              input desmontado nunca dispara onChange — o arquivo escolhido
              sumiria sem erro. Os GATILHOS é que moram no menu do `+`, com
              rótulo em texto. Decisão do Rafa depois de usar: um afordance
              visível só, porque ícone sem rótulo só comunica quando o
              significado é universal, e câmera≠refeição para qualquer um. */}

          {/* Foto de REFEIÇÃO (Nutrição) — `capture` fica, aqui é câmera mesmo:
              o destino é nutrition-photo-analyze, não o turno de conversa. */}
          <input
            ref={photoInputRef}
            type="file"
            accept="image/*"
            capture="environment"
            onChange={handlePhotoPick}
            className="hidden"
          />
          {/* Anexo de ARQUIVO (F1) — imagem, PDF ou planilha para o turno.
              SEM `capture`: o atributo abre a câmera direto no mobile e
              SUPRIME o seletor de arquivos, e com ele não existiria anexo de
              PDF nem de planilha (não existe PDF na câmera). Sem ele, o
              seletor nativo do iOS/Android continua oferecendo "Tirar Foto"
              entre as origens, então o caminho de câmera não se perde. */}
          <input
            ref={attachInputRef}
            type="file"
            accept={ATTACH_ACCEPT}
            multiple
            onChange={(e) => {
              const files = e.target.files;
              if (files && files.length > 0) void attachments.attach(files);
              if (e.target) e.target.value = ""; // permite re-anexar o mesmo arquivo
            }}
            className="hidden"
          />
          <div className="relative min-w-0 flex-1">
            <textarea
              rows={1}
              aria-label={t("mirror.askPlaceholder")}
              disabled={voiceBusy}
              ref={inputRef}
              value={input}
              onFocus={() => {
                setShowConversation(true);
                // setMirrorState("listening"); — DISABLED Group B revert
              }}
              // Blur = teclado fechando: zera as vars sem esperar o
              // visualViewport (fix 66aa9c10 — quirk iOS 26 de offsetTop
              // residual; o evento pós-fechamento pode mentir ou faltar).
              onBlur={() => resetKeyboardCssVars()}
              onClick={() => setShowConversation(true)}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                  e.preventDefault();
                  handleSubmit(e);
                }
              }}
              placeholder={t("mirror.askPlaceholder")}
              className="block w-full min-h-10 max-h-[120px] resize-none bg-transparent border-0 shadow-none ring-0 outline-none focus-visible:ring-0 text-foreground placeholder:text-foreground/25 text-[13px] leading-5 py-2.5 px-1 transition-all disabled:opacity-70"
            />
          </div>
          {/* Send button — arquivo PRONTO já habilita o envio mesmo sem texto
              ("olha isso aqui" é gesto legítimo); enquanto algo está subindo ou
              sendo lido, o envio espera, porque mandar o turno sem o anexo que
              o usuário acabou de escolher é pior do que esperar dois segundos. */}
          {(() => {
            const canSend =
              (!!input.trim() || attachments.readyIds.length > 0 || !!attachedNote) &&
              !isLoading && !voiceBusy && !attachments.busy;
            if (voiceBusy) return <div aria-hidden="true" className="w-10 shrink-0" />;
            if (isLoading || tts.isLoading || isSpeaking) {
              return <button type="button" onClick={handleStopResponse}
                title={t("mirror.voice.stopResponse")} aria-label={t("mirror.voice.stopResponse")}
                className="min-h-11 min-w-11 rounded-xl shrink-0 flex items-center justify-center text-red-300 bg-red-400/10 border border-red-400/20 transition-all active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary">
                <Square size={14} fill="currentColor" />
              </button>;
            }
            if (canSend || attachments.busy) {
              return <button type="submit" disabled={!canSend}
                title={t("mirror.voice.send")} aria-label={t("mirror.voice.send")}
                className={`h-10 w-10 rounded-xl shrink-0 flex items-center justify-center transition-all duration-300 ${canSend
                  ? "bg-primary/20 text-primary shadow-[0_0_20px_hsl(var(--primary)/0.40)] hover:bg-primary/30 active:scale-95"
                  : "text-foreground/25 cursor-not-allowed"}`}>
                {attachments.busy ? <Loader2 size={16} className="animate-spin" /> : <ArrowUp size={16} />}
              </button>;
            }
            return <button type="button" onClick={handleVoicePress}
              disabled={!voice.supported || isLoading}
              title={!voice.supported ? t("mirror.voiceNotSupported") : t("mirror.speak")}
              aria-label={t("mirror.speak")}
              className="h-10 w-10 rounded-xl shrink-0 flex items-center justify-center text-foreground/50 hover:text-primary hover:bg-primary/10 transition-all disabled:opacity-40">
              <Mic size={18} />
            </button>;
          })()}
        </form>
        </>
        )}

        {realtimeLive && liveToolHandoff && actionResultStreamRef.current.authScope.isCurrent(liveToolHandoff.lease) && (
          <section role="status" className="w-full max-w-[680px] mx-auto rounded-xl border border-primary/20 bg-primary/5 p-3 text-sm">
            <p className="whitespace-pre-wrap">{liveToolHandoff.handoff.response}</p>
            <button type="button" onClick={reviewLiveToolInChat} className="mt-2 rounded-lg border border-primary/30 px-3 py-2 text-primary">
              {t("mirror.live.toChat")}
            </button>
          </section>
        )}

        {/* LIVE Realtime (LOTE 3): medidor de minutos + estado + começar/encerrar. */}
        {realtimeLive && (
          <MirrorLiveControls
            status={rt.status}
            presence={rt.presence}
            endReason={rt.endReason}
            secondsRemaining={rt.secondsRemaining}
            onStart={rt.start}
            onEnd={rt.end}
          />
        )}

        {/* Large voice button — primary action, only in idle/live. */}
        {heroVoiceVisible && (
        <div className="flex flex-col items-center gap-2 mt-4 w-full max-w-[680px] mx-auto">
            <VoiceRecordingIndicator
              isRecording={VOICE_WHISPER_ENABLED && voice.isListening}
              isTranscribing={isTranscribing}
              seconds={recordingSeconds}
              amplitude={amplitude}
              isStarting={isVoiceStarting}
              onCancel={handleCancelVoice}
              onStop={() => void handleVoicePress()}
            />
          <div style={{ position: "relative" }}>
            <button
              type="button"
              disabled={!voice.supported || isLoading || isVoiceStarting || isTranscribing}
              title={!voice.supported ? t("mirror.voiceNotSupported") : undefined}
            onClick={handleVoicePress}
            className="relative flex items-center justify-center"
            style={{
              width: 72,
              height: 72,
              borderRadius: "50%",
              background: voice.isListening
                ? "radial-gradient(circle, hsl(187 72% 45%), hsl(187 72% 25%))"
                : "radial-gradient(circle, hsl(220 35% 18%), hsl(220 35% 10%))",
              border: voice.isListening
                ? "2px solid hsl(187 72% 65%)"
                : "2px solid hsl(220 35% 30%)",
              boxShadow: voice.isListening
                ? "0 0 0 8px hsl(187 72% 55% / 0.15), 0 0 0 16px hsl(187 72% 55% / 0.08), 0 0 24px hsl(187 72% 55% / 0.4)"
                : "0 0 12px hsl(220 35% 8% / 0.6)",
              transition: "all 0.3s ease",
              animation: voice.isListening ? "voicePulse 1.5s ease-in-out infinite" : "none",
              opacity: !voice.supported ? 0.3 : 1,
              cursor: !voice.supported ? "not-allowed" : "pointer",
            }}
          >
            <Mic size={28} color={voice.isListening ? "white" : "hsl(187 72% 65%)"} />
            {voice.isListening && (
              <span
                className="absolute inset-0 rounded-full"
                style={{
                  animation: "voiceRipple 1.5s ease-out infinite",
                  border: "2px solid hsl(187 72% 55% / 0.5)",
                }}
              />
            )}
            </button>
          </div>
        </div>
        )}

        {/* Stop speaking button — visible only while TTS is active */}
        <AnimatePresence>
          {(isSpeaking || tts.isLoading || isLoading) && heroVoiceVisible && (
            <motion.div
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 6 }}
              transition={{ duration: 0.2 }}
              className="flex justify-center mt-3"
            >
              <button
                type="button"
                onClick={handleStopResponse}
                className="flex items-center justify-center gap-2 px-4 py-2 rounded-full text-xs font-display tracking-wide transition-all active:scale-95"
                style={{
                  background: "hsl(220 35% 14% / 0.8)",
                  border: "1px solid hsl(0 60% 55% / 0.4)",
                  color: "hsl(0 60% 70%)",
                }}
              >
                <Square size={12} fill="currentColor" />
                {t("mirror.stop")}
              </button>
            </motion.div>
          )}
        </AnimatePresence>
        </div>
      </motion.div>

      {/* Watermark */}
      <div className="absolute bottom-2 right-4 z-10 opacity-[0.08]">
        <img src={vyvIcon} alt="" className="w-4 h-4 object-contain" />
      </div>

      {/* Persistent audio element for iOS Safari TTS compatibility */}
      {/* @ts-expect-error webkit-playsinline is a non-standard Safari attribute */}
      <audio ref={audioElementRef} playsInline webkit-playsinline="true" preload="none" style={{ display: "none" }} />

      {/* Universal-capture confirm modal(s) — agenda + nutrition (voice path);
          new modules join as their handlers register. The hook owns open/close
          + the re-emit guard cleanup that used to live inline here. */}
      {capture.modal}
      <GoalActionModal open={!!recoveredGoalPrefill && activeSessionIdRef.current === recoveredGoalPrefill.expected_session_id && actionResultStreamRef.current.ownerId === recoveredGoalPrefill.expected_user_id}
        prefill={recoveredGoalPrefill} onClose={() => setRecoveredGoalPrefill(null)} onCreated={receipt => acknowledgeCapture("propose_goal_action", receipt) ?? Promise.resolve(false)} />
      <TaskActionModal open={!!recoveredTaskPrefill && activeSessionIdRef.current === recoveredTaskPrefill.expected_session_id && actionResultStreamRef.current.ownerId === recoveredTaskPrefill.expected_user_id}
        prefill={recoveredTaskPrefill} onClose={() => setRecoveredTaskPrefill(null)} onCreated={receipt => acknowledgeCapture("propose_local_task_action", receipt) ?? Promise.resolve(false)} />
      <NoteActionModal open={!!recoveredNotePrefill && activeSessionIdRef.current === recoveredNotePrefill.expected_session_id && actionResultStreamRef.current.ownerId === recoveredNotePrefill.expected_user_id}
        prefill={recoveredNotePrefill} onClose={() => setRecoveredNotePrefill(null)} onCreated={receipt => acknowledgeCapture(recoveredNotePrefill?.brain_kind ? "propose_brain_note_action" : "propose_note_action", receipt) ?? Promise.resolve(false)} />
      <HabitActionModal open={!!recoveredHabitPrefill && activeSessionIdRef.current === recoveredHabitPrefill.expected_session_id && actionResultStreamRef.current.ownerId === recoveredHabitPrefill.expected_user_id}
        prefill={recoveredHabitPrefill} onClose={() => setRecoveredHabitPrefill(null)} onCreated={receipt => acknowledgeCapture("propose_habit_action", receipt) ?? Promise.resolve(false)} />
      <BodyHealthActionModal open={!!recoveredBodyHealthPrefill && activeSessionIdRef.current === recoveredBodyHealthPrefill.expected_session_id && actionResultStreamRef.current.ownerId === recoveredBodyHealthPrefill.expected_user_id}
        prefill={recoveredBodyHealthPrefill} onClose={() => setRecoveredBodyHealthPrefill(null)} onCreated={receipt => acknowledgeCapture("propose_body_health_action", receipt) ?? Promise.resolve(false)} />
      <NutritionMealActionModal open={!!nutritionMealPrefill && activeSessionIdRef.current === nutritionMealPrefill.expected_session_id && actionResultStreamRef.current.ownerId === nutritionMealPrefill.expected_user_id}
        prefill={nutritionMealPrefill} isCurrent={() => !!nutritionMealActor.current && nutritionMealActor.current.operation_id === nutritionMealPrefill?.operation_id && nutritionMealActor.current.isCurrent()}
        onClose={() => { setNutritionMealPrefill(null); nutritionMealActor.current = null; }} onCreated={publishNutritionMealReceipt} />
      <NutritionHydrationActionModal open={!!nutritionHydrationPrefill && activeSessionIdRef.current === nutritionHydrationPrefill.expected_session_id && actionResultStreamRef.current.ownerId === nutritionHydrationPrefill.expected_user_id}
        prefill={nutritionHydrationPrefill} isCurrent={() => !!nutritionHydrationActor.current && nutritionHydrationActor.current.operation_id === nutritionHydrationPrefill?.operation_id && nutritionHydrationActor.current.isCurrent()}
        onClose={() => { setNutritionHydrationPrefill(null); nutritionHydrationActor.current = null; }} onCreated={publishNutritionHydrationReceipt} />
      <LanguageActionModal open={!!languagePrefill && activeSessionIdRef.current === languagePrefill.expected_session_id && actionResultStreamRef.current.ownerId === languagePrefill.expected_user_id}
        prefill={languagePrefill} isCurrent={() => !!languageActor.current && languageActor.current.operation_id === languagePrefill?.operation_id && languageActor.current.isCurrent()}
        onClose={() => { setLanguagePrefill(null); languageActor.current = null; }} onCreated={async (receipt, current) => matchesMirrorLanguageReceiptOrigin(receipt, { userId: receipt.userId, sessionId: activeSessionIdRef.current ?? '', actionId: receipt.action_id }) ? publishLanguageReceipt(receipt, current) : false} />
      <LanguageClassActionModal open={!!languageClassPrefill && activeSessionIdRef.current === languageClassPrefill.expected_session_id && actionResultStreamRef.current.ownerId === languageClassPrefill.expected_user_id}
        prefill={languageClassPrefill} isCurrent={() => !!languageClassActor.current && languageClassActor.current.operation_id === languageClassPrefill?.operation_id && languageClassActor.current.isCurrent()}
        onClose={() => { setLanguageClassPrefill(null); languageClassActor.current = null; }} onCreated={async (receipt, current) => matchesMirrorLanguageClassReceiptOrigin(receipt, { userId: receipt.userId, sessionId: activeSessionIdRef.current ?? '', actionId: receipt.action_id }) ? publishLanguageClassReceipt(receipt, current) : false} />
      {languageTutorPrefill && <LanguageTutorHandoffDialog open={activeSessionIdRef.current === languageTutorPrefill.expected_session_id && actionResultStreamRef.current.ownerId === languageTutorPrefill.expected_user_id}
        {...languageTutorPrefill} isCurrent={() => MIRROR_LANGUAGE_TUTOR_HANDOFF_ENABLED && !!languageTutorActor.current && languageTutorActor.current.action_id === languageTutorPrefill.action_id && languageTutorActor.current.isCurrent()}
        onClose={() => { setLanguageTutorPrefill(null); languageTutorActor.current = null; }} />}
      <BrainHandoffModal open={!!brainHandoffPrefill && activeSessionIdRef.current === brainHandoffPrefill.expected_session_id && actionResultStreamRef.current.ownerId === brainHandoffPrefill.expected_user_id}
        prefill={brainHandoffPrefill} isCurrent={() => !!brainHandoffActor.current && brainHandoffActor.current.action_id === brainHandoffPrefill?.action_id && brainHandoffActor.current.isCurrent()}
        onClose={() => { setBrainHandoffPrefill(null); brainHandoffActor.current = null; }} />
      <NutritionGoalsActionModal open={!!nutritionGoalsPrefill && activeSessionIdRef.current === nutritionGoalsPrefill.expected_session_id && actionResultStreamRef.current.ownerId === nutritionGoalsPrefill.expected_user_id}
        prefill={nutritionGoalsPrefill} isCurrent={() => !!nutritionGoalsActor.current && nutritionGoalsActor.current.operation_id === nutritionGoalsPrefill?.operation_id && nutritionGoalsActor.current.isCurrent()}
        onClose={() => { setNutritionGoalsPrefill(null); nutritionGoalsActor.current = null; }} onCreated={publishNutritionGoalsReceipt} />
      <FitnessCuratedPlanModal open={!!fitnessCuratedPlanPrefill && activeSessionIdRef.current === fitnessCuratedPlanPrefill.expected_session_id && actionResultStreamRef.current.ownerId === fitnessCuratedPlanPrefill.expected_user_id}
        prefill={fitnessCuratedPlanPrefill} isCurrent={() => !!fitnessCuratedPlanActor.current && fitnessCuratedPlanActor.current.action_id === fitnessCuratedPlanPrefill?.action_id && fitnessCuratedPlanActor.current.isCurrent()}
        onClose={() => { setFitnessCuratedPlanPrefill(null); fitnessCuratedPlanActor.current = null; }} onCreated={publishFitnessCuratedPlanReceipt} />
      <FitnessActionModal open={!!recoveredFitnessPrefill && activeSessionIdRef.current === recoveredFitnessPrefill.expected_session_id && actionResultStreamRef.current.ownerId === recoveredFitnessPrefill.expected_user_id}
        isCurrent={(() => {
          const state = actionResultStreamRef.current, authEpoch = state.authEpoch, sessionEpoch = state.sessionEpoch;
          const ownerId = recoveredFitnessPrefill?.expected_user_id, originalSession = recoveredFitnessPrefill?.expected_session_id;
          return () => state.mounted && !state.sessionTransition && state.ownerId === ownerId && state.authEpoch === authEpoch && state.sessionEpoch === sessionEpoch && activeSessionIdRef.current === originalSession;
        })()}
        prefill={recoveredFitnessPrefill} onClose={() => setRecoveredFitnessPrefill(null)} onCreated={receipt => acknowledgeCapture("propose_fitness_action", receipt) ?? Promise.resolve(false)} />
      <FinanceActionModal open={!!recoveredFinance} prefill={recoveredFinance?.prefill??null} isCurrent={recoveredFinance?.isCurrent??(()=>false)}
        onClose={()=>setRecoveredFinance(null)} onCreated={async(receipt,current)=>!!recoveredFinance&&current()&&recoveredFinance.isCurrent()
          &&receipt.operation_id===recoveredFinance.prefill.operation_id&&matchesMirrorFinanceReceiptOrigin(receipt,{userId:recoveredFinance.prefill.expected_user_id,sessionId:recoveredFinance.prefill.expected_session_id??'',actionId:recoveredFinance.prefill.action_id})
          &&await acknowledgeCapture('propose_finance_action',receipt)===true} />
      <FitnessDraftDiscardModal prefill={fitnessDraftDiscardPrefill} onClose={() => setFitnessDraftDiscardPrefill(null)} onLocalReceipt={publishLocalDraftReceipt} />
      <FitnessRuntimeActionModal prefill={fitnessRuntimePrefill} onClose={() => setFitnessRuntimePrefill(null)} onLocalReceipt={publishLocalRuntimeReceipt} />
      <FitnessDraftRestoreModal prefill={fitnessDraftRestorePrefill} onClose={() => setFitnessDraftRestorePrefill(null)} onLocalReceipt={publishLocalRestoreReceipt} />
      <FitnessWorkoutFinishModal prefill={fitnessWorkoutFinishPrefill} onClose={() => setFitnessWorkoutFinishPrefill(null)} onSavedReceipt={publishSavedWorkoutFinishReceipt} />
      <FitnessSavedPlanPrepareModal prefill={fitnessSavedPlanPreparePrefill} onClose={() => setFitnessSavedPlanPreparePrefill(null)} onLocalReceipt={publishLocalSavedPlanPrepareReceipt} />
      <FitnessRestSkipModal prefill={fitnessRestSkipPrefill} onClose={() => setFitnessRestSkipPrefill(null)} onLocalReceipt={publishLocalRestSkipReceipt} />
      <FitnessCurrentSetCompletionModal prefill={fitnessCurrentSetCompletionPrefill} onClose={() => setFitnessCurrentSetCompletionPrefill(null)} onLocalReceipt={publishLocalSetCompletionReceipt} />
      <FitnessSetupStartModal prefill={fitnessSetupStartPrefill} onClose={() => setFitnessSetupStartPrefill(null)} onLocalReceipt={publishLocalSetupStartReceipt} />
      <FitnessCurrentSetEditModal prefill={fitnessCurrentSetEditPrefill} onClose={() => setFitnessCurrentSetEditPrefill(null)} onLocalReceipt={publishLocalSetEditReceipt} />
      <SleepActionModal open={!!recoveredSleepPrefill && activeSessionIdRef.current === recoveredSleepPrefill.expected_session_id && actionResultStreamRef.current.ownerId === recoveredSleepPrefill.expected_user_id}
        prefill={recoveredSleepPrefill} onClose={() => setRecoveredSleepPrefill(null)} onCreated={receipt => acknowledgeCapture("propose_sleep_action", receipt) ?? Promise.resolve(false)} />
      <CheckinActionModal open={!!recoveredCheckinPrefill && activeSessionIdRef.current === recoveredCheckinPrefill.expected_session_id && actionResultStreamRef.current.ownerId === recoveredCheckinPrefill.expected_user_id}
        prefill={recoveredCheckinPrefill} onClose={() => setRecoveredCheckinPrefill(null)} onCreated={receipt => acknowledgeCapture("propose_checkin_action", receipt) ?? Promise.resolve(false)} />
      <FocusActionModal open={!!recoveredFocusPrefill && activeSessionIdRef.current === recoveredFocusPrefill.expected_session_id && actionResultStreamRef.current.ownerId === recoveredFocusPrefill.expected_user_id}
        prefill={recoveredFocusPrefill} onClose={() => setRecoveredFocusPrefill(null)} onCreated={receipt => acknowledgeCapture("propose_focus_action", receipt) ?? Promise.resolve(false)} />
      <LocalReminderActionModal open={!!recoveredReminderPrefill && activeSessionIdRef.current === recoveredReminderPrefill.expected_session_id && actionResultStreamRef.current.ownerId === recoveredReminderPrefill.expected_user_id}
        prefill={recoveredReminderPrefill} onClose={() => setRecoveredReminderPrefill(null)} onCreated={receipt => acknowledgeCapture("propose_reminder_action", receipt) ?? Promise.resolve(false)} />
      <LocalAgendaActionModal open={!!recoveredAgendaPrefill && activeSessionIdRef.current === recoveredAgendaPrefill.expected_session_id && actionResultStreamRef.current.ownerId === recoveredAgendaPrefill.expected_user_id}
        prefill={recoveredAgendaPrefill} onClose={() => setRecoveredAgendaPrefill(null)} onCreated={receipt => acknowledgeCapture("propose_local_agenda_action", receipt) ?? Promise.resolve(false)} />

      {/* Nutrition PHOTO path — same NutritionLogModal as the voice flow, but
          opened by the camera attach button with a photo-derived prefill. */}
      <NutritionLogModal
        open={!!photoPrefill}
        prefill={photoPrefill}
        onClose={() => setPhotoPrefill(null)}
        onCreated={() => setPhotoPrefill(null)}
      />

      {/* PR-A F2: viewer de imagem compartilhado (mesmo componente da
          Biblioteca), aberto pela thumbnail inline da bolha. */}
      <DeliverableImageViewer target={imageView} onClose={() => setImageView(null)} />

      {/* P2: menu multitarefa do compositor — bottom-sheet vaul (precedente
          QuickTaskModal/MiniMirrors). Item ATIVO = prefill no input + fecha
          (onCloseAutoFocus preventDefault: o foco fica no INPUT, não volta
          pro botão +); "Em breve" = tease de roadmap desabilitado, nunca
          botão morto clicável. */}
      <Drawer open={composerMenuOpen} onOpenChange={setComposerMenuOpen}>
        <DrawerContent
          className="rounded-t-3xl"
          style={{
            background: "linear-gradient(135deg, #0a0e1a 0%, #0f1419 50%, #0a0e1a 100%)",
            border: "none",
          }}
          onCloseAutoFocus={(e) => e.preventDefault()}
        >
          <DrawerHeader className="pb-2">
            <DrawerTitle className="text-white text-base font-display tracking-wide uppercase">
              {t("mirror.composerMenu.title")}
            </DrawerTitle>
          </DrawerHeader>
          <div
            className="px-4 space-y-1.5"
            style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 16px) + 16px)" }}
          >
            {COMPOSER_MENU_ITEMS.map((item) =>
              item.disabled ? (
                <div
                  key={item.id}
                  aria-disabled="true"
                  className="flex items-center gap-3 px-3 py-3 rounded-xl opacity-45 select-none"
                  style={{ background: "hsl(222 18% 12%)", border: "1px solid hsl(222 18% 18%)" }}
                >
                  <span className="text-[18px] leading-none">{item.emoji}</span>
                  <span className="flex-1 text-[13px] font-display font-medium text-foreground/80 text-left">
                    {t(item.labelKey)}
                  </span>
                  <span
                    className="text-[10px] font-display tracking-wide px-2 py-0.5 rounded-full"
                    style={{
                      background: "hsl(222 18% 18%)",
                      color: "hsl(218 14% 62%)",
                      border: "1px solid hsl(222 18% 24%)",
                    }}
                  >
                    {t("mirror.composerMenu.soon")}
                  </span>
                </div>
              ) : (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => {
                    analytics.mirrorComposerAction(item.id);
                    // ORDEM IMPORTA para `action`: o .click() no <input> tem de
                    // sair DENTRO do gesto do usuário. Fechar o Drawer antes
                    // quebra a cadeia de user-gesture no iOS Safari e o seletor
                    // de arquivos simplesmente não abre — falha silenciosa, sem
                    // erro, exatamente a classe de bug que já custou esta
                    // feature uma vez.
                    if (item.action === "attachFile") {
                      attachInputRef.current?.click();
                    } else if (item.action === "mealPhoto") {
                      photoInputRef.current?.click();
                    }
                    setComposerMenuOpen(false);
                    if (item.route) {
                      navigate(item.route);
                    } else if (item.sendKey) {
                      // Ajuste A: ENVIA a semente → o Espelho pergunta o assunto.
                      sendMessage(t(item.sendKey));
                    }
                  }}
                  className="w-full flex items-center gap-3 px-3 py-3 rounded-xl transition-all active:scale-[0.99] hover:bg-primary/10"
                  style={{ background: "hsl(222 18% 12%)", border: "1px solid hsl(222 18% 18%)" }}
                >
                  <span className="text-[18px] leading-none">{item.emoji}</span>
                  <span className="flex-1 text-[13px] font-display font-medium text-foreground/90 text-left">
                    {t(item.labelKey)}
                  </span>
                </button>
              )
            )}
          </div>
        </DrawerContent>
      </Drawer>
    </div>
  );
};

export default MirrorChat;
